/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Activities {
  activities: Activity[]
  total?: number
}

export interface Activity {
  activity_type:
    | 'LearnpathActivated'
    | 'LearnpathAssignedToLearner'
    | 'LearnpathReactivatedForLearner'
    | 'LearnpathAssignedToLearnerForManager'
    | 'MembersAddedToActiveLearnpath'
    | 'GamificationAwardGranted'
  /** @format uuid */
  entity_id: string
  entity_type: string
  /** @format uuid */
  id: string
  payload: Record<string, any>
  /** @format date-time */
  timestamp: string
}

export interface AnnouncementsChannel {
  progress?: ChannelProgress
  title?: string
  topics?: ChannelTopicsOneOf[]
}

export interface AnnouncementsChannelGetNotFound {
  message?: 'channel.error.no-announcements-channel-found'
}

export interface ApplicationVersionCheck {
  supported: boolean
}

export interface AssessmentDeleteInternalServerError {
  message?: 'skills.error.skill-assessment-reset-error'
}

export interface AssessmentInfo {
  num_completed_steps: number
}

export interface AssignedCurrentLearnpath {
  /** @format uuid */
  id: string
  is_course: boolean
  mandatory: boolean
  name: string
  /** @format url */
  thumbnail_url: string | null
}

export interface AssignedLearnpath {
  /** @format date */
  complete_until: string | null
  contact_people: ContactPerson[] | null
  default_lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  description: string | null
  duration: number
  elements?: AssignedLearnpathElementOneOf[]
  /** @format uuid */
  external_id: string
  /** @format uuid */
  id: string
  is_course: boolean
  issue_completion_certificate: boolean
  lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  linear: boolean
  mandatory: boolean
  name: string
  points: number | null
  progress: AssignedLearnpathProgress
  /** @format date-time */
  recurring_date: string | null
  recurring_frequency: 'daily' | 'weekly' | 'yearly' | null
  recurring_interval: number | null
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  thumbnail_url: string | null
  validity: Validity
}

export interface AssignedLearnpathElementGetForbidden {
  message?: 'learnpath.error.learnpath-element-not-unlocked'
}

export interface AssignedLearnpathElementGetNotFound {
  message?: 'learnpath.error.learnpath-element-not-found'
}

export interface AssignedLearnpathElementGetUnprocessableContent {
  message?: 'learnpath.error.learnpath-is-not-active'
}

export type AssignedLearnpathElementOneOf =
  | ({
      type: 'embedded_video'
    } & AssignedLearnpathEmbeddedVideoElement)
  | ({
      type: 'event'
    } & AssignedLearnpathEventElement)
  | ({
      type: 'file'
    } & AssignedLearnpathFileElement)
  | ({
      type: 'link'
    } & AssignedLearnpathLinkElement)
  | ({
      type: 'platform_topic'
    } & AssignedLearnpathPlatformTopicElement)
  | ({
      type: 'quiz'
    } & AssignedLearnpathQuizElement)
  | ({
      type: 'scorm'
    } & AssignedLearnpathScormElement)
  | ({
      type: 'text'
    } & AssignedLearnpathTextElement)
  | ({
      type: 'video'
    } & AssignedLearnpathVideoElement)

export interface AssignedLearnpathElementProgress {
  meta: object | null
  status: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
}

export interface AssignedLearnpathElementProgressPutForbidden {
  message?: 'learnpath.error.learnpath-element-not-unlocked'
}

export interface AssignedLearnpathElementProgressPutNotFound {
  message?: 'learnpath.error.learnpath-element-not-found'
}

export interface AssignedLearnpathElementProgressPutRequest {
  meta?: object | null
  status?: string
}

export interface AssignedLearnpathElementProgressPutUnprocessableContent {
  message?: 'learnpath.error.learnpath-is-not-active'
}

export interface AssignedLearnpathEmbeddedVideoElement {
  description: string | null
  duration: number
  /** @format uuid */
  id: string
  order: number
  playable: boolean
  progress: AssignedLearnpathElementProgress
  provider: 'youtube'
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  thumbnail_url: string | null
  title: string
  type: string
  video_id: string
}

export interface AssignedLearnpathEventElement {
  address: string | null
  description: string | null
  duration: number
  /** @format date-time */
  ends_at: string
  event_type: string
  /** @format uuid */
  id: string
  /** @format url */
  link: string | null
  order: number
  progress: AssignedLearnpathElementProgress
  /** @format date-time */
  starts_at: string
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  thumbnail_url: string | null
  timezone: string
  title: string
  type: string
}

export interface AssignedLearnpathFileElement {
  description: string | null
  downloadable: boolean
  duration: number
  /** @format url */
  file_url: string | null
  filename: string
  filesize: number
  /** @format uuid */
  id: string
  learning_objectives: (string | null)[]
  order: number
  progress: AssignedLearnpathElementProgress
  tags: (string | null)[]
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  thumbnail_url: string | null
  title: string
  type: string
}

export interface AssignedLearnpathGetNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface AssignedLearnpathGetUnprocessableContent {
  message?: 'learnpath.error.learnpath-is-not-active'
}

export interface AssignedLearnpathLanguage {
  is_current: boolean
  is_default: boolean
  lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
}

export interface AssignedLearnpathLanguages {
  languages: AssignedLearnpathLanguage[]
}

export interface AssignedLearnpathLanguagesGetNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface AssignedLearnpathLinkElement {
  description: string | null
  duration: number
  /** @format uuid */
  id: string
  learning_objectives: (string | null)[]
  order: number
  progress: AssignedLearnpathElementProgress
  tags: (string | null)[]
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  thumbnail_url: string | null
  title: string
  type: string
  /** @format url */
  url: string
}

export interface AssignedLearnpathPlatformTopicElement {
  duration: number
  /** @format uuid */
  id: string
  order: number
  progress: AssignedLearnpathElementProgress
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  thumbnail_url: string | null
  topic: AssignedPlatformTopic
  type: string
}

export interface AssignedLearnpathProgress {
  complete_in: number | null
  /** @format date-time */
  completion_confirmed_at: string | null
  /** @format date-time */
  deadline_timestamp: string | null
  num_elements: number
  num_elements_completed: number
  num_items: number
  num_items_completed: number
  remaining_time: number | null
}

export interface AssignedLearnpathQuizElement {
  attempts: number | null
  duration: number
  /** @format uuid */
  id: string
  order: number
  progress: AssignedLearnpathElementProgress
  questions: AssignedLearnpathQuizQuestion[]
  threshold: number | null
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  thumbnail_url: string | null
  type: string
}

export interface AssignedLearnpathQuizElementCheckQuestion {
  selected_answers: AssignedLearnpathQuizElementCheckQuestionSelectedAnswer[]
  solved: boolean
}

export interface AssignedLearnpathQuizElementCheckQuestionPostNotFound {
  message?: 'learnpath.error.learnpath-element-not-found'
}

export interface AssignedLearnpathQuizElementCheckQuestionPostRequest {
  answer: number[]
}

export interface AssignedLearnpathQuizElementCheckQuestionPostUnprocessableContent {
  message?: 'learnpath.error.learnpath-is-not-active'
}

export interface AssignedLearnpathQuizElementCheckQuestionSelectedAnswer {
  correct: boolean
  id: number
}

export interface AssignedLearnpathQuizQuestion {
  answers: AssignedLearnpathQuizQuestionAnswer[]
  /** @format uuid */
  id: string
  solved: boolean
  text: string
  type: 'single_choice' | 'multiple_choice'
}

export interface AssignedLearnpathQuizQuestionAnswer {
  correct: boolean
  /** @format uuid */
  id: string
  text: string
}

export interface AssignedLearnpathScormElement {
  completion_trigger: boolean
  description: string | null
  duration: number
  /** @format uuid */
  id: string
  order: number
  progress: AssignedLearnpathElementProgress
  scorm_package: LearnpathScormPackage
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  thumbnail_url: string | null
  title: string | null
  type: string
}

export interface AssignedLearnpathSetLanguagePostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface AssignedLearnpathSetLanguagePostUnprocessableContent {
  message?: 'learnpath.error.learnpath-learner-language-unavailable'
}

export interface AssignedLearnpathSetLanguageRequest {
  lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
}

export interface AssignedLearnpathSetLanguageResponse {
  lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
}

export interface AssignedLearnpathTextElement {
  body: string
  description: string | null
  duration: number
  /** @format uuid */
  id: string
  learning_objectives: (string | null)[]
  order: number
  progress: AssignedLearnpathElementProgress
  tags: (string | null)[]
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  thumbnail_url: string | null
  title: string
  type: string
}

export interface AssignedLearnpathVideoElement {
  description: string | null
  duration: number
  /** @format uuid */
  id: string
  learning_objectives: (string | null)[]
  order: number
  progress: AssignedLearnpathElementProgress
  tags: (string | null)[]
  thumbnail_id: string | null
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  thumbnail_url: string | null
  title: string
  type: string
  video_source: string | null
  /** @format url */
  video_url: string | null
}

export interface AssignedLearnpaths {
  learnpaths: AssignedLearnpath[]
}

export interface AssignedPlatformLecture {
  duration: number
  image_id: string
  order: number
  progress: AssignedPlatformLectureProgress
  short_description: string
  slug: string
  title: string
  type: 'video' | 'text' | 'chatbot' | 'scorm'
  /** @format uuid */
  uid: string
}

export interface AssignedPlatformLectureProgress {
  meta: object | null
  status: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
}

export interface AssignedPlatformTopic {
  author: PlatformAuthor | null
  background_color_1: string | null
  background_color_2: string | null
  background_image_id: string | null
  captions_langs: string[] | null
  difficulty: number | null
  excerpt: string
  id: number
  image_id: string | null
  lectures: AssignedPlatformLecture[]
  locales: (string | null)[]
  max_score: number
  num_lectures: number
  original_lang: string[] | null
  poster_image_id: string | null
  poster_image_mobile_id: string | null
  slug: string
  title: string
  voiceover_langs: string[] | null
}

export interface AssignedUpcomingEvent {
  /** @format uuid */
  element_id: string
  /** @format uuid */
  learnpath_id: string
  /** @format date-time */
  starts_at: string
  title: string
}

export interface AssignedUserGroups {
  user_groups: UserGroupReference[]
}

export interface AttendingGroup {
  attending_count?: number
  /** @format uuid */
  id: string | null
  learners_count: number
  name: string
}

export interface AttendingLearner {
  attended: boolean
  /** @format email */
  email: string
  first_name: string
  groups: string[]
  /** @format uuid */
  id: string
  last_name: string
}

export interface AudioInputTranscription {
  language: string
  model: string
  prompt: string
}

export interface Author {
  company_name?: string
  fullname?: string
  image_id?: string
}

export interface AwardScores {
  bronze?: number
  gold?: number
  silver?: number
}

export interface BadgesActivityListItem {
  has_unclaimed_awards: boolean
  /** @format uuid */
  id: string
  /** @default null */
  image?: string | null
  /** @default null */
  instruction?: string | null
  name: string
  priority: number
  times_achieved: number
  unlocked: boolean
}

export interface BadgesAwardGroupsList {
  badges: BadgesAwardGroupsListItem[]
}

export interface BadgesAwardGroupsListItem {
  activities: BadgesActivityListItem[]
  category: string
  first_name?: string
  granting_type: string
  /** @format uuid */
  id: string
  name: string
}

export interface BaseSkill {
  color: string
  /** @format uuid */
  id: string
  image_id: string | null
  name: string
  slug: string
  video_id: string | null
}

export interface BaseUser {
  can_be_deleted_by_caller: boolean
  can_be_managed_by_caller: boolean
  /** @format uuid */
  company_id: string
  /** @format uuid */
  global_user_id: string
  /** @format uuid */
  id: string
  is_no_email_user: boolean
  status: 'active' | 'pending' | 'deactivated'
  user_identity: BaseUserIdentity
}

export interface BaseUserIdentity {
  /** @format email */
  email: string | null
  first_name: string | null
  last_name: string | null
  no_email_user_id: string | null
}

export interface BatchOperationFile {
  filename: string
  /** @format uuid */
  id: string
  num_failed_entries: number
  num_success_entries: number
  num_total_entries: number
  operation:
    | 'user_import'
    | 'user_edit'
    | 'user_deactivation'
    | 'user_reactivation'
    | 'user_group_assignment'
    | 'license_provider_change'
    | 'department_assignment'
  status:
    | 'pending'
    | 'failed'
    | 'parsing'
    | 'parsed'
    | 'processing'
    | 'completed'
  /** @format date */
  upload_date: string
  uploaded_by: string | null
}

export interface BatchOperationFileErrorsGetConflict {
  message?: 'batch-operations.error.batch-operation-file-not-completed'
}

export interface BatchOperationFileErrorsGetForbidden {
  message?: 'api.error.forbidden'
}

export interface BatchOperationFileErrorsGetNotFound {
  message?: 'batch-operations.error.batch-operation-file-not-found'
}

export interface BatchOperationFileHistory {
  batch_operation_files: BatchOperationFile[]
  total_files: number
}

export interface BatchOperationFileHistoryGetForbidden {
  message?: 'api.error.forbidden'
}

export interface BatchOperationFileStatus {
  status:
    | 'pending'
    | 'failed'
    | 'parsing'
    | 'parsed'
    | 'processing'
    | 'completed'
}

export interface BatchOperationFileUploaded {
  /** @format uuid */
  batch_operation_file_id: string
}

export interface BatchOperationsDepartmentAssignmentPostContentTooLarge {
  message?: 'user.error.batch-operation-file-maximum-size-exceeded'
}

export interface BatchOperationsDepartmentAssignmentPostForbidden {
  message?: 'api.error.forbidden'
}

export interface BatchOperationsDepartmentAssignmentPostUnprocessableContent {
  message?: 'user.error.batch-operation-file-format-not-supported'
}

export interface BatchOperationsLicenseProviderChangePostContentTooLarge {
  message?: 'user.error.batch-operation-file-maximum-size-exceeded'
}

export interface BatchOperationsLicenseProviderChangePostForbidden {
  message?: 'api.error.forbidden'
}

export interface BatchOperationsLicenseProviderChangePostUnprocessableContent {
  message?: 'user.error.batch-operation-file-format-not-supported'
}

export interface BatchOperationsUserDeactivationPostContentTooLarge {
  message?: 'user.error.batch-operation-file-maximum-size-exceeded'
}

export interface BatchOperationsUserDeactivationPostForbidden {
  message?: 'api.error.forbidden'
}

export interface BatchOperationsUserDeactivationPostUnprocessableContent {
  message?: 'user.error.batch-operation-file-format-not-supported'
}

export interface BatchOperationsUserEditPostContentTooLarge {
  message?: 'user.error.batch-operation-file-maximum-size-exceeded'
}

export interface BatchOperationsUserEditPostForbidden {
  message?: 'api.error.forbidden'
}

export interface BatchOperationsUserEditPostUnprocessableContent {
  message?: 'user.error.batch-operation-file-format-not-supported'
}

export interface BatchOperationsUserGroupAssignmentPostContentTooLarge {
  message?: 'user.error.batch-operation-file-maximum-size-exceeded'
}

export interface BatchOperationsUserGroupAssignmentPostForbidden {
  message?: 'api.error.forbidden'
}

export interface BatchOperationsUserGroupAssignmentPostUnprocessableContent {
  message?: 'user.error.batch-operation-file-format-not-supported'
}

export interface BatchOperationsUserReactivationPostContentTooLarge {
  message?: 'user.error.batch-operation-file-maximum-size-exceeded'
}

export interface BatchOperationsUserReactivationPostForbidden {
  message?: 'api.error.forbidden'
}

export interface BatchOperationsUserReactivationPostUnprocessableContent {
  message?: 'user.error.batch-operation-file-format-not-supported'
}

export interface Bookmark {
  /** @format date-time */
  created?: string
  icon?: string
  /** @format uuid */
  id?: string
  image?: string
  position?: number
  text?: string
  title?: string
  /** @format date-time */
  updated?: string
}

export interface BookmarkDeleteForbidden {
  message?: 'lecture.error.bookmark-invalid-id' | 'lecture.error.lecture-locked'
}

export interface BookmarkDeleteNotFound {
  message?:
    | 'lecture.error.bookmark-not-found'
    | 'lecture.error.lecture-not-found'
}

export interface BookmarkDownloadPostRequest {
  content: string
}

export interface BookmarkGetForbidden {
  message?: 'lecture.error.bookmark-invalid-id' | 'lecture.error.lecture-locked'
}

export interface BookmarkGetNotFound {
  message?:
    | 'lecture.error.bookmark-not-found'
    | 'lecture.error.lecture-not-found'
}

export interface BookmarkPutForbidden {
  message?: 'lecture.error.bookmark-invalid-id' | 'lecture.error.lecture-locked'
}

export interface BookmarkPutNotFound {
  message?:
    | 'lecture.error.bookmark-not-found'
    | 'lecture.error.lecture-not-found'
}

export interface BookmarkPutRequest {
  icon?: 'definition' | 'highlight' | 'video'
  image?: string | null
  position?: number | null
  text?: string | null
  title?: string
}

export interface BookmarkedLectureProgress {
  status?: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
}

export interface BookmarkedLectures {
  lectures?: BookmarkedLecturesItem[]
}

export interface BookmarkedLecturesItem {
  image_id?: string
  progress?: BookmarkedLectureProgress
  short_description?: string
  slug?: string
  title?: string
  topic?: BookmarkedLectures
  /** @format uuid */
  uid?: string
}

export interface BookmarkedLecturesPostRequest {
  /** @minItems 1 */
  lectures_uids: string[]
}

export interface Bookmarks {
  num_bookmarks?: number
  topics?: BookmarksTopic[]
}

export interface BookmarksDownload {
  /** @format url */
  url?: string
}

export interface BookmarksDownloadGetNotFound {
  message?:
    | 'bookmark.error.user-bookmarks-download-not-available'
    | 'bookmark.error.user-bookmarks-download-not-found'
    | 'bookmark.error.user-bookmarks-download-not-up-to-date'
}

export interface BookmarksDownloadPostConflict {
  message?: 'bookmark.error.user-bookmarks-download-already-created'
}

export interface BookmarksDownloadPostForbidden {
  message?: 'bookmark.error.user-bookmarks-download-already-requested'
}

export interface BookmarksGetForbidden {
  message?: 'lecture.error.lecture-locked'
}

export interface BookmarksGetNotFound {
  message?: 'lecture.error.lecture-not-found'
}

export interface BookmarksItem {
  /** @format date-time */
  created?: string
  icon?: string
  /** @format uuid */
  id?: string
  image?: string
  position?: number
  text?: string
  title?: string
  /** @format date-time */
  updated?: string
}

export interface BookmarksLecture {
  bookmarks?: BookmarksItem[]
  order?: number
  slug?: string
  title?: string
  type?: 'video' | 'text' | 'chatbot' | 'scorm'
}

export interface BookmarksPostForbidden {
  message?: 'lecture.error.lecture-locked'
}

export interface BookmarksPostNotFound {
  message?: 'lecture.error.lecture-not-found'
}

export interface BookmarksPostRequest {
  icon: 'definition' | 'highlight' | 'video'
  image?: string | null
  position?: number | null
  text?: string | null
  title: string
}

export interface BookmarksTopic {
  author?: BookmarksTopicAuthor
  color?: string
  lectures?: BookmarksLecture[]
  num_bookmarks?: number
  poster_image_id?: string
  poster_image_mobile_id?: string
  slug?: string
  title?: string
}

export interface BookmarksTopicAuthor {
  company_name?: string
  fullname?: string
  image_id?: string
}

export interface BoolPollQuestion {
  false_label?: string
  /** @format uuid */
  id?: string
  optional?: boolean
  optional_label?: string
  order?: number
  text?: string
  true_label?: string
  type?: string
}

export interface CertificateListItem {
  /**
   * The date the certificate was issued.
   * @format date
   */
  created?: string
  /** Variables required by the PDF template, can also hold an additional unrevealed info. */
  data?: Record<string, any>
  /**
   * Unique identifier of the certificate.
   * @format uuid
   */
  id?: string
  /** True if the certificate has been superseded (e.g. the user was transferred between companies or the related content changed). Still returned so the UI can show it as a past certificate while keeping it downloadable. */
  outdated?: boolean
  /** True if the UI should display a poll before certificate download. Legacy field, used specifically with fundamental course and certificate poll. If `poll_details` is non-null, it should be used instead. */
  poll?: boolean
  poll_details?: CertificatePollDetails
  /** Name of the template used to create a PDF file. */
  template?: string
}

export interface CertificateNotFoundResponse {
  message?: 'certificate.error.certificate-not-found'
}

export interface CertificatePollDetails {
  /** Indicates whether the poll has already been completed. */
  is_completed?: boolean
  /**
   * Unique identifier of the poll associated with the certificate.
   * @format uuid
   */
  poll_id?: string
}

export interface CertificatePollGetForbidden {
  message?: 'poll.error.course-not-completed'
}

export interface CertificatePollGetNotFound {
  message?: 'poll.error.poll-not-found'
}

export interface ChannelLockedTopic {
  captions_langs: string[] | null
  difficulty?: number
  duration?: any
  has_chatbot_lecture: boolean
  id: number
  image_id?: string
  locales?: string[]
  num_lectures?: number
  original_lang: string[] | null
  poster_image_id?: string
  poster_image_mobile_id?: string
  slug?: string
  title?: string
  voiceover_langs: string[] | null
}

export interface ChannelProgress {
  status?: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
}

export interface ChannelTopic {
  author?: Author
  average_rating?: number
  /** @format url */
  background_video_url?: string
  captions_langs: string[] | null
  difficulty?: number
  duration?: any
  has_chatbot_lecture: boolean
  id: number
  image_id?: string
  locales?: string[]
  num_lectures?: number
  original_lang: string[] | null
  poster_image_id?: string
  poster_image_mobile_id?: string
  progress?: ChannelTopicProgress
  slug?: string
  tags?: string[]
  title?: string
  voiceover_langs: string[] | null
}

export interface ChannelTopicProgress {
  /** @format date-time */
  completed_at?: string
  num_completed_lectures?: number
  status?: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
}

export type ChannelTopicsOneOf =
  | ({
      type: 'locked'
    } & ChannelLockedTopic)
  | ({
      type: 'other statuses'
    } & ChannelTopic)

export interface Channels {
  channels?: SingleChannel[]
}

export interface ChatbotLecturePostNotFound {
  message?: 'chatbot.error.chatbot-lecture-not-found'
}

export interface ChatbotLecturePostRequestBody {
  /**
   * @format uuid
   * @default null
   */
  conversation_id?: string | null
  /** @default null */
  message?: string | null
}

export interface ChatbotLecturePostTooManyRequests {
  message?: 'chatbot.error.llm-rate-limit-exceeded'
}

export interface ChatbotLecturePostUnauthorized {
  message?: 'chatbot.error.llm-authentication-failed'
}

export interface ChatbotLecturePostUnprocessableContent {
  message?: 'chatbot.error.content-flagged'
}

export interface ChatbotLectureSessionPostNotFound {
  message?: 'chatbot.error.chatbot-lecture-not-found'
}

export interface ChatbotLectureSessionPostTooManyRequests {
  message?: 'chatbot.error.llm-rate-limit-exceeded'
}

export interface ChatbotLectureSessionPostUnauthorized {
  message?: 'chatbot.error.llm-authentication-failed'
}

export interface ChoosePollQuestion {
  dropdown?: boolean
  /** @format uuid */
  id?: string
  many?: boolean
  optional?: boolean
  optional_label?: string
  options?: ChoosePollQuestionOption[]
  order?: number
  text?: string
  type?: string
}

export interface ChoosePollQuestionOption {
  color?: string
  description?: string
  /** @format uuid */
  id?: string
  image_id?: string
  text?: string
}

export interface Cmi5LaunchGetUnprocessableContent {
  message?: 'cmi5-launch.error.xapi-client-id-not-found'
}

export interface Company {
  background_image_id?: string
  color?: string
  default_platform_start_page:
    | 'homepage'
    | 'learning-paths-all'
    | 'learning-paths-mandatory'
    | 'learning-paths-active'
    | 'company-courses'
    | 'exclusive-content'
    | 'discovery-page'
    | 'company-space-overview'
    | 'company-space-learning-paths'
  email_domains?: string[]
  enable_stripe_management?: boolean
  extra_data: Record<string, any>
  /** @format uuid */
  id?: string
  is_user_signup_email_edit_disabled?: boolean
  logo_id?: string
  name?: string
  support_person?: SupportPerson
  unlimited?: boolean
}

export interface CompanyAuditLogRequestPost {
  /** @format date */
  from_date: string
  /** @format date */
  to_date: string
}

export interface CompanyAuditLogRequestPostForbidden {
  message?: 'api.error.forbidden'
}

export interface CompanyAuditLogRequestPostInternalServerError {
  message?: 'company.error.audit-log-request-notification-failed'
}

export interface CompanyAuditLogRequestPostUnprocessableContent {
  message?: 'company.error.audit-log-request-invalid-date-range'
}

export interface CompanyCoursesCompletionSummary {
  num_company_courses_assigned: number
  num_company_courses_completed: number
}

export interface CompanyDepartmentDeleteConflict {
  message?: 'company.error.department-has-users-assigned'
}

export interface CompanyDepartmentDeleteForbidden {
  message?: 'api.error.forbidden'
}

export interface CompanyDepartmentDeleteNotFound {
  message?: 'company.error.department-not-found'
}

export interface CompanyDepartmentPutNotFound {
  message?: 'company.error.department-not-found'
}

export interface CompanyDepartmentPutUnprocessableEntity {
  message?: 'company.error.department-already-exists'
}

export interface CompanyDepartmentsPostUnprocessableEntity {
  message?: 'company.error.department-already-exists'
}

export interface CompanyGetNotFound {
  message?: 'company.error.company-not-found'
}

export interface CompanyLicenseStructure {
  total_users: number
  users: CompanyLicenseStuctureUser[]
}

export interface CompanyLicenseStructureLicenseProvider {
  /** @format uuid */
  global_user_id: string
  /** @format uuid */
  id: string
  identity: CompanyLicenseStructureUserIdentity
  is_no_email_user: boolean
}

export interface CompanyLicenseStructureLicenses {
  available: number
  total: number
}

export interface CompanyLicenseStructureUserIdentity {
  email: string | null
  first_name: string | null
  last_name: string | null
  no_email_user_id: string | null
}

export interface CompanyLicenseStuctureUser {
  /** @format url */
  avatar_url: string | null
  department: Department | null
  /** @format uuid */
  global_user_id: string
  /** @format uuid */
  id: string
  identity: CompanyLicenseStructureUserIdentity
  /** @format date */
  invited_at: string
  is_no_email_user: boolean
  license_provider: CompanyLicenseStructureLicenseProvider | null
  licenses: CompanyLicenseStructureLicenses
  roles: (
    | 'admin'
    | 'owner'
    | 'company_administrator'
    | 'public_api_client'
    | 'manager'
    | 'content_creator'
    | 'student'
  )[]
  status: 'active' | 'pending' | 'deactivated'
}

export interface CompanyNotificationsSettingGetNotFound {
  message?: 'company.error.user-not-found' | 'company.error.company-not-found'
}

export interface CompanyNotificationsSettings {
  /** @format uuid */
  company_id: string
  gamification_settings?: GamificationNofificationsSettings
  learnpaths_settings?: LearnpathsNotificationsSettings
  suppress_notifications: boolean
}

export interface CompanyPostRequest {
  company_name: string
  features: string[]
  /** @min 0 */
  licenses: number
  /** @format email */
  owner_email: string
}

export interface CompanyPostUnprocessableContent {
  message?: 'company.error.company-with-given-name-exists'
}

export interface CompanyPutNotFound {
  message?: 'company.error.company-not-found'
}

export interface CompanyPutRequest {
  default_platform_start_page?:
    | 'homepage'
    | 'learning-paths-all'
    | 'learning-paths-mandatory'
    | 'learning-paths-active'
    | 'company-courses'
    | 'exclusive-content'
    | 'discovery-page'
    | 'company-space-overview'
    | 'company-space-learning-paths'
  is_user_signup_email_edit_disabled?: boolean
  logo_data?: string
}

export interface CompanyPutUnprocessableEntity {
  message?: 'company.error.logo-upload-error'
}

export interface CompanySSOIdPHint {
  idp_hint?: string
}

export interface ContactPerson {
  /** @format email */
  email: string
  fullname: string
  phone?: string | null
  position?: string | null
}

export interface ContentListUnprocessableEntity {
  message?: 'public_api.error.company-has-integration-conflict'
}

export interface CourseGetNotFound {
  message?: 'course.error.course-not-found'
}

export interface CoursePoll {
  is_completed?: boolean
  /** @format uuid */
  poll_id?: string
  text?: string
  title?: string
}

export interface CourseProgress {
  num_completed_lectures?: number
  status?: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
  total_score?: number
}

export interface CourseTopicAuthor {
  company_name?: string
  fullname?: string
  image_id?: string
}

export interface CourseTopicProgress {
  num_completed_lectures?: number
  status?: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
}

export interface CourseVersion {
  description: string
  duration: number
  lang: string
  launch_link: LaunchLink | null
  /** @format url */
  thumbnail_url: string
  title: string
}

export interface CurrentLecture {
  image_id?: string
  learning_objectives?: string[]
  progress?: LectureProgress
  slug?: string
  title?: string
  topic?: LectureTopic
  type?: 'video' | 'text' | 'chatbot' | 'scorm'
}

export interface CurrentSkill {
  color: string
  /** @format uuid */
  id: string
  image_id: string | null
  name: string
  progress: SkillProgress
  slug: string
  video_id: string | null
}

export interface CurrentSkillGetNotFound {
  message?: 'skills.error.current-skill-not-set'
}

export interface CurrentSkillPutNotFound {
  message?: 'skills.error.skill-not-found'
}

export interface CurrentSkillPutRequest {
  /** @format uuid */
  skill_id: string
}

export interface CurrentUser {
  /** @format url */
  avatar_url: string | null
  completed_fundamental: boolean
  current_skill_set: boolean
  department: Department | null
  email_pending_update: string | null
  extra_data: object | null
  features: string[]
  field_of_activity:
    | 'management'
    | 'procurement'
    | 'sales'
    | 'finance'
    | 'it'
    | 'business_intelligence'
    | 'customer_care'
    | 'logistics'
    | 'human_resources'
    | 'consulting'
    | 'coaching'
    | 'product_development'
    | 'graphic_design'
    | 'accounting'
    | 'legal'
    | 'administration'
    | 'marketing'
    | 'public_relations'
    | 'research_development'
    | 'quality_management'
    | 'editorial'
    | 'e_commerce'
    | 'production'
    | 'warehouse'
    | 'other'
    | null
  field_of_activity_custom: string | null
  /** @format uuid */
  global_user_id: string
  /** @format uuid */
  id: string
  identity?: UserIdentity
  interests: string[]
  lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt-br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  licenses?: Licenses
  permission_scopes: string[]
  roles: (
    | 'admin'
    | 'owner'
    | 'company_administrator'
    | 'public_api_client'
    | 'manager'
    | 'content_creator'
    | 'student'
  )[]
  scorm: boolean
  settings: UserSettings
}

export interface CurrentUserAvatarPut {
  avatar_data?: string | null
}

export interface CurrentUserAvatarPutInternalServerError {
  message?: 'user.error.avatar-upload-error'
}

export interface CurrentUserExtraDataPut {
  extra_data: Record<string, any>
}

export interface CurrentUserPut {
  /** @format date */
  date_of_birth?: string | null
  field_of_activity?:
    | 'management'
    | 'procurement'
    | 'sales'
    | 'finance'
    | 'it'
    | 'business_intelligence'
    | 'customer_care'
    | 'logistics'
    | 'human_resources'
    | 'consulting'
    | 'coaching'
    | 'product_development'
    | 'graphic_design'
    | 'accounting'
    | 'legal'
    | 'administration'
    | 'marketing'
    | 'public_relations'
    | 'research_development'
    | 'quality_management'
    | 'editorial'
    | 'e_commerce'
    | 'production'
    | 'warehouse'
    | 'other'
    | null
  field_of_activity_custom?: string | null
  first_name?: string
  interests?: (
    | 'design'
    | 'marketing'
    | 'distribution'
    | 'programming'
    | 'hr'
    | 'management'
    | 'product_development'
    | 'new_technologies'
    | 'law'
    | 'it'
    | 'data'
    | 'productivity'
  )[]
  job_title?: string | null
  lang?:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt-br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  last_name?: string
  phone?: string | null
  title?: 'mr' | 'mrs' | 'mx'
}

export interface CurrentUserPutBadRequest {
  message?: 'user.error.empty-payload'
}

export interface CurrentUserPutUnprocessableContent {
  message?: 'user.error.failed-to-update-user-in-iam'
}

export interface CurrentUserStateGet {
  company_courses: CompanyCoursesCompletionSummary
  learnpaths: LearnpathsCompletionSummary
}

export interface Department {
  /** @format uuid */
  id: string
  name: string
}

export interface DepartmentPutRequest {
  name: string
}

export interface Departments {
  departments?: Department[]
}

export interface DepartmentsPostRequest {
  name: string
}

export interface E2EBatchOperationFileStatusGetForbidden {
  message?: 'api.error.forbidden'
}

export interface E2EBatchOperationFileStatusGetNotFound {
  message?: 'batch-operations.error.batch-operation-file-not-found'
}

export interface E2ECompanyBatchOperationsDeleteForbidden {
  message?: 'api.error.forbidden'
}

export interface E2ECompanyBatchOperationsDeleteNotFound {
  message?: 'batch-operations.error.company-not-found'
}

export interface E2ENoEmailUsersPost {
  /**
   * @format uuid
   * @default null
   */
  department_id?: string | null
  /** @default null */
  first_name?: string | null
  /** @default null */
  last_name?: string | null
  no_email_user_id: string
  roles: (
    | 'admin'
    | 'owner'
    | 'company_administrator'
    | 'public_api_client'
    | 'manager'
    | 'content_creator'
    | 'student'
  )[]
  /** @default null */
  title?: 'mr' | 'mrs' | 'mx' | null
}

export interface E2ENoEmailUsersPostConflict {
  message?: 'user.error.missing-sso-source-id'
}

export interface E2ENoEmailUsersPostForbidden {
  message?: 'api.error.forbidden'
}

export interface E2ENoEmailUsersPostNotFound {
  message?: 'user.error.department-not-found'
}

export interface E2ENoEmailUsersPostUnprocessableContent {
  message?: 'user.error.license-limit-exceeded'
}

export interface E2EResetUsersProgressPost {
  users_ids: string[]
}

export type Empty = object

export interface ErrorResponse {
  detail: string
  schemas?: string[]
  status: number
}

export interface Event {
  address: string | null
  attendees_count: number
  description: string | null
  /** @format date-time */
  ends_at: string
  /** @format uuid */
  id: string
  in_progress: boolean
  learners_count: number
  /** @format url */
  link: string | null
  /** @format date-time */
  starts_at: string
  state: 'active' | 'unassigned' | 'overdue'
  thumbnail: Thumbnail | null
  timezone: string
  title: string
  type: 'in_person' | 'online'
}

export interface EventAttendee {
  attended: boolean
  /** @format uuid */
  user_id: string
}

export interface EventAttendees {
  groups: AttendingGroup[]
  learners: AttendingLearner[]
}

export interface EventAttendeesGetNotFound {
  message?: 'event.error.event-not-found'
}

export interface EventAttendeesPutNotFound {
  message?: 'event.error.event-not-found'
}

export interface EventDeleteNotFound {
  message?: 'event.error.event-not-found'
}

export interface EventDuplicatePostNotFound {
  message?: 'event.error.event-not-found'
}

export interface EventGetNotFound {
  message?: 'event.error.event-not-found'
}

export interface EventPutNotFound {
  message?: 'event.error.event-not-found'
}

export interface EventPutRequest {
  address?: string | null
  description?: string | null
  /** @format date-time */
  ends_at?: string
  /** @format url */
  link?: string | null
  /** @format date-time */
  starts_at?: string
  /** @format uuid */
  thumbnail_id?: string | null
  timezone?: string
  /** @minLength 1 */
  title?: string
}

export interface EventPutUnprocessableContent {
  message?: 'event.error.start-time-must-be-sooner-than-end-time'
}

export interface Events {
  events: Event[]
  total: number
}

export interface EventsPostNotFound {
  message?: 'event.error.event-not-found'
}

export interface EventsPostRequest {
  /** @default null */
  address?: string | null
  /** @default null */
  description?: string | null
  /** @format date-time */
  ends_at: string
  /**
   * @format url
   * @default null
   */
  link?: string | null
  /** @format date-time */
  starts_at: string
  /**
   * @format uuid
   * @default null
   */
  thumbnail_id?: string | null
  timezone: string
  /** @minLength 1 */
  title: string
}

export interface FederatedIdentity {
  /** @default null */
  identity_provider?: string | null
  /** @default null */
  user_id?: string | null
  /** @default null */
  user_name?: string | null
}

export interface FreeTextPollQuestion {
  /** @format uuid */
  id?: string
  optional?: boolean
  optional_label?: string
  order?: number
  text?: string
  type?: string
}

export interface FundamentalScore {
  award_scores?: AwardScores
  max_score?: number
  status?: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
  total_score?: number
}

export interface GamificationNofificationsSettings {
  show_badge_notifications: boolean
}

export interface Generated {
  /** @min 1 */
  count: number
}

export interface GetCertificateResponse {
  /**
   * The date the certificate was issued.
   * @format date
   */
  created?: string
  /** Variables required by the PDF template, can also hold an additional unrevealed info. */
  data?: Record<string, any>
  /**
   * Unique identifier of the certificate.
   * @format uuid
   */
  id?: string
  /** True if the certificate has been superseded (e.g. the user was transferred between companies or the related content changed). Still returned so the UI can show it as a past certificate while keeping it downloadable. */
  outdated?: boolean
  /** True if the UI should display a poll before certificate download. Legacy field, used specifically with fundamental course and certificate poll. If `poll_details` is non-null, it should be used instead. */
  poll?: boolean
  poll_details?: CertificatePollDetails
  /** Indicates the context in which certificate was issued. Possible values: course, learnpath */
  scope?: string
  /** Name of the template used to create a PDF file. */
  template?: string
}

export interface GetCertificatesResponse {
  /** List of certificates issued in scope 'course' */
  course?: CertificateListItem[]
  /** List of certificates issued in scope 'learnpath' */
  learnpath?: CertificateListItem[]
}

export interface HighestRatedTopicsChannel {
  progress?: ChannelProgress
  topics?: ChannelTopicsOneOf[]
}

export interface HighlightedTopic {
  author?: Author
  average_rating?: number
  captions_langs: string[] | null
  difficulty?: number
  excerpt?: string
  id?: number
  image_id?: string
  locales?: string[]
  num_lectures?: number
  original_lang: string[] | null
  parent_slug?: string
  slug?: string
  title?: string
  voiceover_langs: string[] | null
}

export interface InternalChannel {
  progress?: ChannelProgress
  topics?: ChannelTopicsOneOf[]
}

export interface InternalError {
  message?: 'json_schema.error.internal-error'
}

export interface InviteCompany {
  background_image_id?: string
  logo_id?: string
  name?: string
}

export interface InviteConsumerPost {
  lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt-br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  password: string
}

export interface InviteConsumerPostBadRequest {
  message?: 'invite.error.user-is-deactivated'
}

export interface InviteConsumerPostInternalServerError {
  message?: 'invite.error.failed-to-update-user-in-iam'
}

export interface InviteConsumerPostNotFound {
  message?: 'invite.error.invite-not-found'
}

export interface InviteConsumerPostUnprocessableContent {
  message?: 'invite.error.invite-already-consumed'
}

export interface InvitesConsumerPost {
  users: _UserToConsumeInvite[]
}

export interface InvitesConsumerPostResponse {
  errors?: Record<string, string>
}

export interface KnockUserTokenGetResponse {
  knock_user_token: string
}

export interface KnockUserTokenGetUnauthorized {
  message?: 'activity_log.error.signing-key-storage-exception'
}

export interface LTIDeepLinkingJWTPostBadRequest {
  message?: 'lti.error.launch-id-not-found-exception'
}

export interface LTIDeepLinkingJWTPostRequest {
  items: string[]
}

export interface LTIDeepLinkingJWTPostResponse {
  jwt: string
}

export interface Lang {
  browser?: string
  country_code?: string
  country_language?: string
  ip?: string
  supported?: string[]
  user?: string
}

export interface LaunchGetBadRequest {
  message?: 'launch.error.invalid-integration-type'
}

export interface LaunchGetNotFound {
  message?: 'launch.error.company-not-found'
}

export interface LaunchLink {
  http_method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTION'
  /** @format url */
  url: string
}

export interface LaunchPostBadRequest {
  message?: 'launch.error.invalid-integration-type'
}

export interface Learngroup {
  company?: LearngroupCompany
  /** @format uuid */
  id?: string
  memberships?: LearngroupMembership[]
  name?: string
  num_seats_limit?: number
  num_seats_used?: number
}

export interface LearngroupCompany {
  name?: string
}

export interface LearngroupDeleteForbidden {
  message?: 'learngroup.error.user-not-learngroup-owner'
}

export interface LearngroupDeleteNotFound {
  message?: 'learngroup.error.no-user-learngroup'
}

export interface LearngroupGetNotFound {
  message?: 'learngroup.error.no-user-learngroup'
}

export interface LearngroupLeaderboard {
  company?: LearngroupLeaderboardCompany
  last_week_rank?: number
  last_week_score?: number
  ranking?: LearngroupLeaderboardRankingItem[]
  /** @format date */
  since?: string
}

export interface LearngroupLeaderboardCompany {
  logo_id?: string
  name?: string
}

export interface LearngroupLeaderboardGetNotFound {
  message?: 'learngroup.error.no-user-company'
}

export interface LearngroupLeaderboardRankingItem {
  is_user?: boolean
  rank?: number
  score?: number
  /** @format uuid */
  user_id?: string
}

export interface LearngroupMembership {
  /** @format uuid */
  id?: string
  is_owner?: boolean
  joined?: boolean
  user?: LearngroupMembershipUser
}

export interface LearngroupMembershipDeleteForbidden {
  message?:
    | 'learngroup.error.user-learngroup-mismatch'
    | 'learngroup.error.user-not-joined'
    | 'learngroup.error.user-not-learngroup-owner'
}

export interface LearngroupMembershipDeleteNotFound {
  message?: 'learngroup.error.no-user-learngroup-membership'
}

export interface LearngroupMembershipMailPostForbidden {
  message?:
    | 'learngroup.error.user-learngroup-mismatch'
    | 'learngroup.error.user-not-joined'
}

export interface LearngroupMembershipMailPostInternalError {
  message?: 'learngroup.error.failed-learngroup-invite-mail'
}

export interface LearngroupMembershipMailPostNotFound {
  message?: 'learngroup.error.no-user-learngroup-membership'
}

export interface LearngroupMembershipMailPostTooManyRequests {
  message?: 'learngroup.error.learngroup-invite-mail-throttled'
}

export interface LearngroupMembershipMailPostUnprocessableEntity {
  message?:
    | 'learngroup.error.cannot-invite-self'
    | 'learngroup.error.user-already-joined'
}

export interface LearngroupMembershipPutForbidden {
  message?: 'learngroup.error.user-learngroup-membership-mismatch'
}

export interface LearngroupMembershipPutNotFound {
  message?: 'learngroup.error.no-user-learngroup-membership'
}

export interface LearngroupMembershipUser {
  /** @format url */
  avatar_url?: string
  email?: string
  first_name?: string
  last_name?: string
}

export interface LearngroupPostRequest {
  /**
   * @maxItems 5
   * @minItems 1
   */
  emails: string[]
  /** @default null */
  name?: string | null
}

export interface LearngroupPostUnprocessableEntity {
  message?:
    | 'learngroup.error.empty-learngroup-name'
    | 'learngroup.error.user-already-in-learngroup'
}

export interface LearngroupPutForbidden {
  message?: 'learngroup.error.user-not-joined'
}

export interface LearngroupPutNotFound {
  message?: 'learngroup.error.no-user-learngroup'
}

export interface LearngroupPutRequest {
  /** @default [] */
  emails?: string[]
  /** @default null */
  name?: string | null
}

export interface LearngroupPutUnprocessableEntity {
  message?:
    | 'learngroup.error.user-already-in-learngroup'
    | 'learngroup.error.num-seats-limit-reached'
}

export interface LearngroupScoring {
  company?: LearngroupScoringCompany
  company_avg_score?: number
  learning_objective?: LearngroupScoringLearningObjective
  scoring?: LearngroupScoringItem[]
  /** @format date */
  since?: string
}

export interface LearngroupScoringCompany {
  name?: string
}

export interface LearngroupScoringGetForbidden {
  message?: 'learngroup.error.user-not-joined'
}

export interface LearngroupScoringGetNotFound {
  message?:
    | 'learngroup.error.no-user-company'
    | 'learngroup.error.no-user-learngroup'
}

export interface LearngroupScoringItem {
  /** @format uuid */
  id?: string
  is_user?: boolean
  joined?: boolean
  last_week_score?: number
  score?: number
  user?: LearngroupScoringUser
}

export interface LearngroupScoringLearningObjective {
  /** @format date */
  end_date?: string
  num_days_left?: number
  score?: number
  /** @format date */
  start_date?: string
}

export interface LearngroupScoringUser {
  /** @format url */
  avatar_url?: string
  first_name?: string
  last_name?: string
}

export interface LearningAppointmentPostRequest {
  day_of_week: string
  time: string
}

export interface LearnpathAttributeTranslations {
  attributes: LearnpathTranslationAttribute[]
  /** @format uuid */
  id: string
}

export interface LearnpathCategories {
  categories: LearnpathCategory[]
}

export interface LearnpathCategory {
  /** @format uuid */
  id: string
  name: string
  num_learnpaths: number
}

export interface LearnpathElementTranslationUpdate {
  attributes: LearnpathTranslationAttributeUpdate[]
  /** @format uuid */
  id: string
}

export interface LearnpathElementTranslations {
  attributes: LearnpathTranslationAttribute[]
  /** @format uuid */
  id: string
  translations: string[] | null
  type:
    | 'video'
    | 'text'
    | 'link'
    | 'quiz'
    | 'platform_topic'
    | 'file'
    | 'scorm'
    | 'embedded_video'
    | 'event'
}

export interface LearnpathFileUpload {
  filename: string
  filesize: number
  /** @format uuid */
  id: string
  /** @format url */
  media_url: string | null
  status: 'initiated' | 'uploaded' | 'available'
}

export interface LearnpathFileUploadDeleteInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-file-upload-integrity-error'
}

export interface LearnpathFileUploadDeleteNotFound {
  message?: 'learnpath.error.learnpath-file-upload-not-found'
}

export interface LearnpathFileUploadDeleteUnprocessableEntity {
  message?: 'learnpath.error.learnpath-file-upload-currently-assigned'
}

export interface LearnpathFileUploadGetNotFound {
  message?: 'learnpath.error.learnpath-file-upload-not-found'
}

export interface LearnpathFileUploadPutNotFound {
  message?: 'learnpath.error.learnpath-file-upload-not-found'
}

export interface LearnpathFileUploadPutRequest {
  status: string
}

export interface LearnpathFileUploadPutUnprocessableEntity {
  message?: 'learnpath.error.learnpath-file-upload-already-updated'
}

export interface LearnpathFileUploadWithPayload {
  filename: string
  filesize: number
  /** @format uuid */
  id: string
  /** @format url */
  media_url: string | null
  payload: PresignedPostForFileUpload
  status: 'initiated' | 'uploaded' | 'available'
}

export interface LearnpathFileUploadsPostForbidden {
  message?: 'learnpath.error.no-user-company'
}

export interface LearnpathFileUploadsPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-file-upload-integrity-error'
}

export interface LearnpathFileUploadsPostRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  filename: string
  /**
   * @min 1
   * @max 2147483647
   */
  filesize: number
}

export interface LearnpathJoinByLinkPostForbidden {
  message?: 'learnpath.error.no-user-company'
}

export interface LearnpathJoinByLinkPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface LearnpathJoinByLinkPostUnprocessableContent {
  message?: 'learnpath.error.learnpath-is-not-active'
}

export interface LearnpathLaunchLink {
  auth_method: 'password' | 'sso'
  /** @format url */
  url: string
}

export interface LearnpathMemberUserGroups {
  /** @format uuid */
  id: string
  name: string
}

export interface LearnpathMembershipsOverviewDeleteForbidden {
  message?: 'api.error.forbidden'
}

export interface LearnpathMembershipsOverviewDeleteNotFound {
  message?: 'learnpath.error.learner-not-found'
}

export interface LearnpathMembershipsOverviewGetNotFound {
  message?: 'learnpath.error.learner-not-found'
}

export interface LearnpathMembershipsOverviewPostForbidden {
  message?: 'api.error.forbidden'
}

export interface LearnpathMembershipsOverviewPostNotFound {
  message?: 'learnpath.error.learner-not-found'
}

export interface LearnpathOverview {
  /**
   * When this previous recurring release was superseded: the first activation time of the following release in the series. Null unless `release` is previous.
   * @format date-time
   */
  deactivation_date: string | null
  description: string | null
  /** @format uuid */
  id: string
  mandatory: boolean
  name: string
  num_members: number
  num_members_completed: number
  /** @format date-time */
  recurring_date: string | null
  /** @format uuid */
  recurring_id: string | null
  release: 'previous' | 'current' | 'next' | 'first' | null
}

export interface LearnpathOwnTranslationAttributeUpdate {
  active?: boolean
  key: string
  provider?: 'youtube' | null
  status?: 'in_progress' | 'in_review' | 'completed' | null
  value?: string | null
  video_id?: string | null
}

export interface LearnpathOwner {
  /** @format url */
  avatar_url: string | null
  first_name: string | null
  last_name: string | null
}

export interface LearnpathScormPackage {
  /** @format uuid */
  id: string
  uri: string | null
  works_on_mobile: boolean
}

export interface LearnpathSharingLink {
  auth_method: 'password' | 'sso'
  /** @format url */
  url: string
}

export interface LearnpathThumbnailUploadDeleteNotFound {
  message?: 'learnpath.error.learnpath-thumbnail-upload-not-found'
}

export interface LearnpathThumbnailUploadGetNotFound {
  message?: 'learnpath.error.learnpath-thumbnail-upload-not-found'
}

export interface LearnpathThumbnailUploadPutNotFound {
  message?: 'learnpath.error.learnpath-thumbnail-upload-not-found'
}

export interface LearnpathTranslationAttribute {
  active: boolean
  default: string | null
  /**
   * When this attribute's default-language value last changed. Compared with value_updated_at of the same attribute.
   * @format date-time
   */
  default_updated_at: string | null
  key: string
  /** Manual status of a text lesson body translation. Only completed counts towards completion_ratio. Null for every other attribute and for a body that has not been started. */
  status: 'in_progress' | 'in_review' | 'completed' | null
  type: string
  value: string | null
  value_filename: string | null
  value_name: string | null
  /**
   * When this attribute's translation was last saved. A save of the current value moves it. Null when the translation is empty.
   * @format date-time
   */
  value_updated_at: string | null
}

export interface LearnpathTranslationAttributeUpdate {
  active?: boolean
  key: string
  provider?: 'youtube' | null
  status?: 'in_progress' | 'in_review' | 'completed' | null
  value?: string | null
  video_id?: string | null
}

export interface LearnpathTranslations {
  elements: LearnpathElementTranslations[]
  learnpath: LearnpathAttributeTranslations
}

export interface LearnpathTranslationsPutRequest {
  elements?: LearnpathElementTranslationUpdate[]
  learnpath?: LearnpathOwnTranslationAttributeUpdate[]
}

export interface LearnpathUserMembershipsBulkRequest {
  /** @minItems 1 */
  learnpath_ids: string[]
}

export interface LearnpathVideoUpload {
  duration: number | null
  filename: string
  filesize: number
  /** @format uuid */
  id: string
  media_source: string | null
  /** @format url */
  media_url: string | null
  status: 'initiated' | 'uploaded' | 'available'
  thumbnail_id: string | null
  /** @format url */
  thumbnail_url: string | null
}

export interface LearnpathVideoUploadDeleteInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-video-upload-integrity-error'
}

export interface LearnpathVideoUploadDeleteNotFound {
  message?: 'learnpath.error.learnpath-video-upload-not-found'
}

export interface LearnpathVideoUploadDeleteUnprocessableEntity {
  message?: 'learnpath.error.learnpath-video-upload-currently-assigned'
}

export interface LearnpathVideoUploadGetNotFound {
  message?: 'learnpath.error.learnpath-video-upload-not-found'
}

export interface LearnpathVideoUploadPutNotFound {
  message?: 'learnpath.error.learnpath-video-upload-not-found'
}

export interface LearnpathVideoUploadPutRequest {
  status: string
}

export interface LearnpathVideoUploadPutUnprocessableEntity {
  message?: 'learnpath.error.learnpath-video-upload-already-updated'
}

export interface LearnpathVideoUploadWithPayload {
  duration: number | null
  filename: string
  filesize: number
  /** @format uuid */
  id: string
  media_source: string | null
  /** @format url */
  media_url: string | null
  payload: PresignedPostForFileUpload
  status: 'initiated' | 'uploaded' | 'available'
  thumbnail_id: string | null
  /** @format url */
  thumbnail_url: string | null
}

export interface LearnpathVideoUploadsPostForbidden {
  message?: 'learnpath.error.no-user-company'
}

export interface LearnpathVideoUploadsPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-video-upload-integrity-error'
}

export interface LearnpathVideoUploadsPostRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  filename: string
  /**
   * @min 1
   * @max 2147483647
   */
  filesize: number
}

export interface LearnpathsCompletionSummary {
  num_learnpaths_assigned: number
  num_learnpaths_completed: number
  num_mandatory_learnpaths_assigned: number
  num_mandatory_learnpaths_completed: number
}

export interface LearnpathsNotificationsSettings {
  mandatory_learnpaths_notifications_only: boolean
}

export interface LearnpathsOverview {
  learnpaths: LearnpathOverview[]
  total_learnpaths: number
}

export interface LectureBookmarks {
  bookmarks?: Bookmark[]
}

export interface LectureProgress {
  meta: object | null
  status: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
}

export interface LectureTopic {
  author?: LectureTopicAuthor
  background_image_id?: string
  /** @format url */
  background_video_url?: string
  captions_langs: string[] | null
  difficulty?: number
  duration?: any
  excerpt?: string
  id: number
  image_id?: string
  is_announcement?: boolean
  is_internal?: boolean
  locales?: string[]
  max_score?: number
  num_lectures?: number
  original_lang: string[] | null
  poster_image_id?: string
  poster_image_mobile_id?: string
  slug?: string
  tags?: string[]
  title?: string
  type?: 'course' | 'channel'
  voiceover_langs: string[] | null
}

export interface LectureTopicAuthor {
  company_name?: string
  fullname?: string
  image_id?: string
}

export interface LicenseProvider {
  /** The URI of the SCIM resource                 representing the User's manager. */
  $ref?: string
  /**
   * Identifier of the User.
   * @format uuid
   */
  value?: string
}

export interface LicenseProviderPut {
  /** @format uuid */
  license_provider_id: string
}

export interface LicenseProviderPutBadRequest {
  message?: 'user.error.user-cannot-be-its-own-license-provider'
}

export interface LicenseProviderPutForbidden {
  message?: 'api.error.forbidden'
}

export interface LicenseProviderPutNotFound {
  message?: 'user.error.user-not-found'
}

export interface Licenses {
  available: number
  total: number
}

export interface ManagedLearnpath {
  /**
   * A UTC timestamp indicating when the activation will occur automatically.
   * @format date-time
   */
  activates_at: string | null
  /**
   * A timezone used solely in the UI to present the scheduled activation date & time.
   * @example "Europe/Warsaw"
   */
  activates_at_tz: string | null
  active: boolean
  assigned_for_all_students: boolean
  can_be_edited_by_caller: boolean
  can_be_restricted_by_caller: boolean
  categories: ManagedLearnpathCategory[]
  complete_in: number | null
  /** @format date */
  complete_until: string | null
  contact_people: ContactPerson[] | null
  /** @format date-time */
  created_at: string
  default_lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  description: string | null
  duration: number
  /** @format uuid */
  external_id: string
  has_been_active: boolean
  /** @format uuid */
  id: string
  is_course: boolean
  is_quiz_mastery_mode_on: boolean
  isolated_progress: boolean
  issue_completion_certificate: boolean
  lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  launch_links: LearnpathLaunchLink[]
  linear: boolean
  link_sharing_active: boolean
  mandatory: boolean
  name: string | null
  notification_flags: ManagedLearnpathNotificationFlags
  num_elements: number
  num_items: number
  num_link_elements: number
  num_members: number
  num_members_completed: number
  num_members_started: number
  num_scorm_elements: number
  num_text_elements: number
  num_video_elements: number
  owner: LearnpathOwner | null
  percentage_of_completed_items: number
  points: number | null
  /** @format uuid */
  recurring_draft_id: string | null
  recurring_frequency: 'daily' | 'weekly' | 'yearly' | null
  /** @format uuid */
  recurring_id: string | null
  recurring_interval: number | null
  recurring_release: 'previous' | 'current' | 'next' | 'first' | null
  releases: ManagedRecurringLearnpathRelease[]
  restricted_access: boolean
  /** @format uuid */
  sharing_link_id: string
  sharing_links: LearnpathSharingLink[]
  thumbnail: Thumbnail | null
  /** @format date-time */
  updated_at: string
  validity: Validity
}

export interface ManagedLearnpathActivateActionPostForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathActivateActionPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathActivateActionPostUnprocessableContent {
  message?: 'learnpath.error.learnpath-is-active'
}

export interface ManagedLearnpathCandidate {
  /** @format url */
  avatar_url: string | null
  email: string
  first_name: string | null
  /** @format uuid */
  id: string
  last_name: string | null
  no_email_user_id: string | null
  status: 'active' | 'pending' | 'deactivated'
  user_group_memberships: LearnpathMemberUserGroups[]
}

export interface ManagedLearnpathCandidates {
  candidates: ManagedLearnpathCandidate[]
  members: ManagedLearnpathMember[]
  num_all_students: number
}

export interface ManagedLearnpathCategory {
  /** @format uuid */
  id: string
  name: string
}

export interface ManagedLearnpathCompletionStatisticsGetNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathDeactivateActionPostForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathDeactivateActionPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathDeactivateActionPostUnprocessableContent {
  message?: 'learnpath.error.learnpath-is-not-active'
}

export interface ManagedLearnpathDeleteForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathDeleteInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-integrity-error'
}

export interface ManagedLearnpathDeleteNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathDuplicateActionPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-integrity-error'
}

export interface ManagedLearnpathDuplicateActionPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathDuplicateActionResponse {
  /** @format uuid */
  id?: string
  name?: string
}

export interface ManagedLearnpathDuplicateAsCourseActionPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-integrity-error'
}

export interface ManagedLearnpathDuplicateAsCourseActionPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathDuplicateAsCourseActionPostUnprocessableContent {
  message?: 'learnpath.error.learnpath-is-course'
}

export interface ManagedLearnpathDuplicateAsCourseActionResponse {
  /** @format uuid */
  id?: string
  name?: string
}

export interface ManagedLearnpathDuplicateAsLearnpathActionPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-integrity-error'
}

export interface ManagedLearnpathDuplicateAsLearnpathActionPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathDuplicateAsLearnpathActionPostUnprocessableContent {
  message?: 'learnpath.error.learnpath-is-not-course'
}

export interface ManagedLearnpathDuplicateAsLearnpathActionResponse {
  /** @format uuid */
  id?: string
  name?: string
}

export type ManagedLearnpathElementOneOf =
  | ({
      type: 'embedded_video'
    } & ManagedLearnpathEmbeddedVideoElement)
  | ({
      type: 'event'
    } & ManagedLearnpathEventElement)
  | ({
      type: 'file'
    } & ManagedLearnpathFileElement)
  | ({
      type: 'link'
    } & ManagedLearnpathLinkElement)
  | ({
      type: 'platform_topic'
    } & ManagedLearnpathPlatformTopicElement)
  | ({
      type: 'quiz'
    } & ManagedLearnpathQuizElement)
  | ({
      type: 'scorm'
    } & ManagedLearnpathScormElement)
  | ({
      type: 'text'
    } & ManagedLearnpathTextElement)
  | ({
      type: 'video'
    } & ManagedLearnpathVideoElement)

export interface ManagedLearnpathElements {
  elements: ManagedLearnpathElementOneOf[]
}

export interface ManagedLearnpathElementsGetNotFound {
  message?: 'learnpath.error.learnpath-language-not-found'
}

export interface ManagedLearnpathElementsPutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathElementsPutRequest {
  /** @minItems 1 */
  ordering: string[]
}

export interface ManagedLearnpathElementsPutUnprocessableContent {
  message?: 'learnpath.error.invalid-learnpath-elements-ordering'
}

export interface ManagedLearnpathEmbeddedVideoElement {
  description: string | null
  duration: number
  /** @format uuid */
  id: string
  order: number
  playable: boolean
  provider: 'youtube'
  thumbnail: Thumbnail | null
  title: string | null
  type: string
  video_id: string
}

export interface ManagedLearnpathEmbeddedVideoElementDeleteForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathEmbeddedVideoElementDeleteNotFound {
  message?: 'learnpath.error.learnpath-embedded-video-element-not-found'
}

export interface ManagedLearnpathEmbeddedVideoElementGetNotFound {
  message?: 'learnpath.error.learnpath-embedded-video-element-not-found'
}

export interface ManagedLearnpathEmbeddedVideoElementPutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathEmbeddedVideoElementPutInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-embedded-video-element-integrity-error'
}

export interface ManagedLearnpathEmbeddedVideoElementPutNotFound {
  message?: 'learnpath.error.learnpath-embedded-video-element-not-found'
}

export interface ManagedLearnpathEmbeddedVideoElementPutRequest {
  description?: string | null
  /** @min 1 */
  duration?: number
  provider?: 'youtube'
  /** @format uuid */
  thumbnail_id?: string | null
  /** @minLength 1 */
  title?: string
  /** @minLength 1 */
  video_id?: string
}

export interface ManagedLearnpathEmbeddedVideoElementsPostConflict {
  message?: 'learnpath.error.duplicate-learnpath-element-order'
}

export interface ManagedLearnpathEmbeddedVideoElementsPostForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathEmbeddedVideoElementsPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-embedded-video-element-integrity-error'
}

export interface ManagedLearnpathEmbeddedVideoElementsPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathEmbeddedVideoElementsPostRequest {
  /** @default null */
  description?: string | null
  /** @min 1 */
  duration: number
  provider: 'youtube'
  /**
   * @format uuid
   * @default null
   */
  thumbnail_id?: string | null
  /** @minLength 1 */
  title: string
  /** @minLength 1 */
  video_id: string
}

export interface ManagedLearnpathEnabledNotifications {
  notification_types: (
    | 'content_edit'
    | 'learner_assignment'
    | 'completion_time_edit'
    | 'reactivation'
  )[]
}

export interface ManagedLearnpathEventElement {
  address: string | null
  description: string | null
  duration: number
  /** @format date-time */
  ends_at: string
  /** @format uuid */
  event_id: string
  event_thumbnail: Thumbnail | null
  event_type: string
  /** @format uuid */
  id: string
  /** @format url */
  link: string | null
  order: number
  /** @format date-time */
  starts_at: string
  thumbnail: Thumbnail | null
  /** @format url */
  thumbnail_url: string | null
  timezone: string
  title: string | null
  type: string
}

export interface ManagedLearnpathEventElementDeleteForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathEventElementDeleteNotFound {
  message?: 'learnpath.error.learnpath-event-element-not-found'
}

export interface ManagedLearnpathEventElementGetNotFound {
  message?: 'learnpath.error.learnpath-event-element-not-found'
}

export interface ManagedLearnpathEventElementPutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathEventElementPutInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-event-element-integrity-error'
}

export interface ManagedLearnpathEventElementPutNotFound {
  message?: 'learnpath.error.learnpath-event-element-not-found'
}

export interface ManagedLearnpathEventElementPutRequest {
  /** @format uuid */
  event_id?: string
}

export interface ManagedLearnpathEventElementsPostConflict {
  message?: 'learnpath.error.duplicate-learnpath-element-order'
}

export interface ManagedLearnpathEventElementsPostForbidden {
  message?: 'learnpath.error.feature-not-available-in-course'
}

export interface ManagedLearnpathEventElementsPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-event-element-integrity-error'
}

export interface ManagedLearnpathEventElementsPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathEventElementsPostRequest {
  /** @format uuid */
  event_id: string
}

export interface ManagedLearnpathEventElementsPostUnprocessableContent {
  message?: 'learnpath.error.event-not-available'
}

export interface ManagedLearnpathFileElement {
  description: string | null
  downloadable: boolean
  duration: number
  file_upload: LearnpathFileUpload
  /** @format uuid */
  id: string
  learning_objectives: (string | null)[]
  order: number
  tags: (string | null)[]
  thumbnail: Thumbnail | null
  title: string | null
  type: string
}

export interface ManagedLearnpathFileElementDeleteForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathFileElementGetNotFound {
  message?: 'learnpath.error.learnpath-file-element-not-found'
}

export interface ManagedLearnpathFileElementPutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathFileElementPutInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-file-element-integrity-error'
}

export interface ManagedLearnpathFileElementPutNotFound {
  message?: 'learnpath.error.learnpath-file-upload-not-found'
}

export interface ManagedLearnpathFileElementPutRequest {
  description?: string | null
  downloadable?: boolean
  duration?: number
  /** @format uuid */
  file_upload_id?: string
  learning_objectives?: string[] | null
  tags?: string[] | null
  /** @format uuid */
  thumbnail_id?: string | null
  /** @minLength 1 */
  title?: string
}

export interface ManagedLearnpathFileElementsPostConflict {
  message?: 'learnpath.error.duplicate-learnpath-element-order'
}

export interface ManagedLearnpathFileElementsPostForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathFileElementsPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-file-element-integrity-error'
}

export interface ManagedLearnpathFileElementsPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathFileElementsPostRequest {
  /** @default null */
  description?: string | null
  /** @default true */
  downloadable?: boolean
  duration?: number
  /** @format uuid */
  file_upload_id: string
  learning_objectives?: string[] | null
  tags?: string[] | null
  /**
   * @format uuid
   * @default null
   */
  thumbnail_id?: string | null
  /** @minLength 1 */
  title: string
}

export interface ManagedLearnpathGetNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathLanguage {
  active: boolean
  completion_ratio: number
  is_default: boolean
  lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  /** True when any saved attribute predates a change to that attribute's default. Other attributes stay as they are. Always false for the default language. */
  outdated: boolean
}

export interface ManagedLearnpathLanguageDeleteForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathLanguageDeleteNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathLanguageDeleteUnprocessableContent {
  message?: 'learnpath.error.learnpath-language-is-default'
}

export interface ManagedLearnpathLanguagePostRequest {
  lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
}

export interface ManagedLearnpathLanguagePutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathLanguagePutNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathLanguagePutRequest {
  active: boolean
}

export interface ManagedLearnpathLanguagePutUnprocessableContent {
  message?: 'learnpath.error.learnpath-language-is-default'
}

export interface ManagedLearnpathLanguages {
  languages: ManagedLearnpathLanguage[]
}

export interface ManagedLearnpathLanguagesGetNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathLanguagesPostConflict {
  message?: 'learnpath.error.learnpath-language-already-exists'
}

export interface ManagedLearnpathLanguagesPostForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathLanguagesPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathLanguagesPostUnprocessableContent {
  message?: 'learnpath.error.learnpath-language-is-default'
}

export interface ManagedLearnpathLinkElement {
  description: string | null
  duration: number
  /** @format uuid */
  id: string
  learning_objectives: (string | null)[]
  order: number
  tags: (string | null)[]
  thumbnail: Thumbnail | null
  title: string | null
  type: string
  /** @format url */
  url: string
}

export interface ManagedLearnpathLinkElementDeleteForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathLinkElementDeleteNotFound {
  message?: 'learnpath.error.learnpath-link-element-not-found'
}

export interface ManagedLearnpathLinkElementGetNotFound {
  message?: 'learnpath.error.learnpath-link-element-not-found'
}

export interface ManagedLearnpathLinkElementPutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathLinkElementPutInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-link-element-integrity-error'
}

export interface ManagedLearnpathLinkElementPutNotFound {
  message?: 'learnpath.error.learnpath-link-element-not-found'
}

export interface ManagedLearnpathLinkElementPutRequest {
  description?: string | null
  duration?: number
  learning_objectives?: string[] | null
  tags?: string[] | null
  /** @format uuid */
  thumbnail_id?: string | null
  /** @minLength 1 */
  title?: string
  /** @format url */
  url?: string
}

export interface ManagedLearnpathLinkElementsPostConflict {
  message?: 'learnpath.error.duplicate-learnpath-element-order'
}

export interface ManagedLearnpathLinkElementsPostForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathLinkElementsPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-link-element-integrity-error'
}

export interface ManagedLearnpathLinkElementsPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathLinkElementsPostRequest {
  /** @default null */
  description?: string | null
  duration?: number
  learning_objectives?: string[] | null
  tags?: string[] | null
  /**
   * @format uuid
   * @default null
   */
  thumbnail_id?: string | null
  /** @minLength 1 */
  title: string
  /** @format url */
  url: string
}

export interface ManagedLearnpathMember {
  assignment_method:
    | 'auto'
    | 'choice'
    | 'copied'
    | 'link'
    | 'admin'
    | 'scorm'
    | 'self_assigned'
  /** @format url */
  avatar_url: string | null
  completion_status: string | null
  email: string
  first_name: string | null
  /** @format uuid */
  id: string
  last_name: string | null
  no_email_user_id: string | null
  status: 'active' | 'pending' | 'deactivated'
  user_group_memberships: LearnpathMemberUserGroups[]
}

export interface ManagedLearnpathMembers {
  members: ManagedLearnpathMember[]
}

export interface ManagedLearnpathMembersDeleteRequest {
  /** @minItems 1 */
  users_ids: string[]
}

export interface ManagedLearnpathMembersPostForbidden {
  message?: 'learnpath.error.feature-not-available-in-course'
}

export interface ManagedLearnpathMembersPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-member-integrity-error'
}

export interface ManagedLearnpathMembersPostRequest {
  /** @minItems 1 */
  users_ids: string[]
}

export interface ManagedLearnpathMembersPostUnprocessableContent {
  message?: 'learnpath.error.learnpath-member-company-mismatch'
}

export interface ManagedLearnpathNotificationFlags {
  completion_time_edit: boolean
  content_edit: boolean
  learner_assignment: boolean
  reactivation: boolean
}

export interface ManagedLearnpathPlatformTopicElement {
  /** @format uuid */
  id: string
  order: number
  thumbnail: Thumbnail | null
  topic: ManagedPlatformTopic
  type: string
}

export interface ManagedLearnpathPlatformTopicElementDeleteForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathPlatformTopicElementDeleteNotFound {
  message?: 'learnpath.error.learnpath-platform-topic-element-not-found'
}

export interface ManagedLearnpathPlatformTopicElementGetNotFound {
  message?: 'learnpath.error.learnpath-platform-topic-element-not-found'
}

export interface ManagedLearnpathPlatformTopicElementPostRequest {
  /** @minItems 1 */
  lectures_ids: number[]
  /** Warning: this is actually a Custom Topic Entry ID, not a Topic ID. */
  topic_id: number
}

export interface ManagedLearnpathPlatformTopicElementPutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathPlatformTopicElementPutInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-platform-topic-element-integrity-error'
}

export interface ManagedLearnpathPlatformTopicElementPutNotFound {
  message?: 'learnpath.error.learnpath-platform-topic-element-not-found'
}

export interface ManagedLearnpathPlatformTopicElementPutRequest {
  /** @minItems 1 */
  lectures_ids: number[]
}

export interface ManagedLearnpathPlatformTopicElementPutUnprocessableContent {
  message?: 'learnpath.error.no-learnpath-platform-topic-element-lectures'
}

export interface ManagedLearnpathPlatformTopicElementsPostError {
  message: string
  /** @default "error" */
  status?: any
}

export type ManagedLearnpathPlatformTopicElementsPostResponse =
  | ({
      status: 'error'
    } & ManagedLearnpathPlatformTopicElementsPostError)
  | ({
      status: 'ok'
    } & ManagedLearnpathPlatformTopicElement)

export interface ManagedLearnpathPlatformTopicsCatalog {
  filters: PlatformTopicsFilters
  limit: number | null
  offset: number | null
  order: 'relevance' | 'top_rated' | 'most_viewed' | 'most_recent' | null
  query: string | null
  topics: PlatformTopic[]
  total_count: number
}

export interface ManagedLearnpathPutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathPutInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-integrity-error'
}

export interface ManagedLearnpathPutNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathPutRequest {
  /**
   * A UTC timestamp indicating when the activation will occur automatically.
   * @format date-time
   */
  activates_at?: string | null
  /**
   * A timezone used solely in the UI to present the scheduled activation date & time.
   * @example "Europe/Warsaw"
   */
  activates_at_tz?: string | null
  assigned_for_all_students?: boolean
  categories?: string[]
  /**
   * @min 1
   * @max 366
   */
  complete_in?: number | null
  /** @format date */
  complete_until?: string | null
  /**
   * @maxItems 2
   * @minItems 0
   */
  contact_people?: ManagedLearnpathPutRequestContactPeople[] | null
  default_lang?:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  /** @maxLength 300 */
  description?: string | null
  isolated_progress?: boolean
  issue_completion_certificate?: boolean
  lang?:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  linear?: boolean
  mandatory?: boolean
  /**
   * @minLength 1
   * @maxLength 60
   */
  name?: string
  notification_flags?: ManagedLearnpathNotificationFlags
  /** @min 1 */
  points?: number | null
  recurring_frequency?: 'daily' | 'weekly' | 'yearly' | null
  /** @min 1 */
  recurring_interval?: number | null
  restricted_access?: boolean
  /** @format uuid */
  thumbnail_id?: string | null
  validity?: ManagedLearnpathPutRequestValidity | null
}

export interface ManagedLearnpathPutRequestContactPeople {
  /** @format email */
  email: string
  fullname: string
  phone?: string
  position?: string
}

export interface ManagedLearnpathPutRequestValidity {
  /** @format date */
  date: string | null
  type: 'day' | 'month' | 'year' | null
  /** @min 1 */
  value: number | null
}

export interface ManagedLearnpathPutUnprocessableContent {
  message?: 'learnpath.error.learnpath-is-active'
}

export interface ManagedLearnpathQuizElement {
  attempts: number | null
  /** @format uuid */
  id: string
  order: number
  questions: ManagedLearnpathQuizQuestion[]
  threshold: number | null
  thumbnail: Thumbnail | null
  type: string
}

export interface ManagedLearnpathQuizElementDeleteForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathQuizElementDeleteNotFound {
  message?: 'learnpath.error.learnpath-quiz-element-not-found'
}

export interface ManagedLearnpathQuizElementGetNotFound {
  message?: 'learnpath.error.learnpath-quiz-element-not-found'
}

export interface ManagedLearnpathQuizElementPutConflict {
  message?: 'learnpath.error.duplicate-learnpath-element-order'
}

export interface ManagedLearnpathQuizElementPutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathQuizElementPutInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-quiz-element-integrity-error'
}

export interface ManagedLearnpathQuizElementPutNotFound {
  message?: 'learnpath.error.learnpath-quiz-element-not-found'
}

export interface ManagedLearnpathQuizElementPutRequest {
  /**
   * @min 1
   * @max 5
   */
  attempts?: number | null
  /** @minItems 1 */
  questions: ManagedLearnpathQuizElementPutRequestQuestions[]
  /**
   * @min 0
   * @max 100
   */
  threshold?: number | null
  /** @format uuid */
  thumbnail_id?: string | null
}

export interface ManagedLearnpathQuizElementPutRequestAnswers {
  correct: boolean
  /** @format uuid */
  id?: string
  text: string
}

export interface ManagedLearnpathQuizElementPutRequestQuestions {
  /**
   * @maxItems 4
   * @minItems 2
   */
  answers: ManagedLearnpathQuizElementPutRequestAnswers[]
  /** @format uuid */
  id?: string
  text: string
  type: 'single_choice' | 'multiple_choice'
}

export interface ManagedLearnpathQuizElementsPostConflict {
  message?: 'learnpath.error.duplicate-learnpath-element-order'
}

export interface ManagedLearnpathQuizElementsPostForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathQuizElementsPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-quiz-element-integrity-error'
}

export interface ManagedLearnpathQuizElementsPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathQuizElementsPostRequest {
  /**
   * @min 1
   * @max 5
   * @default null
   */
  attempts?: number | null
  /** @minItems 1 */
  questions: ManagedLearnpathQuizElementsPostRequestQuestions[]
  /**
   * @min 0
   * @max 100
   * @default null
   */
  threshold?: number | null
  /**
   * @format uuid
   * @default null
   */
  thumbnail_id?: string | null
}

export interface ManagedLearnpathQuizElementsPostRequestAnswers {
  correct: boolean
  text: string
}

export interface ManagedLearnpathQuizElementsPostRequestQuestions {
  /**
   * @maxItems 4
   * @minItems 2
   */
  answers: ManagedLearnpathQuizElementsPostRequestAnswers[]
  text: string
  type: 'single_choice' | 'multiple_choice'
}

export interface ManagedLearnpathQuizQuestion {
  answers: ManagedLearnpathQuizQuestionAnswer[]
  /** @format uuid */
  id: string
  text: string | null
  type: 'single_choice' | 'multiple_choice'
}

export interface ManagedLearnpathQuizQuestionAnswer {
  correct: boolean
  /** @format uuid */
  id: string
  text: string | null
}

export interface ManagedLearnpathQuizStatisticsGetNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathScormElement {
  completion_trigger: boolean
  description: string | null
  /** @format uuid */
  id: string
  order: number
  scorm_package: LearnpathScormPackage
  thumbnail: Thumbnail | null
  title: string | null
  type: string
}

export interface ManagedLearnpathScormElementDeleteForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathScormElementDeleteNotFound {
  message?: 'learnpath.error.learnpath-scorm-element-not-found'
}

export interface ManagedLearnpathScormElementGetNotFound {
  message?: 'learnpath.error.learnpath-scorm-element-not-found'
}

export interface ManagedLearnpathScormElementPutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathScormElementPutInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-scorm-element-integrity-error'
}

export interface ManagedLearnpathScormElementPutNotFound {
  message?: 'learnpath.error.learnpath-scorm-element-not-found'
}

export interface ManagedLearnpathScormElementPutRequest {
  completion_trigger?: boolean
  description?: string | null
  learning_objectives?: string[] | null
  /** @format uuid */
  scorm_package_id?: string
  tags?: string[] | null
  /** @format uuid */
  thumbnail_id?: string | null
  /** @minLength 1 */
  title?: string
  /** @format url */
  url?: string
}

export interface ManagedLearnpathScormElementPutUnprocessableContent {
  message?: 'learnpath.error.package-not-available-for-selected-company'
}

export interface ManagedLearnpathScormElementsPostConflict {
  message?: 'learnpath.error.duplicate-learnpath-element-order'
}

export interface ManagedLearnpathScormElementsPostForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathScormElementsPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathScormElementsPostRequest {
  /** @default false */
  completion_trigger?: boolean | null
  /** @default null */
  description?: string | null
  /** @format uuid */
  scorm_package_id: string
  /**
   * @format uuid
   * @default null
   */
  thumbnail_id?: string | null
  /** @minLength 1 */
  title: string
}

export interface ManagedLearnpathScormElementsPostUnprocessableContent {
  message?: 'learnpath.error.package-not-available-for-selected-company'
}

export interface ManagedLearnpathSharingLink {
  link_sharing_active: boolean
  /** @format uuid */
  sharing_link_id: string | null
}

export interface ManagedLearnpathSummary {
  /**
   * A UTC timestamp indicating when the activation will occur automatically.
   * @format date-time
   */
  activates_at: string | null
  /**
   * A timezone used solely in the UI to present the scheduled activation date & time.
   * @example "Europe/Warsaw"
   */
  activates_at_tz: string | null
  active: boolean
  can_be_edited_by_caller: boolean
  complete_in: number | null
  /** @format date */
  complete_until: string | null
  /** @format date-time */
  created_at: string
  default_lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  duration: number
  has_been_active: boolean
  /** @format uuid */
  id: string
  is_course: boolean
  lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  languages: (
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  )[]
  link_sharing_active: boolean
  mandatory: boolean
  name: string
  num_items: number
  num_members: number
  num_members_completed: number
  num_members_started: number
  /** @format date-time */
  recurring_date: string | null
  /** @format uuid */
  recurring_draft_id: string | null
  /** @format uuid */
  recurring_id: string | null
  /** @format uuid */
  sharing_link_id: string
  /** @format date-time */
  updated_at: string
}

export interface ManagedLearnpathTextElement {
  body: string | null
  description: string | null
  duration: number
  /** @format uuid */
  id: string
  learning_objectives: (string | null)[]
  order: number
  tags: (string | null)[]
  thumbnail: Thumbnail | null
  title: string | null
  type: string
}

export interface ManagedLearnpathTextElementDeleteForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathTextElementDeleteNotFound {
  message?: 'learnpath.error.learnpath-text-element-not-found'
}

export interface ManagedLearnpathTextElementGetNotFound {
  message?: 'learnpath.error.learnpath-text-element-not-found'
}

export interface ManagedLearnpathTextElementPutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathTextElementPutInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-text-element-integrity-error'
}

export interface ManagedLearnpathTextElementPutNotFound {
  message?: 'learnpath.error.learnpath-text-element-not-found'
}

export interface ManagedLearnpathTextElementPutRequest {
  body?: string
  description?: string | null
  /** @min 1 */
  duration?: number
  learning_objectives?: string[] | null
  tags?: string[] | null
  /** @format uuid */
  thumbnail_id?: string | null
  /** @minLength 1 */
  title?: string
}

export interface ManagedLearnpathTextElementsPostConflict {
  message?: 'learnpath.error.duplicate-learnpath-element-order'
}

export interface ManagedLearnpathTextElementsPostForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathTextElementsPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-text-element-integrity-error'
}

export interface ManagedLearnpathTextElementsPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathTextElementsPostRequest {
  body: string
  /** @default null */
  description?: string | null
  /** @min 1 */
  duration: number
  learning_objectives?: string[] | null
  tags?: string[] | null
  /**
   * @format uuid
   * @default null
   */
  thumbnail_id?: string | null
  /** @minLength 1 */
  title: string
}

export interface ManagedLearnpathToggleLinkSharingActionPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathTranslationsGetNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathTranslationsGetUnprocessableContent {
  message?: 'learnpath.error.learnpath-language-is-default'
}

export interface ManagedLearnpathTranslationsPutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathTranslationsPutNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathTranslationsPutUnprocessableContent {
  message?: 'learnpath.error.learnpath-language-is-default'
}

export interface ManagedLearnpathUserGroup {
  /** @format uuid */
  id: string
  name: string
  num_students: number
}

export interface ManagedLearnpathUserGroups {
  user_groups: ManagedLearnpathUserGroup[]
}

export interface ManagedLearnpathUserGroupsDeleteNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathUserGroupsDeleteRequest {
  /** @minItems 1 */
  user_groups_ids: string[]
}

export interface ManagedLearnpathUserGroupsGetNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathUserGroupsPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-user-group-integrity-error'
}

export interface ManagedLearnpathUserGroupsPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathUserGroupsPostRequest {
  /** @minItems 1 */
  user_groups_ids: string[]
}

export interface ManagedLearnpathUserGroupsPutNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathUserGroupsPutRequest {
  user_groups_ids: string[]
}

export interface ManagedLearnpathVideoElement {
  description: string | null
  /** @format uuid */
  id: string
  learning_objectives: (string | null)[]
  order: number
  tags: (string | null)[]
  thumbnail: Thumbnail | null
  title: string | null
  type: string
  video_upload: LearnpathVideoUpload
}

export interface ManagedLearnpathVideoElementDeleteForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathVideoElementDeleteNotFound {
  message?: 'learnpath.error.learnpath-video-element-not-found'
}

export interface ManagedLearnpathVideoElementGetNotFound {
  message?: 'learnpath.error.learnpath-video-element-not-found'
}

export interface ManagedLearnpathVideoElementPutForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathVideoElementPutInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-video-element-integrity-error'
}

export interface ManagedLearnpathVideoElementPutNotFound {
  message?: 'learnpath.error.learnpath-video-upload-not-found'
}

export interface ManagedLearnpathVideoElementPutRequest {
  description?: string | null
  learning_objectives?: string[] | null
  tags?: string[] | null
  /** @format uuid */
  thumbnail_id?: string | null
  /** @minLength 1 */
  title?: string
  /** @format uuid */
  video_upload_id?: string
}

export interface ManagedLearnpathVideoElementsPostConflict {
  message?: 'learnpath.error.duplicate-learnpath-element-order'
}

export interface ManagedLearnpathVideoElementsPostForbidden {
  message?: 'learnpath.error.restricted-access'
}

export interface ManagedLearnpathVideoElementsPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-video-element-integrity-error'
}

export interface ManagedLearnpathVideoElementsPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathVideoElementsPostRequest {
  /** @default null */
  description?: string | null
  learning_objectives?: string[] | null
  tags?: string[] | null
  /**
   * @format uuid
   * @default null
   */
  thumbnail_id?: string | null
  /** @minLength 1 */
  title: string
  /** @format uuid */
  video_upload_id: string
}

export interface ManagedLearnpaths {
  learnpaths: ManagedLearnpathSummary[]
}

export interface ManagedLearnpathsCompletionBulkStatisticsPostNotFound {
  message?: 'learnpath.error.learnpath-not-found'
}

export interface ManagedLearnpathsCompletionBulkStatisticsPostRequest {
  /** @default true */
  include_deactivated_users?: boolean
  /** @minItems 1 */
  learnpath_ids: string[]
  user_ids?: string[] | null
}

export interface ManagedLearnpathsDeleteRequest {
  ids: string[]
}

export interface ManagedLearnpathsPostForbidden {
  message?: 'learnpath.error.no-user-company'
}

export interface ManagedLearnpathsPostInternalServerError {
  message?: 'learnpath.error.unknown-learnpath-integrity-error'
}

export interface ManagedLearnpathsPostRequest {
  /**
   * A UTC timestamp indicating when the activation will occur automatically.
   * @format date-time
   * @default null
   */
  activates_at?: string | null
  /**
   * A timezone used solely in the UI to present the scheduled activation date & time.
   * @default null
   * @example "Europe/Warsaw"
   */
  activates_at_tz?: string | null
  categories?: string[]
  /**
   * @maxItems 2
   * @minItems 0
   * @default null
   */
  contact_people?: ManagedLearnpathsPostRequestContactPeople[] | null
  default_lang?:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  /**
   * @maxLength 300
   * @default null
   */
  description?: string | null
  /** @default false */
  is_course?: boolean
  isolated_progress?: boolean
  issue_completion_certificate: boolean
  lang?:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt_br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  linear: boolean
  /** @default false */
  mandatory?: boolean
  /**
   * @minLength 1
   * @maxLength 60
   */
  name: string
  notification_flags: ManagedLearnpathNotificationFlags
  /**
   * @min 1
   * @default null
   */
  points?: number | null
  /** @default false */
  restricted_access?: boolean
  /**
   * @format uuid
   * @default null
   */
  thumbnail_id?: string | null
}

export interface ManagedLearnpathsPostRequestContactPeople {
  /** @format email */
  email: string
  fullname: string
  phone?: string
  position?: string
}

export interface ManagedLearnpathsPostUnprocessableContent {
  message?: 'learnpath.error.duplicate-learnpath-name'
}

export interface ManagedPlatformLecture {
  assignable: boolean
  assigned: boolean
  content: PlatformLectureContentOneOf
  duration: number
  has_quiz: boolean
  id: number
  order: number
  title: string
  type: 'video' | 'text' | 'chatbot' | 'scorm'
}

export interface ManagedPlatformTopic {
  author: PlatformAuthor
  duration: number
  id: number
  image_id: string | null
  lectures: ManagedPlatformLecture[]
  locales: (string | null)[]
  num_assigned_lectures: number
  num_lectures: number
  poster_image_id: string | null
  title: string
}

export interface ManagedRecurringLearnpathRelease {
  /** @format date-time */
  activation_date: string | null
  /** @format date-time */
  created_at: string
  /** @format uuid */
  id: string
  mandatory: boolean
  name: string
  release: 'previous' | 'current' | 'next' | 'first'
}

export interface MasterplanUserAttributes {
  /**
   * Number of licenses available.
   * @min 0
   */
  licenses?: number
  /** Masterplan roles parsed to a string, sorted alphabetically, with commas as separators. */
  roles_string?: string
}

export interface MasterplanUserGroupAttributes {
  /** A boolean value indicating if user group is private. */
  is_private?: boolean
  /** Reference to owner of the Group. */
  owner?: UserGroupMember
}

export interface Meta {
  /** @format date-time */
  created: string
  /**
   * @format url
   * @default null
   */
  location?: string | null
  /** @default null */
  resourceType?: string | null
}

export interface Metric {
  data?: Record<string, any>[]
  filters: MetricFilters | null
  metric_name: string
}

export interface MetricCsvGetBadRequest {
  message?: 'analytics.error.metric-not-implemented'
}

export interface MetricCsvGetForbidden {
  message?: 'api.error.forbidden'
}

export interface MetricFilters {
  /** @format uuid */
  company_id: string
  departments?: string[]
  end_date: string
  /** @format date */
  start_date: string
  user_groups?: string[]
  user_state?: string | null
  user_type?: string | null
}

export interface MetricGetBadRequest {
  message?: 'analytics.error.metric-not-implemented'
}

export interface MetricGetForbidden {
  message?: 'api.error.forbidden'
}

export interface NameDetails {
  /**
   * The last name of the User.
   * @default null
   */
  familyName?: string | null
  /**
   * The first name of the User.
   * @default null
   */
  givenName?: string | null
}

export interface NewTopicsChannel {
  progress?: ChannelProgress
  topics?: ChannelTopicsOneOf[]
}

export interface NextLecture {
  image_id?: string
  learning_objectives?: string[]
  progress?: LectureProgress
  slug?: string
  title?: string
  topic?: LectureTopic
  type?: 'video' | 'text' | 'chatbot' | 'scorm'
}

export interface NextLectureNotFound {
  message?: 'progress.error.next-lecture-not-found'
}

export interface NoChannelAccessError {
  message?: 'channel.error.no-channel-access'
}

export interface NoChannelFound {
  message?: 'channel.error.no-channel-found'
}

export interface NoHighlightedTopicFoundError {
  message?: 'channel.error.no-highlighted-topic-found'
}

export interface NotificationHubUserTokenGetResponse {
  notificationhub_user_token: string
}

export interface NotificationHubUserTokenGetUnauthorized {
  message?: 'activity_log.error.signing-key-storage-exception'
}

export interface NotificationsSettingsGetRequest {
  /** @format uuid */
  user_id: string
}

export interface PayloadAudioInputTranscription {
  language?: string | null
  model?: string | null
  prompt?: string | null
}

export interface PayloadRealtimeAudioInput {
  format?: object | null
  noise_reduction?: object | null
  transcription?: PayloadAudioInputTranscription | null
  turn_detection?: object | null
}

export interface PayloadRealtimeAudioOutput {
  format?: object | null
  speed?: number | null
  voice?: string | null
}

export interface PayloadRealtimeClientSecret {
  expires_at?: RealtimeClientSecretPayloadSchemaExpiresAt | null
  session?: PayloadRealtimeSession | null
}

export interface PayloadRealtimeSession {
  audio?: PayloadRealtimeSessionAudio | null
  id?: string | null
  include?: string[] | null
  instructions?: string | null
  max_output_tokens?: number | string
  model?: string | null
  object?: string | null
  output_modalities?: string[]
  prompt?: object | null
  tool_choice?: string | null
  tools?: Record<string, any>[]
  tracing?: string | null
  truncation?: object | string
  type?: string | null
}

export interface PayloadRealtimeSessionAudio {
  input?: PayloadRealtimeAudioInput | null
  output?: PayloadRealtimeAudioOutput | null
}

export interface PersonalChannel {
  progress?: ChannelProgress
  topics?: ChannelTopicsOneOf[]
}

export interface PlatformAuthor {
  company_name: string
  fullname: string
  image_id: string
}

export interface PlatformLecture {
  assignable: boolean
  content: PlatformLectureContentOneOf
  duration: number
  has_quiz: boolean
  id: number
  order: number
  title: string
  type: 'video' | 'text' | 'chatbot' | 'scorm'
}

export interface PlatformLectureChatbotContent {
  goal: string
  name: string
}

export type PlatformLectureContentOneOf =
  | ({
      type: 'chatbot'
    } & PlatformLectureChatbotContent)
  | ({
      type: 'scorm'
    } & PlatformLectureScormContent)
  | ({
      type: 'text'
    } & PlatformLectureTextContent)
  | ({
      type: 'video'
    } & PlatformLectureVideoContent)

export interface PlatformLectureScormContent {
  launch_file_url: string | null
}

export interface PlatformLectureTextContent {
  text: string | null
}

export interface PlatformLectureVideoContent {
  /** @format url */
  video_url: string
}

export interface PlatformTopic {
  author: PlatformAuthor
  id: number
  image_id: string | null
  lectures: PlatformLecture[]
  locales: (string | null)[]
  num_lectures: number
  poster_image_id: string | null
  title: string
}

export interface PlatformTopicsFilter {
  count: number
  selected: boolean
  value: string
}

export interface PlatformTopicsFilters {
  content_types: PlatformTopicsFilter[]
  locales: PlatformTopicsFilter[]
  tags: PlatformTopicsFilter[]
}

export interface Poll {
  /** @format uuid */
  id?: string
  is_completed: boolean
  sections?: PollSection[]
  text?: string
  title?: string
}

export interface PollGetNotFound {
  message?: 'poll.error.poll-not-found'
}

export type PollQuestion =
  | ({
      type: 'bool'
    } & BoolPollQuestion)
  | ({
      type: 'choose'
    } & ChoosePollQuestion)
  | ({
      type: 'free_text'
    } & FreeTextPollQuestion)
  | ({
      type: 'rate'
    } & RatePollQuestion)

export interface PollResults {
  answers: Record<string, any>
}

export interface PollResultsPostNotFound {
  message?: 'poll.error.poll-not-found'
}

export interface PollResultsPostUnprocessableEntity {
  message?:
    | 'poll.error.poll-already-submitted'
    | 'poll.error.poll-answer-incorrect-value'
}

export interface PollSection {
  /** @format uuid */
  id?: string
  order?: number
  questions?: PollQuestion[]
  title?: string
}

export interface PresignedPostFields {
  /** @example "private" */
  acl:
    | 'private'
    | 'public-read'
    | 'public-read-write'
    | 'aws-exec-read'
    | 'authenticated-read'
    | 'bucket-owner-read'
    | 'bucket-owner-full-control'
  /** @example "image/jpeg" */
  content_type?: string
  /** @example "4b77986d-097b-4b6b-9e1c-deccb7916f8c/ded32309-efe6-4199-8103-15ea94e71b66" */
  key: string
  /** @example "eyJmb28iOiAiZXhhbXBsZSIsICJiYXIiOiAxfQ==" */
  policy: string
  /** @example "AWS4-HMAC-SHA256" */
  x_amz_algorithm: string
  /** @example "3CHR6ESB2EA8GECMI2JX/20220929/eu-central-1/s3/aws4_request" */
  x_amz_credential: string
  /** @example "20220929T122242Z" */
  x_amz_date: string
  /** @example "jR%2BSpt6Vwp%2F5eA%3D%3D" */
  x_amz_security_token: string
  /** @example "07ef2ea82d5af1d603cef07f5ee807a6edfed0263e43e594848a5bf88257da67" */
  x_amz_signature: string
}

export interface PresignedPostForFileUpload {
  fields: PresignedPostFields
  /**
   * @format url
   * @example "https://s3.eu-central-1.amazonaws.com/masterplan-learnpath-uploads-dev"
   */
  url: string
}

export interface Progress {
  meta?: Record<string, any>
  status?: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
  total_score?: number
}

export interface ProgressPutConflict {
  message?: 'lecture.error.progress-update-conflict'
}

export interface ProgressPutForbidden {
  message?: 'lecture.error.lecture-locked'
}

export interface ProgressPutNotFound {
  message?: 'lecture.error.lecture-not-found'
}

export interface ProgressPutRequest {
  meta?: object | null
  status?: string
}

export interface ProgressPutUnprocessableEntity {
  message?: 'lecture.error.progress-no-update'
}

export interface PublicCourse {
  course_type: 'topic' | 'learnpath' | 'company_course'
  /** @format uuid */
  id: string
  versions: CourseVersion[]
}

export interface PublicCoursesList {
  courses: PublicCourse[] | null
  meta: PublicCoursesListMeta
}

export interface PublicCoursesListMeta {
  /** @format url */
  next_page_url: string | null
  page: number
  /** @format url */
  prev_page_url: string | null
  size: number
  total: number
}

export interface Quiz {
  color?: string
  id: number
  max_score?: number
  num_questions?: any
  progress?: QuizProgress
}

export interface QuizAnswer {
  /** @format uuid */
  id?: string
  image_id?: string
  text?: string
}

export interface QuizAnsweredQuestion {
  attempt?: number
  correct_answers_ids?: any
  skipped?: boolean
}

export interface QuizGetForbidden {
  message?: 'lecture.error.lecture-locked' | 'lecture.error.quiz-locked'
}

export interface QuizGetNotFound {
  message?: 'lecture.error.lecture-not-found' | 'lecture.error.quiz-not-found'
}

export interface QuizProgress {
  answered_questions?: Record<string, QuizAnsweredQuestion>
  can_skip_current_question?: boolean
  completed?: boolean
  current_answers_hints?: Record<string, any>
  current_attempt?: number
  current_question?: QuizQuestion
  current_question_hint?: string
  num_answered_questions?: number
  total_score?: number
}

export interface QuizPutForbidden {
  message?: 'lecture.error.lecture-locked' | 'lecture.error.quiz-locked'
}

export interface QuizPutNotFound {
  message?: 'lecture.error.lecture-not-found' | 'lecture.error.quiz-not-found'
}

export interface QuizPutRequest {
  /** @default [] */
  answers_ids?: string[]
  /** @format uuid */
  question_id: string
  /** @default false */
  skip?: boolean
}

export interface QuizPutUnprocessableEntity {
  message?:
    | 'lecture.error.quiz-not-current-question'
    | 'lecture.error.quiz-question-already-answered'
    | 'lecture.error.quiz-question-not-yet-skippable'
}

export interface QuizQuestion {
  answers?: QuizAnswer[]
  /** @format uuid */
  id?: string
  image_id?: string
  scoring?: number[]
  text?: string
  type?:
    | 'choose_many_from_many'
    | 'choose_many_from_many_stepwise'
    | 'choose_one_from_many'
    | 'order_all'
    | 'order_many_from_many'
}

export interface QuizStep {
  correct?: boolean
}

export interface QuizStepPutForbidden {
  message?: 'lecture.error.lecture-locked' | 'lecture.error.quiz-locked'
}

export interface QuizStepPutNotFound {
  message?: 'lecture.error.lecture-not-found' | 'lecture.error.quiz-not-found'
}

export interface QuizStepPutRequest {
  /** @format uuid */
  answer_id: string
  answer_value: boolean
  /** @format uuid */
  question_id: string
}

export interface QuizStepPutUnprocessableEntity {
  message?: 'lecture.error.quiz-not-current-question'
}

export interface RatePollQuestion {
  /** @format uuid */
  id?: string
  max_label?: string
  max_value?: number
  min_label?: string
  min_value?: number
  optional?: boolean
  optional_label?: string
  order?: number
  text?: string
  type?: string
}

export interface RealmRolePost {
  action: 'CREATE' | 'DELETE'
  name: string
}

export interface RealtimeAudioInput {
  format: Record<string, any>
  /** @default null */
  noise_reduction?: object | null
  /** @default null */
  transcription?: AudioInputTranscription | null
  turn_detection: Record<string, any>
}

export interface RealtimeAudioOutput {
  format: Record<string, any>
  speed: number
  voice: string
}

export interface RealtimeClientSecret {
  expires_at: number
  session: RealtimeSession
  value: string
}

export interface RealtimeClientSecretPayloadSchemaExpiresAt {
  anchor?: string | null
  seconds?: number | null
}

export interface RealtimeSession {
  audio: RealtimeSessionAudio
  id: string
  /** @default null */
  include?: string[] | null
  instructions: string
  max_output_tokens: number | string
  model: string
  object: string
  output_modalities?: string[]
  /** @default null */
  prompt?: object | null
  tool_choice: string
  tools?: Record<string, any>[]
  /** @default null */
  tracing?: string | null
  truncation: object | string
  type: string
}

export interface RealtimeSessionAudio {
  input: RealtimeAudioInput
  output: RealtimeAudioOutput
}

export interface RealtimeSessionPayload {
  client_secret?: PayloadRealtimeClientSecret
}

export interface Reminder {
  day_of_week?: string
  /** @format date-time */
  first_event?: string
  /** @format uuid */
  id?: string
  time?: string
  type?: string
  /** @format uuid */
  user_id?: string
}

export interface ResourceType {
  description: string
  endpoint: string
  id: string
  /** @default null */
  meta?: Meta | null
  name: string
  schema: string
  schemaExtensions?: _SchemaExtension[]
  schemas?: string[]
}

export interface ResourcesTypes {
  Resources: ResourceType[] | null
  itemsPerPage: number
  schemas?: string[]
  startIndex: number
  totalResults: number
}

export interface SCIMSchemaGetNotFound {
  message?: 'Resource not found'
}

export interface SCIMTypeGetNotFound {
  message?: 'Resource not found'
}

export interface SCIMUserDeleteBadRequest {
  message?: 'Insufficient permissions to perform this action.'
}

export interface SCIMUserDeleteInternalServerError {
  message?: 'Server error.'
}

export interface SCIMUserDeleteNotFound {
  message?: 'Resource not found'
}

export interface SCIMUserGetNotFound {
  message?: 'Resource not found'
}

export interface SCIMUserGroupDeleteBadRequest {
  message?: 'Insufficient permissions to perform this action.'
}

export interface SCIMUserGroupDeleteNotFound {
  message?: 'Resource not found'
}

export interface SCIMUserGroupGetNotFound {
  message?: 'Resource not found'
}

export interface SCIMUserGroupPatchBadRequest {
  message?: 'Insufficient permissions to perform this action.'
}

export interface SCIMUserGroupPatchNotFound {
  message?: 'Resource not found'
}

export interface SCIMUserGroupPutBadRequest {
  message?: 'Insufficient permissions to perform this action.'
}

export interface SCIMUserGroupPutNotFound {
  message?: 'Resource not found'
}

export interface SCIMUserGroupsGetBadRequest {
  message?: 'Invalid filters.'
}

export interface SCIMUserGroupsPostBadRequest {
  message?: 'There is already resource with this name.'
}

export interface SCIMUserPatchBadRequest {
  message?: 'Insufficient permissions to perform this action.'
}

export interface SCIMUserPatchInternalServerError {
  message?: 'Server error.'
}

export interface SCIMUserPatchNotFound {
  message?: 'Resource not found'
}

export interface SCIMUserPutBadRequest {
  message?: 'Company owner cannot have manager.'
}

export interface SCIMUserPutInternalServerError {
  message?: 'Server error.'
}

export interface SCIMUserPutNotFound {
  message?: 'Resource not found'
}

export interface SCIMUsersGetBadRequest {
  message?: 'Invalid filters.'
}

export interface SCIMUsersLegacyGetBadRequest {
  message?: 'Invalid filters.'
}

export interface SCIMUsersPostBadRequest {
  message?: 'Insufficient permissions to perform this action.'
}

export interface SCIMUsersPostInternalServerError {
  message?: 'Server error.'
}

export interface SCIMUsersPostNotFound {
  message?: 'Manager not found'
}

export interface SchemaDetails {
  attributes: _Attribute[]
  description: string
  id: string
  meta: Meta
  name: string
  schemas?: string[]
}

export interface SchemaNotFound {
  message?: 'json_schema.error.schema-not-found'
}

export interface SchemasDetails {
  Resources?: SchemaDetails[]
  itemsPerPage: number
  schemas?: string[]
  startIndex: number
  totalResults: number
}

export interface Score {
  fundamental_score?: FundamentalScore
  last_score?: number
  learning_objective?: ScoreLearningObjective
  total_score?: number
}

export interface ScoreLearningObjective {
  score?: number
  target?: number
}

export interface ScormAuthPostRequest {
  /** @format uuid */
  client_id: string
  /** @default null */
  location_hash?: string | null
  /** @minLength 1 */
  student_id: string
}

export interface ScormAuthPostUnprocessableContent {
  message?: 'scorm.error.invalid-client'
}

export interface ScormClient {
  /** @format uuid */
  client_id: string
  enabled: boolean
}

export interface ScormClientGetUnprocessableContent {
  message?: 'scorm.error.company-has-no-scorm-client-assigned'
}

export interface ScormCompany {
  name: string
}

export interface ScormEmailPutForbidden {
  message?: 'api.error.forbidden'
}

export interface ScormEmailPutInternalServerError {
  message?: 'user.error.failed-to-send-verification-email'
}

export interface ScormEmailPutNotFound {
  message?: 'user.error.user-not-found'
}

export interface ScormEmailPutUnprocessableContent {
  message?: 'user.error.email-already-set'
}

export interface ScormEmailUpdatePut {
  /** @format email */
  email: string
}

export interface ScormInit {
  location_hash?: string
}

export interface ScormInitPostRequest {
  /** @format uuid */
  client_id: string
}

export interface ScormInitPostUnprocessableContent {
  message?: 'scorm.error.invalid-client'
}

export interface ScormPackage {
  archived: boolean
  company: ScormCompany
  /** @format date-time */
  created_at: string
  description: string | null
  duration: number
  /** @format uuid */
  id: string
  status: 'active' | 'error' | 'pending'
  status_details: object | null
  /** The filename of the .zip package is used if there's no title set. */
  title: string | null
  uri: string | null
  works_on_mobile: boolean
}

export interface ScormPackageDeleteForbidden {
  message?: 'scorm.error.package-not-available-for-selected-company'
}

export interface ScormPackageDeleteInternalServerError {
  message?: 'scorm.error.package-integrity-error'
}

export interface ScormPackageDeleteNotFound {
  message?: 'scorm.error.package-not-found'
}

export interface ScormPackageGetForbidden {
  message?: 'scorm.error.package-not-available-for-selected-company'
}

export interface ScormPackageGetNotFound {
  message?: 'scorm.error.package-not-found'
}

export interface ScormPackageLambdaPostNotFound {
  message?: 'scorm.error.package-not-found'
}

export interface ScormPackageLambdaPostRequest {
  description?: string | null
  duration?: number | null
  launch_file?: string
  original_filename?: string | null
  /** @format uuid */
  package_id: string
  /** @default "active" */
  status?: 'active' | 'error' | 'pending'
  status_details?: object | null
  /** @minLength 1 */
  title?: string
  uri?: string
}

export interface ScormPackagePostInternalServerError {
  message?: 'scorm.error.package-integrity-error'
}

export interface ScormPackagePostRequest {
  bytes?: number
  /**
   * @minLength 1
   * @maxLength 255
   */
  filename?: string
  /**
   * @min 1
   * @max 2147483647
   */
  filesize?: number
  /** @minLength 1 */
  title?: string
}

export interface ScormPackagePutForbidden {
  message?: 'scorm.error.package-not-available-for-selected-company'
}

export interface ScormPackagePutNotFound {
  message?: 'scorm.error.package-not-found'
}

export interface ScormPackagePutRequest {
  archived?: boolean
  description?: string | null
  duration?: number | null
  /** @minLength 1 */
  title?: string
  uri?: string | null
}

export interface ScormPackageWithPayload {
  archived: boolean
  company: ScormCompany
  /** @format date-time */
  created_at: string
  description: string | null
  duration: number
  /** @format uuid */
  id: string
  payload: PresignedPostForFileUpload
  status: 'active' | 'error' | 'pending'
  status_details: object | null
  /** The filename of the .zip package is used if there's no title set. */
  title: string | null
  uri: string | null
  works_on_mobile: boolean
}

export interface ScormPackages {
  packages?: ScormPackage[]
}

export interface ScormState {
  completion_status: 'completed' | 'incomplete' | 'not_attempted' | 'unknown'
  score_raw: number | null
  score_scaled: number | null
  success_status: 'passed' | 'failed' | 'unknown'
  suspend_data: string | null
}

export interface ScormStateGetForbidden {
  message?: 'scorm.error.package-not-available-for-selected-company'
}

export interface ScormStateGetNotFound {
  message?: 'scorm.error.package-not-found'
}

export interface ScormStatePostForbidden {
  message?: 'scorm.error.package-not-available-for-selected-company'
}

export interface ScormStatePostInternalServerError {
  message?: 'scorm.error.scorm-state-integrity-error'
}

export interface ScormStatePostNotFound {
  message?: 'scorm.error.package-not-found'
}

export interface ScormStatePostRequest {
  completion_status?: 'completed' | 'incomplete' | 'not_attempted' | 'unknown'
  score_raw?: number
  score_scaled?: number
  success_status?: 'passed' | 'failed' | 'unknown'
  /** @maxLength 64000 */
  suspend_data?: string
}

export interface SearchResultsSchemaV2 {
  topics?: TopicSearchResultV2[]
}

export interface SearchV2GetUnprocessableContent {
  message?: 'search.error.invalid-search-parameters'
}

export interface SearchedUser {
  /** @format uuid */
  company_id: string
  /** @format uuid */
  global_user_id: string
  /** @format uuid */
  id: string
  is_no_email_user: boolean
  status: 'active' | 'pending' | 'deactivated'
  user_identity: SearchedUserIdentity
}

export interface SearchedUserIdentity {
  /** @format email */
  email: string | null
  first_name: string | null
  last_name: string | null
  no_email_user_id: string | null
}

export interface SelfInviteLink {
  background_image_id?: string
  /** @format url */
  background_video_url?: string
  company?: InviteCompany
  /** @format url */
  custom_privacy_policy_url?: string
  description?: string
  /** @format uuid */
  id?: string
  title?: string
}

export interface SelfInviteLinkGetNotFound {
  message?: 'invite.error.self-invite-link-not-found'
}

export interface SelfInvitePostInternalError {
  message?: 'invite.error.unknown-invite-integrity-error'
}

export interface SelfInvitePostNotFound {
  message?: 'invite.error.self-invite-link-not-found'
}

export interface SelfInvitePostRequest {
  /** @format email */
  email: string
  /** @format uuid */
  id: string
}

export interface SelfInvitePostUnprocessableEntity {
  message?:
    | 'invite.error.user-already-exists'
    | 'invite.error.exhausted-user-invite-limit'
    | 'invite.error.company-email-domains-mismatch'
}

export interface ServiceProviderConfig {
  bulk: Record<string, any>
  changePassword: Record<string, any>
  /** @format url */
  documentationUri: string
  etag: Record<string, any>
  filter: Record<string, any>
  meta: Meta
  patch: Record<string, any>
  schemas: string[]
  sort: Record<string, any>
}

export interface SignatureCourse {
  excerpt?: string
  id?: number
  logos?: string[]
  max_score?: number
  num_lectures?: number
  num_trial_lectures?: number
  post_completion_poll?: CoursePoll
  pre_start_poll?: CoursePoll
  progress?: CourseProgress
  slug?: string
  themes?: Theme[]
  title?: string
}

export interface SignatureCourseTopic {
  author?: CourseTopicAuthor
  background_color_1: string | null
  background_color_2: string | null
  background_image_id: string | null
  /** @format url */
  background_video_url?: string
  captions_langs: string[] | null
  course_order?: number
  difficulty?: number
  duration?: any
  excerpt?: string
  id: number
  image_id?: string
  locales?: string[]
  max_score?: number
  num_lectures?: number
  order?: number
  original_lang: string[] | null
  poster_image_id?: string
  poster_image_mobile_id?: string
  progress?: CourseTopicProgress
  slug?: string
  tags?: string[]
  title?: string
  voiceover_langs: string[] | null
}

export interface SignupPollGetNotFound {
  message?: 'poll.error.poll-not-found'
}

export interface SimpleChannels {
  channels?: SimpleSingleChannel[]
}

export interface SimpleSingleChannel {
  slug?: string
  title?: string
}

export interface SingleChannel {
  color?: string
  progress?: ChannelProgress
  slug?: string
  title?: string
  topics?: ChannelTopicsOneOf[]
}

export interface Skill {
  color: string
  current_level: number
  /** @format uuid */
  id: string
  image_id: string | null
  is_current: boolean
  name: string
  slug: string
  video_id: string | null
}

export interface SkillAssessmentPollGetForbidden {
  message?: 'poll.error.uncompleted-previous-skill-assessment-step'
}

export interface SkillAssessmentPollGetNotFound {
  message?: 'poll.error.poll-not-found'
}

export interface SkillAssessmentPollGetUnprocessableEntity {
  message?: 'poll.error.unknown-skill-assessment-step'
}

export interface SkillGetNotFound {
  message?: 'skills.error.current-skill-not-set'
}

export interface SkillList {
  skills: Skill[]
}

export interface SkillNodeWithProgress {
  /** @format uuid */
  id: string
  name: string
  num_available_topics: number
  num_completed_topics: number
  num_points: number
  num_total_points: number
  slug: string
}

export interface SkillNodeWithTopics {
  /** @format uuid */
  id: string
  name: string
  nodes: SkillNodeWithTopics[] | null
  nodes_label: string | null
  slug: string
  topics: SkillTreeTopic[] | null
}

export interface SkillProgress {
  current_level: number
  nodes: SkillNodeWithProgress[]
  nodes_label: string
  points_to_next_level: number | null
}

export interface SkillProgressGetNotFound {
  message?: 'skills.error.skill-not-found'
}

export interface SkillTopics {
  nodes: SkillNodeWithTopics[]
  nodes_label: string
}

export interface SkillTopicsGetNotFound {
  message?: 'skills.error.skill-not-found'
}

export interface SkillTreeTopic {
  fundamental: boolean
  has_chatbot_lecture: boolean
  id: number
  image_id: string | null
  num_lectures: number
  poster_image_id: string | null
  progress: SkillTreeTopicProgress
  slug: string
  title: string
}

export interface SkillTreeTopicProgress {
  num_completed_lectures: number
  status: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
}

export interface Status {
  status?: 'ok' | 'error'
}

export interface SupportPerson {
  email: string
  gender: 'female' | 'male'
  name: string
  phone: string | null
  picture_id: string
}

export interface Theme {
  color?: string
  num_topics?: number
  order?: number
  progress?: ThemeProgress
  slug?: string
  title?: string
  topics?: SignatureCourseTopic[]
}

export interface ThemeProgress {
  num_completed_topics?: number
  status?: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
}

export interface Thumbnail {
  /**
   * @minLength 1
   * @maxLength 255
   * @example "example.jpg"
   */
  filename: string | null
  /**
   * @min 1
   * @max 2147483647
   */
  filesize: number | null
  /** @format uuid */
  id: string
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  url: string | null
}

export interface ThumbnailDeleteNotFound {
  message?: 'media.error.thumbnail-not-found'
}

export interface ThumbnailGetNotFound {
  message?: 'media.error.thumbnail-not-found'
}

export interface ThumbnailGetResponse {
  /**
   * @minLength 1
   * @maxLength 255
   * @example "example.jpg"
   */
  filename: string
  /**
   * @min 1
   * @max 2147483647
   */
  filesize: number
  /** @format uuid */
  id: string
  status: 'initiated' | 'uploaded' | 'available'
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  url: string | null
}

export interface ThumbnailPutNotFound {
  message?: 'media.error.thumbnail-not-found'
}

export interface ThumbnailPutRequest {
  status: string
}

export interface ThumbnailPutResponse {
  /**
   * @minLength 1
   * @maxLength 255
   * @example "example.jpg"
   */
  filename: string
  /**
   * @min 1
   * @max 2147483647
   */
  filesize: number
  /** @format uuid */
  id: string
  status: 'initiated' | 'uploaded' | 'available'
  /**
   * @format url
   * @example "https://img.masterplan-stage.com/path/to/image?exp=expiration-time&sig=signature"
   */
  url: string | null
}

export interface ThumbnailsPostRequest {
  /**
   * @minLength 1
   * @maxLength 255
   * @example "example.jpg"
   */
  filename: string
  /**
   * @min 1
   * @max 2147483647
   */
  filesize: number
}

export interface ThumbnailsPostResponse {
  /** @format uuid */
  id: string
  payload: PresignedPostForFileUpload
}

export interface Tokens {
  access_token?: string
  refresh_token?: string
}

export interface Topic {
  author?: TopicAuthor
  average_rating?: number
  background_color_1?: string
  background_color_2?: string
  background_image_id?: string
  captions_langs: string[] | null
  difficulty?: number
  duration?: any
  excerpt?: string
  /** @format uuid */
  external_id: string
  highlighted?: boolean
  id?: number
  image_id?: string
  is_announcement?: boolean
  is_internal?: boolean
  /** @format url */
  launch_link_url?: string
  lectures?: TopicLecture[]
  locales?: string[]
  max_score?: number
  num_lectures?: number
  original_lang: string[] | null
  poster_image_id?: string
  poster_image_mobile_id?: string
  progress?: TopicProgress
  slug?: string
  tags?: string[]
  title?: string
  type?: 'course' | 'channel'
  voiceover_langs: string[] | null
}

export interface TopicAuthor {
  company_name?: string
  fullname?: string
  image_id?: string
}

export interface TopicGetForbidden {
  message?: 'topic.error.topic-locked'
}

export interface TopicGetNotFound {
  message?: 'topic.error.topic-not-found'
}

export interface TopicLecture {
  bookmarked?: boolean
  duration?: any
  image_id?: string
  order?: number
  progress?: TopicLectureProgress
  short_description?: string
  slug?: string
  title?: string
  type?: 'video' | 'text' | 'chatbot' | 'scorm'
  /** @format uuid */
  uid?: string
}

export interface TopicLectureProgress {
  meta?: Record<string, any>
  status?: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
}

export interface TopicProgress {
  /** @format date-time */
  completed_at?: string
  num_completed_lectures?: number
  status?: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
  total_score?: number
}

export interface TopicSearchItemAuthor {
  company_name?: string
  fullname?: string
  image_id?: string
}

export interface TopicSearchResultV2 {
  author?: TopicSearchItemAuthor
  captions_langs: string[] | null
  duration?: any
  id: number
  image_id?: string
  num_lectures?: number
  original_lang: string[] | null
  parent_slug?: string
  poster_image_id?: string
  slug?: string
  title?: string
  voiceover_langs: string[] | null
}

export interface TransferLicenses {
  /** @format uuid */
  giver_user_id: string
  /** @min 1 */
  licenses: number
  /** @format uuid */
  receiver_user_id: string
}

export interface TransferLicensesForbidden {
  message?: 'api.error.forbidden'
}

export interface TransferLicensesInsufficientNumberOfLicensesToTransfer {
  message?: 'user.error.insufficient-number-of-licenses-to-transfer'
}

export interface TransferLicensesInvalidNumberOfLicenses {
  message?: 'user.error.invalid-number-of-licenses'
}

export interface TransferLicensesUserNotFound {
  message?: 'user.error.user-not-found'
}

export interface UnprotectedUserConsentsGetNotFound {
  message?: 'user.error.user-not-found'
}

export interface UnprotectedUserConsentsPutNotFound {
  message?: 'user.error.user-not-found'
}

export interface User {
  /** @format url */
  avatar_url: string | null
  can_be_deleted_by_caller: boolean
  can_be_managed_by_caller: boolean
  /** @format uuid */
  company_id: string
  department: Department | null
  /** @format uuid */
  global_user_id: string
  /** @format uuid */
  id: string
  /** @format date */
  invited_at: string
  is_no_email_user: boolean
  license_provider: BaseUser | null
  licenses: Licenses
  /** @format date-time */
  no_email_user_password_reset_at: string | null
  roles: (
    | 'admin'
    | 'owner'
    | 'company_administrator'
    | 'public_api_client'
    | 'manager'
    | 'content_creator'
    | 'student'
  )[]
  settings: UserSettings
  status: 'active' | 'pending' | 'deactivated'
  user_identity: UserIdentity
}

export interface UserAssignedGroupsDeleteForbidden {
  message?: 'api.error.forbidden'
}

export interface UserAssignedGroupsDeleteNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserAssignedGroupsDeleteRequest {
  /** @maxItems 50 */
  user_groups_ids: string[]
}

export interface UserAssignedGroupsDeleteResult {
  errors: Record<string, string>
}

export interface UserAssignedGroupsGetForbidden {
  message?: 'api.error.forbidden'
}

export interface UserAssignedGroupsGetNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserAssignedGroupsPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UserAssignedGroupsPostNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserAssignedGroupsPostRequest {
  /** @maxItems 50 */
  user_groups_ids: string[]
}

export interface UserAssignedGroupsResult {
  errors: Record<string, string>
}

export interface UserConsents {
  enabled_notifications?: string[]
}

export interface UserConsentsGetNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserConsentsRequest {
  enabled_notifications:
    | 'general_news'
    | 'content_updates'
    | 'platform_updates'
    | 'personal_recommendations'
    | 'system_notifications'
}

export interface UserCreatePayload {
  /**
   * @maxItems 1
   * @minItems 1
   */
  emails: _EmailDetails[]
  name?: NameDetails
  /**
   * @maxItems 1
   * @minItems 1
   * @default null
   */
  phoneNumbers?: _PhoneNumber[]
  /** @default null */
  preferredLanguage?: string | null
  /** @default ["student"] */
  roles?: (
    | 'admin'
    | 'owner'
    | 'company_administrator'
    | 'public_api_client'
    | 'manager'
    | 'content_creator'
    | 'student'
  )[]
  /**
   * @maxItems 3
   * @minItems 1
   */
  schemas: (
    | 'urn:masterplan:scim:UserAttributes'
    | 'urn:ietf:params:scim:schemas:core:2.0:User'
    | 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User'
  )[]
  /** @default null */
  title?: 'mr' | 'mrs' | 'mx' | null
  'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User'?: _UserExtension
  'urn:masterplan:scim:UserAttributes'?: _MasterplanUserAttributes
  /** @default null */
  userType?: string | null
}

export interface UserDeactivationPostBadRequest {
  message?: 'user.error.user-already-deactivated'
}

export interface UserDeactivationPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UserDeactivationPostInternalServerError {
  message?: 'user.error.failed-to-update-user-in-iam'
}

export interface UserDeactivationPostNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserDeleteForbidden {
  message?: 'api.error.forbidden'
}

export interface UserDeleteNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserDeleteUnprocessableContent {
  message?: 'user.error.failed-to-delete-user-in-iam'
}

export interface UserDepartmentsDelete {
  /** @format uuid */
  department_id: string
}

export interface UserDepartmentsDeleteForbidden {
  message?: 'api.error.forbidden'
}

export interface UserDepartmentsDeleteNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserDepartmentsPut {
  /** @format uuid */
  department_id: string
}

export interface UserDepartmentsPutForbidden {
  message?: 'api.error.forbidden'
}

export interface UserDepartmentsPutNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserDetails {
  /**
   * Value indicating the user's status.
   * @default null
   */
  active?: boolean | null
  /**
   * User's email addresses.Currently only one email per user is stored.
   * @default null
   */
  emails?: _EmailDetails1[] | null
  /**
   * A String that is an identifier for the resource as defined by the provisioning client.
   * @format uuid
   * @default null
   */
  externalId?: string | null
  /**
   * A unique identifier for a SCIM resource as defined by the service provider.
   * @format uuid
   */
  id: string
  /** @default null */
  meta?: Meta | null
  /**
   * The components of the user's real name.
   * @default null
   */
  name?: NameDetails | null
  /**
   * User's phone numbers.Currently only one email per user is stored.
   * @default null
   */
  phoneNumbers?: _PhoneNumberDetails[] | null
  /**
   * Preferred language by the user.
   * @default null
   */
  preferredLanguage?: string | null
  /**
   * List of Users roles.
   * @default null
   */
  roles?:
    | (
        | 'admin'
        | 'owner'
        | 'company_administrator'
        | 'public_api_client'
        | 'manager'
        | 'content_creator'
        | 'student'
      )[]
    | null
  schemas?: string[]
  /**
   * Title of the user.
   * @default null
   */
  title?: string | null
  /** @default null */
  'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User'?: UserExtension | null
  /** @default null */
  'urn:masterplan:scim:UserAttributes'?: MasterplanUserAttributes | null
  /**
   * Unique identifier of user in Masterplan.
   * @default null
   */
  userName?: string | null
  /**
   * Job title of the user.
   * @default null
   */
  userType?: string | null
}

export interface UserExtension {
  /**
   * Identifies the name of a user's department.
   * @default null
   */
  department?: string | null
  /**
   * Numeric or alphanumeric identifier assigned to a person, typically based on order of hire or association with an organization.
   * @default null
   */
  employeeNumber?: string | null
  /** The User's manager.  A complex type that             optionally allows service providers to represent organizational             hierarchy by referencing the 'id' attribute of another User. */
  manager?: LicenseProvider
}

export interface UserFaqPostRequest {
  /** @format email */
  email: string
  question: string
}

export interface UserFeature {
  enabled: boolean
}

export interface UserFeatureGetUnauthorized {
  message?: 'api.error.unauthorized'
}

export interface UserFeedback {
  reason?: string
  recommendation?: number
  relevance?: number
}

export interface UserFeedbackGetForbidden {
  message?: 'lecture.error.lecture-locked'
}

export interface UserFeedbackGetNotFound {
  message?:
    | 'lecture.error.lecture-not-found'
    | 'lecture.error.user-feedback-not-found'
}

export interface UserFeedbackPostForbidden {
  message?:
    | 'lecture.error.lecture-locked'
    | 'lecture.error.user-feedback-disabled'
}

export interface UserFeedbackPostNotFound {
  message?: 'lecture.error.lecture-not-found'
}

export interface UserFeedbackPostRequest {
  /** @default null */
  reason?: string | null
  /**
   * @min 0
   * @max 10
   * @default null
   */
  recommendation?: number | null
  /**
   * @min 0
   * @max 5
   * @default null
   */
  relevance?: number | null
}

export interface UserFeedbackPostUnprocessableEntity {
  message?: 'lecture.error.user-feedback-already-given'
}

export interface UserFeedbackPostUnprocessableEntity1 {
  message?:
    | 'lecture.error.user-feedback-empty'
    | 'lecture.error.lecture-not-viewed'
    | 'lecture.error.user-feedback-already-given'
}

export interface UserFeedbackPutForbidden {
  message?: 'lecture.error.lecture-locked'
}

export interface UserFeedbackPutNotFound {
  message?:
    | 'lecture.error.lecture-not-found'
    | 'lecture.error.user-feedback-not-found'
}

export interface UserFeedbackPutRequest {
  reason: string
}

export interface UserGetUserNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserGroup {
  /** @format date-time */
  created_at?: string
  creator?: UserGroupCreator
  /** @format uuid */
  id?: string
  is_private?: boolean
  name?: string
  num_students?: number
  total_members?: number
}

export interface UserGroupCandidates {
  candidates: BaseUser[]
  total_candidates: number
}

export interface UserGroupCandidatesGetForbidden {
  message?: 'api.error.forbidden'
}

export interface UserGroupCandidatesGetNotFound {
  message?: 'user.error.user-group-not-found'
}

export interface UserGroupCandidatesGetUnprocessableContent {
  message?: 'user.error.query-too-short'
}

export interface UserGroupCreateUpdatePayload {
  displayName: string
  members?: _MemberValue[]
  /**
   * @maxItems 2
   * @minItems 1
   */
  schemas: (
    | 'urn:masterplan:scim:UserGroupAttributes'
    | 'urn:ietf:params:scim:schemas:core:2.0:Group'
  )[]
  'urn:masterplan:scim:UserGroupAttributes'?: MasterplanUserGroupAttributes
}

export interface UserGroupCreated {
  /** @format uuid */
  user_group_id?: string
}

export interface UserGroupCreator {
  /** @format email */
  email?: string
  /** @format uuid */
  user_id?: string
}

export interface UserGroupDetails {
  /** A human-readable name for the Group */
  displayName: string
  /**
   * A unique identifier for a SCIM resource as defined by the service provider.
   * @format uuid
   */
  id: string
  /** A list of members of the Group. */
  members?: UserGroupMember[]
  /** @default null */
  meta?: Meta | null
  schemas?: string[]
  'urn:masterplan:scim:UserGroupAttributes'?: MasterplanUserGroupAttributes
}

export interface UserGroupList {
  total_user_groups: number
  user_groups?: UserGroup[]
}

export interface UserGroupLookup {
  /** @format uuid */
  id: string
  name: string
}

export interface UserGroupMember {
  /** The URI corresponding to a SCIM resource that is a member of this Group. */
  $ref?: string
  /** A label indicating the type of resource */
  type?: string
  /** Identifier of the member of this Group. */
  value?: string
}

export interface UserGroupMemberList {
  members?: BaseUser[]
}

export interface UserGroupMembersBulkDeleteForbidden {
  message?: 'api.error.forbidden'
}

export interface UserGroupMembersBulkDeleteNotFound {
  message?: 'user.error.user-group-not-found'
}

export interface UserGroupMembersBulkDeleteRequest {
  /** @format uuid */
  user_group_id: string
  users_ids: string[]
}

export interface UserGroupMembersBulkDeleteUnprocessableContent {
  message?: 'user.error.members-limit-exceeded'
}

export interface UserGroupMembersBulkPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UserGroupMembersBulkPostNotFound {
  message?: 'user.error.user-group-not-found'
}

export interface UserGroupMembersBulkPostRequest {
  /** @format uuid */
  user_group_id: string
  users_ids: string[]
}

export interface UserGroupMembersBulkPostUnprocessableContent {
  message?: 'user.error.members-limit-exceeded'
}

export interface UserGroupMembersBulkResult {
  errors: Record<string, string>
}

export interface UserGroupMembersExportPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UserGroupMembersExportPostNotFound {
  message?: 'user.error.user-group-not-found'
}

export interface UserGroupMembersGetForbidden {
  message?: 'api.error.forbidden'
}

export interface UserGroupMembersGetUnprocessableContent {
  message?: 'user.error.query-too-short'
}

export interface UserGroupMembersPostRequest {
  /** @format uuid */
  user_id: string
}

export interface UserGroupPrivacyPutBadRequest {
  message?: 'user.error.user-group-creator-cannot-manage-all-members'
}

export interface UserGroupPrivacyPutForbidden {
  message?: 'api.error.forbidden'
}

export interface UserGroupPrivacyPutRequest {
  private: boolean
}

export interface UserGroupPutRequest {
  user_group_name: string
}

export interface UserGroupReference {
  /** @format uuid */
  id: string
  name: string
}

export interface UserGroupUpdatePatch {
  Operations: _Operation[]
  /**
   * @maxItems 1
   * @minItems 1
   */
  schemas: string[]
}

export interface UserGroupsBulkDeleteRequest {
  user_groups_ids: string[]
}

export interface UserGroupsBulkDeleteResult {
  errors: Record<string, string>
}

export interface UserGroupsDeleteForbidden {
  message?: 'api.error.forbidden'
}

export interface UserGroupsListResponse {
  Resources?: UserGroupDetails[]
  itemsPerPage: number
  schemas?: string[]
  startIndex: number
  totalResults: number
}

export interface UserGroupsPostBadRequest {
  message?: 'user.error.name-already-exists'
}

export interface UserGroupsPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UserGroupsPostNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserGroupsPostRequest {
  private?: boolean
  user_group_name: string
  users_ids?: string[]
}

export interface UserGroupsPostUnprocessableContent {
  message?: 'user.error.name-too-long'
}

export interface UserIdentity {
  date_of_birth: string | null
  /** @format email */
  email: string | null
  first_name: string | null
  job_title: string | null
  last_name: string | null
  no_email_user_id: string | null
  phone: string | null
  title: string | null
}

export interface UserIdentityPostRequest {
  /** @format uuid */
  company_id?: string | null
  date_of_birth?: string | null
  email?: string | null
  email_verified?: boolean | null
  enabled?: boolean | null
  federated_identity?: FederatedIdentity | null
  first_name?: string | null
  job_title?: string | null
  last_name?: string | null
  /** @format uuid */
  legacy_user_id?: string | null
  phone?: string | null
  realm_roles?: RealmRolePost[]
  title?: string | null
  username?: string | null
}

export interface UserInviteEmailPostBadRequest {
  message?: 'user.error.user-already-confirmed'
}

export interface UserInviteEmailPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UserInviteEmailPostNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserInviteLink {
  link?: string
}

export interface UserInviteLinkPostBadRequest {
  message?: 'user.error.user-already-confirmed'
}

export interface UserInviteLinkPostConflict {
  message?: 'user.error.invite-link-not-supported-for-no-email-user'
}

export interface UserInviteLinkPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UserInviteLinkPostNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserList {
  total_users: number
  users: UserSummary[]
}

export interface UserListGetForbidden {
  message?: 'a' | 'p' | 'i' | '.' | 'e' | 'r' | 'o' | 'f' | 'b' | 'd' | 'n'
}

export interface UserPasswordReset {
  new_password?: string
}

export interface UserPasswordResetPutConflict {
  message?: 'user.error.user-is-not-no-email-user'
}

export interface UserPasswordResetPutForbidden {
  message?: 'api.error.forbidden'
}

export interface UserPasswordResetPutNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserPut {
  /** @format email */
  email?: string
  first_name?: string | null
  last_name?: string | null
  title?: 'mr' | 'mrs' | 'mx'
}

export interface UserPutEmailAlreadyInUse {
  message?: 'user.error.email-already-in-use'
}

export interface UserPutForbidden {
  message?: 'api.error.forbidden'
}

export interface UserPutNoEmailUserDoesNotHaveEmail {
  message?: 'user.error.no-email-user-does-not-have-email'
}

export interface UserPutUserNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserReactivationPostBadRequest {
  message?: 'user.error.user-has-to-be-deactivated'
}

export interface UserReactivationPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UserReactivationPostInternalServerError {
  message?: 'user.error.failed-to-update-user-in-iam'
}

export interface UserReactivationPostNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserRolesDelete {
  role:
    | 'admin'
    | 'owner'
    | 'company_administrator'
    | 'public_api_client'
    | 'manager'
    | 'content_creator'
    | 'student'
}

export interface UserRolesDeleteForbidden {
  message?: 'api.error.forbidden'
}

export interface UserRolesDeleteUserNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserRolesPost {
  role:
    | 'admin'
    | 'owner'
    | 'company_administrator'
    | 'public_api_client'
    | 'manager'
    | 'content_creator'
    | 'student'
}

export interface UserRolesPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UserRolesPostRoleAlreadyAssigned {
  message?: 'user.error.role-already-assigned'
}

export interface UserRolesPostUserNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserRolesPut {
  roles: (
    | 'admin'
    | 'owner'
    | 'company_administrator'
    | 'public_api_client'
    | 'manager'
    | 'content_creator'
    | 'student'
  )[]
}

export interface UserRolesPutForbidden {
  message?: 'api.error.forbidden'
}

export interface UserRolesPutUserNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserSearch {
  total_users: number
  users: SearchedUser[]
}

export interface UserSearchGetForbidden {
  message?: 'api.error.forbidden'
}

export interface UserSearchGetUnprocessableContent {
  message?: 'user.error.query-too-short'
}

export interface UserSettings {
  platform_start_page:
    | 'homepage'
    | 'learning-paths-all'
    | 'learning-paths-mandatory'
    | 'learning-paths-active'
    | 'company-courses'
    | 'exclusive-content'
    | 'discovery-page'
    | 'company-space-overview'
    | 'company-space-learning-paths'
}

export interface UserSettingsPatch {
  platform_start_page?:
    | 'homepage'
    | 'learning-paths-all'
    | 'learning-paths-mandatory'
    | 'learning-paths-active'
    | 'company-courses'
    | 'exclusive-content'
    | 'discovery-page'
    | 'company-space-overview'
    | 'company-space-learning-paths'
}

export interface UserSettingsPatchForbidden {
  message?: 'api.error.forbidden'
}

export interface UserSettingsPatchNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserSignatureCourse {
  description?: string
  duration?: number
  image_id?: string
  num_completed_topics?: number
  num_lectures?: number
  num_of_points?: number
  num_topics?: number
  slug?: string
  title?: string
}

export interface UserSignatureCourses {
  signature_courses?: UserSignatureCourse[]
}

export interface UserSignupDetails {
  company: string
  /** @format email */
  email: string
  /** @format uuid */
  id: string
  lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt-br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  roles: (
    | 'admin'
    | 'owner'
    | 'company_administrator'
    | 'public_api_client'
    | 'manager'
    | 'content_creator'
    | 'student'
  )[]
  state: 'active' | 'pending' | 'deactivated'
}

export interface UserSignupDetailsGetBadRequest {
  message?: 'user.error.user-is-deactivated'
}

export interface UserSignupDetailsGetGone {
  message?: 'user.error.user-invite-token-expired'
}

export interface UserSignupDetailsGetNotFound {
  message?: 'user.error.user-not-found'
}

export interface UserSummary {
  /** @format url */
  avatar_url: string | null
  can_be_deleted_by_caller: boolean
  can_be_managed_by_caller: boolean
  /** @format uuid */
  company_id: string
  department: Department | null
  /** @format uuid */
  global_user_id: string
  /** @format uuid */
  id: string
  /** @format date */
  invited_at: string
  is_no_email_user: boolean
  license_provider: UserSummaryLicenseProvider | null
  licenses: Licenses
  /** @format date-time */
  no_email_user_password_reset_at: string | null
  roles: (
    | 'admin'
    | 'owner'
    | 'company_administrator'
    | 'public_api_client'
    | 'manager'
    | 'content_creator'
    | 'student'
  )[]
  status: 'active' | 'pending' | 'deactivated'
  user_identity: UserSummaryIdentityShema
}

export interface UserSummaryIdentityShema {
  /** @format email */
  email: string | null
  first_name: string | null
  last_name: string | null
  no_email_user_id: string | null
}

export interface UserSummaryLicenseProvider {
  /** @format uuid */
  global_user_id: string
  /** @format uuid */
  id: string
  is_no_email_user: boolean
  status: 'active' | 'pending' | 'deactivated'
  user_identity: UserSummaryIdentityShema
}

export interface UserTokens {
  access_token: string
  refresh_token: string
}

export interface UserUpdatePatch {
  Operations: _Operation[]
  /**
   * @maxItems 1
   * @minItems 1
   */
  schemas: string[]
}

export interface UserUpdatePut {
  /** @default true */
  active?: boolean
  emails: _EmailAddress[]
  name?: NameDetails
  /**
   * @maxItems 1
   * @minItems 1
   */
  phoneNumbers?: _PhoneNumber1[]
  /** @default null */
  preferredLanguage?: string | null
  /** @default ["student"] */
  roles?: (
    | 'admin'
    | 'owner'
    | 'company_administrator'
    | 'public_api_client'
    | 'manager'
    | 'content_creator'
    | 'student'
  )[]
  /** @default null */
  title?: 'mr' | 'mrs' | 'mx' | null
  'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User'?: UserExtension
  /** @default null */
  userType?: string | null
}

export interface UsersBulkDeactivationRequest {
  /** @maxItems 50 */
  users_ids: string[]
}

export interface UsersBulkDeactivationResult {
  errors: Record<string, string>
}

export interface UsersBulkDeleteRequest {
  /** @maxItems 50 */
  users_ids: string[]
}

export interface UsersBulkDeleteResult {
  errors: Record<string, string>
}

export interface UsersBulkInviteEmailRequest {
  /** @maxItems 50 */
  users_ids: string[]
}

export interface UsersBulkInviteEmailResult {
  errors: Record<string, string>
}

export interface UsersBulkReactivationRequest {
  /** @maxItems 50 */
  users_ids: string[]
}

export interface UsersBulkReactivationResult {
  errors: Record<string, string>
}

export interface UsersDeactivationPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UsersDeleteForbidden {
  message?: 'api.error.forbidden'
}

export interface UsersExportPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UsersGetForbidden {
  message?: 'api.error.forbidden'
}

export interface UsersGetUnprocessableContent {
  message?: 'user.error.query-too-short'
}

export interface UsersImportPostContentTooLarge {
  message?: 'user.error.batch-operation-file-maximum-size-exceeded'
}

export interface UsersImportPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UsersImportPostUnprocessableContent {
  message?: 'user.error.batch-operation-file-format-not-supported'
}

export interface UsersInviteEmailPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UsersListResponse {
  Resources?: UserDetails[]
  itemsPerPage: number
  schemas?: string[]
  startIndex: number
  totalResults: number
}

export interface UsersPost {
  /**
   * @format uuid
   * @default null
   */
  department_id?: string | null
  /** @format email */
  email: string
  /** @default null */
  first_name?: string | null
  /** @default null */
  lang?:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt-br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  /** @default null */
  last_name?: string | null
  /** @min 0 */
  licenses?: number
  platform_start_page?:
    | 'homepage'
    | 'learning-paths-all'
    | 'learning-paths-mandatory'
    | 'learning-paths-active'
    | 'company-courses'
    | 'exclusive-content'
    | 'discovery-page'
    | 'company-space-overview'
    | 'company-space-learning-paths'
  roles: (
    | 'admin'
    | 'owner'
    | 'company_administrator'
    | 'public_api_client'
    | 'manager'
    | 'content_creator'
    | 'student'
  )[]
  send_invite_email?: boolean
  /** @default null */
  title?: 'mr' | 'mrs' | 'mx' | null
}

export interface UsersPostCompanyNotFound {
  message?: 'user.error.company-not-found'
}

export interface UsersPostEmailIsNotAllowedInCompany {
  message?: 'user.error.invalid-email-domain'
}

export interface UsersPostForbidden {
  message?: 'api.error.forbidden'
}

export interface UsersPostIamError {
  message?: 'user.error.iam-error'
}

export interface UsersPostLicensesLimitExceeded {
  message?: 'user.error.license-limit-exceeded'
}

export interface UsersReactivationPostForbidden {
  message?: 'api.error.forbidden'
}

export interface Validity {
  /** @format date */
  date: string | null
  type: string | null
  value: number | null
}

export interface VideoLectureAudioGetResponse {
  /** @format url */
  download_url: string
}

export interface VideoLecturesAudioGetForbidden {
  message?: 'media.error.video-lecture-access-denied'
}

export interface VideoLecturesAudioGetNotFound {
  message?: 'media.error.cloudflare-video-not-found'
}

export interface VideoLecturesAudioGetUnprocessableContent {
  message?: 'media.error.invalid-audio-lang-format'
}

export interface VideoUploadWebhookInitPostInternalServerError {
  message?: 'media.error.cloudflare-upload-exception'
}

export interface VideoUploadWebhookInitPostRequest {
  bucket: string
  key: string
  name: string
  size: number
}

export interface VideoUploadWebhookReadyPostNotFound {
  message?: 'media.error.cloudflare-video-not-found'
}

export interface VideoUploadWebhookReadyPostUnprocessableContent {
  message?: 'media.error.unknown-video-creator-name'
}

export interface XAPIStatementsPostBadRequest {
  message?: 'xapi.error.missing-cmi5-session-id-request-header'
}

export interface XAPIStatementsResourcePost {
  xapi_verb: 'terminated'
}

export interface _Attribute {
  canonicalValues?: string[]
  caseExact?: boolean
  description: string
  multiValued: boolean
  mutability: string
  name: string
  referenceTypes?: string[]
  required: boolean
  returned: string
  subAttributes?: _Attribute[]
  type: string
  uniqueness: string
}

export interface _Cmi5LaunchParams {
  activity_id: string
  actor: any
  endpoint: string
  fetch: string
  /** @format uuid */
  registration: string
  /** @format uuid */
  xapi_client_id: string
}

export interface _EmailAddress {
  /** @format email */
  value: string
}

export interface _EmailDetails {
  /** @format email */
  value: string
}

export interface _EmailDetails1 {
  /**
   * A boolean value indicating if address is preferred by user.
   * @default null
   */
  primary?: boolean | null
  /**
   * Type of users email address.Currently only 'work' type is supported.
   * @default null
   */
  type?: string | null
  /**
   * Email addresses for the user.
   * @format email
   * @default null
   */
  value?: string | null
}

export interface _Manager {
  /** @format uuid */
  value: string
}

export interface _MasterplanUserAttributes {
  licenses?: number
}

export interface _MemberValue {
  /** @format uuid */
  value?: string
}

export interface _Operation {
  op: string
  path?: string
  value?: any
}

export interface _PhoneNumber {
  value: string
}

export interface _PhoneNumber1 {
  value: string
}

export interface _PhoneNumberDetails {
  /**
   * A boolean value indicating if phone number is preferred by user.
   * @default null
   */
  primary?: boolean | null
  /**
   * Type of users phone number.Currently only 'work' type is supported.
   * @default null
   */
  type?: string | null
  /**
   * Phone number of the the user.
   * @default null
   */
  value?: string | null
}

export interface _SchemaExtension {
  required: boolean
  schema: string
}

export interface _UserExtension {
  department?: string
  employeeNumber?: string
  manager?: _Manager
}

export interface _UserToConsumeInvite {
  /** @format uuid */
  id: string
  lang:
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'cs'
    | 'hu'
    | 'pl'
    | 'pt'
    | 'sk'
    | 'el'
    | 'tr'
    | 'nl'
    | 'pt-br'
    | 'ru'
    | 'sl'
    | 'ja'
    | 'ko'
    | 'zh'
  password: string
}

export interface CompanyNotFound {
  message?: 'company.error.company-not-found'
}

export interface CompanyNotFound1 {
  message?: 'company.error.company-not-found'
}

export interface CompanyNotFound2 {
  message?: 'company.error.company-not-found'
}

export interface InvalidCompanySsoConfiguration {
  message?: 'company.error.invalid-company-sso-configuration'
}

export interface InvalidCompanySsoConfiguration1 {
  message?: 'company.error.invalid-company-sso-configuration'
}

export interface NameTooLong {
  message?: 'user.error.name-too-long'
}

import axios, { AxiosInstance, AxiosRequestConfig, ResponseType } from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<
  AxiosRequestConfig,
  'data' | 'params' | 'url' | 'responseType'
> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>

interface ApiConfig<SecurityDataType = unknown> extends Omit<
  AxiosRequestConfig,
  'data' | 'cancelToken'
> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
  instance?: AxiosInstance
}

enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
}

class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  readonly securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  readonly secure?: boolean
  readonly format?: ResponseType

  constructor({
    securityWorker,
    secure,
    format,
    instance,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance =
      instance ||
      axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)
    const headers =
      method && this.instance.defaults.headers[method.toLowerCase()]

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((headers as Record<string, any>) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    const formDataFirstIteration = Object.keys(input || {}).reduce(
      (formData, key) => {
        const property = input[key]
        const propertyContent =
          property instanceof Array ? property : [property]

        for (const formItem of propertyContent) {
          const isFileType =
            formItem instanceof Blob || formItem instanceof File
          formData.append(
            key,
            isFileType ? formItem : this.stringifyFormItem(formItem),
          )
        }

        return formData
      },
      new FormData(),
    )

    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      formData.append(
        key,
        property instanceof Blob
          ? property
          : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
      )
      return formData
    }, formDataFirstIteration)
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {}),
          ...(requestParams.headers || {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Masterplan
 * @version 3.38.0
 */
export class ApiClient<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  activity = {
    /**
     * @name ActivityKnockUserTokenList
     * @request GET:/activity/knock-user-token
     */
    knockUserTokenList: (params: RequestParams = {}) =>
      this.request<KnockUserTokenGetResponse, KnockUserTokenGetUnauthorized>({
        path: `/activity/knock-user-token`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ActivityManagerList
     * @request GET:/activity/manager
     */
    managerList: (
      query: {
        /** @min 0 */
        page: number
        /**
         * @min 1
         * @max 500
         */
        size: number
        /** @default null */
        activity_type?:
          | 'LearnpathActivated'
          | 'LearnpathAssignedToLearner'
          | 'LearnpathReactivatedForLearner'
          | 'LearnpathAssignedToLearnerForManager'
          | 'MembersAddedToActiveLearnpath'
          | 'GamificationAwardGranted'
          | null
        /** @default "timestamp" */
        sort?: 'entity_id' | 'entity_type' | 'activity_type' | 'timestamp'
        /** @default "desc" */
        order?: 'asc' | 'desc'
      },
      params: RequestParams = {},
    ) =>
      this.request<Activities, any>({
        path: `/activity/manager`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name ActivityNotificationhubUserTokenList
     * @request GET:/activity/notificationhub-user-token
     */
    notificationhubUserTokenList: (params: RequestParams = {}) =>
      this.request<
        NotificationHubUserTokenGetResponse,
        NotificationHubUserTokenGetUnauthorized
      >({
        path: `/activity/notificationhub-user-token`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ActivityStudentList
     * @request GET:/activity/student
     */
    studentList: (
      query: {
        /** @min 0 */
        page: number
        /**
         * @min 1
         * @max 500
         */
        size: number
        /** @default null */
        activity_type?:
          | 'LearnpathActivated'
          | 'LearnpathAssignedToLearner'
          | 'LearnpathReactivatedForLearner'
          | 'LearnpathAssignedToLearnerForManager'
          | 'MembersAddedToActiveLearnpath'
          | 'GamificationAwardGranted'
          | null
        /** @default "timestamp" */
        sort?: 'entity_id' | 'entity_type' | 'activity_type' | 'timestamp'
        /** @default "desc" */
        order?: 'asc' | 'desc'
      },
      params: RequestParams = {},
    ) =>
      this.request<Activities, any>({
        path: `/activity/student`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  analytics = {
    /**
     * @name AnalyticsMetricList
     * @request GET:/analytics/metric
     */
    metricList: (
      query: {
        metric_name:
          | 'licenses'
          | 'users'
          | 'course_starters_and_completers'
          | 'learning_path_starters_and_completers'
          | 'total_users'
          | 'users_in_learning_groups'
          | 'users_that_finished_fundamental_course'
          | 'total_users_activity_time'
          | 'course_starts_and_completions'
          | 'lessons_starts_and_completions'
          | 'learningpath_starts_and_completions'
          | 'learningpath_elements_starts_and_completions'
          | 'learningpath_activity_by_type'
          | 'learningpath_elements_activity_by_type'
          | 'average_activity_time_in_learningpath'
          | 'learningpath_progress'
          | 'users_who_completed_skills_assessment'
          | 'most_popular_power_skill'
          | 'power_skill_with_most_points_achieved'
          | 'highest_level_in_power_skill'
          | 'most_popular_domain'
          | 'most_popular_course'
          | 'users_in_power_skills'
          | 'highest_level_in_power_skills'
          | 'average_score_in_power_skill'
          | 'average_course_rating_and_others'
          | 'top_5_most_completed_courses'
          | 'completed_courses'
          | 'top_5_most_completed_lessons'
          | 'completed_lessons'
          | 'top_5_best_rated_lessons'
          | 'top_10_most_popular_searches'
          | 'user_groups_overview'
          | 'lessons_starts_and_completions_monthly'
          | 'users_with_activity_monthly'
          | 'user_group_learning_path_league'
          | 'company_trainings'
          | 'learning_paths_overview'
          | 'top_5_fastest_completed_learning_paths'
          | 'company_courses_overview'
          | 'company_course_starters_and_completers'
          | 'company_course_starts_and_completions'
          | 'company_course_elements_starts_and_completions'
          | 'company_course_elements_activity_by_type'
          | 'company_course_activity_time'
          | 'company_course_progress'
          | 'top_5_most_completed_company_courses'
          | 'company_course_quiz_completion_rate'
          | 'signature_course_completions'
          | 'top_5_most_achieved_rewards'
          | 'course_progress'
        /** @format date */
        start_date: string
        /** @format date */
        end_date: string
        user_type?: string | null
        user_state?: string | null
        departments?: string[]
        user_groups?: string[]
      },
      params: RequestParams = {},
    ) =>
      this.request<Metric, MetricGetBadRequest | MetricGetForbidden>({
        path: `/analytics/metric`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name AnalyticsMetricCsvList
     * @request GET:/analytics/metric/csv
     */
    metricCsvList: (
      query: {
        metric_name:
          | 'licenses'
          | 'users'
          | 'course_starters_and_completers'
          | 'learning_path_starters_and_completers'
          | 'total_users'
          | 'users_in_learning_groups'
          | 'users_that_finished_fundamental_course'
          | 'total_users_activity_time'
          | 'course_starts_and_completions'
          | 'lessons_starts_and_completions'
          | 'learningpath_starts_and_completions'
          | 'learningpath_elements_starts_and_completions'
          | 'learningpath_activity_by_type'
          | 'learningpath_elements_activity_by_type'
          | 'average_activity_time_in_learningpath'
          | 'learningpath_progress'
          | 'users_who_completed_skills_assessment'
          | 'most_popular_power_skill'
          | 'power_skill_with_most_points_achieved'
          | 'highest_level_in_power_skill'
          | 'most_popular_domain'
          | 'most_popular_course'
          | 'users_in_power_skills'
          | 'highest_level_in_power_skills'
          | 'average_score_in_power_skill'
          | 'average_course_rating_and_others'
          | 'top_5_most_completed_courses'
          | 'completed_courses'
          | 'top_5_most_completed_lessons'
          | 'completed_lessons'
          | 'top_5_best_rated_lessons'
          | 'top_10_most_popular_searches'
          | 'user_groups_overview'
          | 'lessons_starts_and_completions_monthly'
          | 'users_with_activity_monthly'
          | 'user_group_learning_path_league'
          | 'company_trainings'
          | 'learning_paths_overview'
          | 'top_5_fastest_completed_learning_paths'
          | 'company_courses_overview'
          | 'company_course_starters_and_completers'
          | 'company_course_starts_and_completions'
          | 'company_course_elements_starts_and_completions'
          | 'company_course_elements_activity_by_type'
          | 'company_course_activity_time'
          | 'company_course_progress'
          | 'top_5_most_completed_company_courses'
          | 'company_course_quiz_completion_rate'
          | 'signature_course_completions'
          | 'top_5_most_achieved_rewards'
          | 'course_progress'
        /** @format date */
        start_date: string
        /** @format date */
        end_date: string
        user_type?: string | null
        user_state?: string | null
        departments?: string[]
        user_groups?: string[]
      },
      params: RequestParams = {},
    ) =>
      this.request<any, MetricCsvGetBadRequest | MetricCsvGetForbidden>({
        path: `/analytics/metric/csv`,
        method: 'GET',
        query: query,
        ...params,
      }),
  }
  applicationVersionCheck = {
    /**
     * @name ApplicationVersionCheckList
     * @request GET:/application-version-check
     */
    list: (params: RequestParams = {}) =>
      this.request<ApplicationVersionCheck, any>({
        path: `/application-version-check`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  auth = {
    /**
     * @name AuthUserConsentsList
     * @request GET:/auth/user/consents
     */
    userConsentsList: (params: RequestParams = {}) =>
      this.request<UserConsents, UserConsentsGetNotFound>({
        path: `/auth/user/consents`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name AuthUserConsentsUpdate
     * @request PUT:/auth/user/consents
     */
    userConsentsUpdate: (
      data?: UserConsentsRequest,
      params: RequestParams = {},
    ) =>
      this.request<Empty, any>({
        path: `/auth/user/consents`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name AuthUserConsentsGetByUserConsentsToken
     * @request GET:/auth/user/consents/{user_consents_token}
     */
    userConsentsGetByUserConsentsToken: (
      userConsentsToken: string,
      params: RequestParams = {},
    ) =>
      this.request<UserConsents, UnprotectedUserConsentsGetNotFound>({
        path: `/auth/user/consents/${userConsentsToken}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name AuthUserConsentsUpdateByUserConsentsToken
     * @request PUT:/auth/user/consents/{user_consents_token}
     */
    userConsentsUpdateByUserConsentsToken: (
      userConsentsToken: string,
      data?: UserConsentsRequest,
      params: RequestParams = {},
    ) =>
      this.request<Empty, UnprotectedUserConsentsPutNotFound>({
        path: `/auth/user/consents/${userConsentsToken}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  batchOperations = {
    /**
     * @name BatchOperationsList
     * @request GET:/batch-operations/
     */
    list: (
      query?: {
        /** @min 0 */
        page?: number
        /** @min 1 */
        size?: number
        sort_by?: 'filename' | 'status' | 'uploaded_at'
        sort_order?: 'asc' | 'desc'
        filename?: string
        operation?:
          | 'user_import'
          | 'user_edit'
          | 'user_deactivation'
          | 'user_reactivation'
          | 'user_group_assignment'
          | 'license_provider_change'
          | 'department_assignment'
        /** @format uuid */
        creator_id?: string
        status?: (
          | 'pending'
          | 'failed'
          | 'parsing'
          | 'parsed'
          | 'processing'
          | 'completed'
        )[]
        /** @format date */
        from_uploaded_at?: string
        /** @format date */
        to_uploaded_at?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<
        BatchOperationFileHistory,
        BatchOperationFileHistoryGetForbidden
      >({
        path: `/batch-operations/`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name BatchOperationsE2ECompanyDeleteByCompanyId
     * @request DELETE:/batch-operations/e2e/company/{company_id}
     */
    e2ECompanyDeleteByCompanyId: (
      companyId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | E2ECompanyBatchOperationsDeleteForbidden
        | E2ECompanyBatchOperationsDeleteNotFound
      >({
        path: `/batch-operations/e2e/company/${companyId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name BatchOperationsE2EStatusGetByBatchOperationFileId
     * @request GET:/batch-operations/e2e/{batch_operation_file_id}/status
     */
    e2EStatusGetByBatchOperationFileId: (
      batchOperationFileId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        BatchOperationFileStatus,
        | E2EBatchOperationFileStatusGetForbidden
        | E2EBatchOperationFileStatusGetNotFound
      >({
        path: `/batch-operations/e2e/${batchOperationFileId}/status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name BatchOperationsErrorsGetByBatchOperationFileId
     * @request GET:/batch-operations/{batch_operation_file_id}/errors
     */
    errorsGetByBatchOperationFileId: (
      batchOperationFileId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        | BatchOperationFileErrorsGetForbidden
        | BatchOperationFileErrorsGetNotFound
        | BatchOperationFileErrorsGetConflict
      >({
        path: `/batch-operations/${batchOperationFileId}/errors`,
        method: 'GET',
        ...params,
      }),
  }
  bookmarkedLectures = {
    /**
     * @name BookmarkedLecturesDelete
     * @request DELETE:/bookmarked_lectures
     */
    delete: (
      data?: BookmarkedLecturesPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<BookmarkedLectures, any>({
        path: `/bookmarked_lectures`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name BookmarkedLecturesList
     * @request GET:/bookmarked_lectures
     */
    list: (params: RequestParams = {}) =>
      this.request<BookmarkedLectures, any>({
        path: `/bookmarked_lectures`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name BookmarkedLecturesCreate
     * @request POST:/bookmarked_lectures
     */
    create: (
      data?: BookmarkedLecturesPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<BookmarkedLectures, any>({
        path: `/bookmarked_lectures`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  bookmarks = {
    /**
     * @name BookmarksList
     * @request GET:/bookmarks
     */
    list: (
      query?: {
        /** @default null */
        q?: string | null
      },
      params: RequestParams = {},
    ) =>
      this.request<Bookmarks, any>({
        path: `/bookmarks`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name BookmarksDownloadList
     * @request GET:/bookmarks/download
     */
    downloadList: (
      query?: {
        /** @default false */
        dl?: boolean
      },
      params: RequestParams = {},
    ) =>
      this.request<BookmarksDownload, BookmarksDownloadGetNotFound>({
        path: `/bookmarks/download`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name BookmarksDownloadCreate
     * @request POST:/bookmarks/download
     */
    downloadCreate: (
      data?: BookmarkDownloadPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        BookmarksDownloadPostForbidden | BookmarksDownloadPostConflict
      >({
        path: `/bookmarks/download`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  certificates = {
    /**
     * @name CertificatesList
     * @request GET:/certificates
     */
    list: (params: RequestParams = {}) =>
      this.request<GetCertificatesResponse, any>({
        path: `/certificates`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name CertificatesGetByCertificateId
     * @request GET:/certificates/{certificate_id}
     */
    getByCertificateId: (certificateId: string, params: RequestParams = {}) =>
      this.request<GetCertificateResponse, CertificateNotFoundResponse>({
        path: `/certificates/${certificateId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  channels = {
    /**
     * @name ChannelsList
     * @request GET:/channels
     */
    list: (params: RequestParams = {}) =>
      this.request<Channels, any>({
        path: `/channels`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ChannelsAnnouncementsList
     * @request GET:/channels/announcements
     */
    announcementsList: (params: RequestParams = {}) =>
      this.request<AnnouncementsChannel, AnnouncementsChannelGetNotFound>({
        path: `/channels/announcements`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ChannelsBestTopicsList
     * @request GET:/channels/best_topics
     */
    bestTopicsList: (params: RequestParams = {}) =>
      this.request<HighestRatedTopicsChannel, any>({
        path: `/channels/best_topics`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ChannelsCategoryGetBySlug
     * @request GET:/channels/category/{slug}
     */
    categoryGetBySlug: (slug: string, params: RequestParams = {}) =>
      this.request<SingleChannel, NoChannelFound>({
        path: `/channels/category/${slug}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ChannelsHighlightedTopicList
     * @request GET:/channels/highlighted_topic
     */
    highlightedTopicList: (params: RequestParams = {}) =>
      this.request<
        HighlightedTopic,
        NoChannelAccessError | NoHighlightedTopicFoundError
      >({
        path: `/channels/highlighted_topic`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ChannelsInternalList
     * @request GET:/channels/internal
     */
    internalList: (params: RequestParams = {}) =>
      this.request<InternalChannel, any>({
        path: `/channels/internal`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ChannelsNamesList
     * @request GET:/channels/names
     */
    namesList: (params: RequestParams = {}) =>
      this.request<SimpleChannels, any>({
        path: `/channels/names`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ChannelsNewTopicsList
     * @request GET:/channels/new_topics
     */
    newTopicsList: (params: RequestParams = {}) =>
      this.request<NewTopicsChannel, any>({
        path: `/channels/new_topics`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ChannelsPersonalList
     * @request GET:/channels/personal
     */
    personalList: (params: RequestParams = {}) =>
      this.request<PersonalChannel, any>({
        path: `/channels/personal`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  chatbot = {
    /**
     * @name ChatbotLectureCreateByLectureId
     * @request POST:/chatbot/lecture/{lecture_id}
     */
    lectureCreateByLectureId: (
      lectureId: number,
      query?: {
        /** @default false */
        stream?: boolean
      },
      data?: ChatbotLecturePostRequestBody,
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        | ChatbotLecturePostUnauthorized
        | ChatbotLecturePostNotFound
        | ChatbotLecturePostUnprocessableContent
        | ChatbotLecturePostTooManyRequests
      >({
        path: `/chatbot/lecture/${lectureId}`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @name ChatbotLectureRealtimeSessionCreateByLectureId
     * @request POST:/chatbot/lecture/{lecture_id}/realtime-session
     */
    lectureRealtimeSessionCreateByLectureId: (
      lectureId: number,
      data?: RealtimeSessionPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        RealtimeClientSecret,
        | ChatbotLectureSessionPostUnauthorized
        | ChatbotLectureSessionPostNotFound
        | ChatbotLectureSessionPostTooManyRequests
      >({
        path: `/chatbot/lecture/${lectureId}/realtime-session`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name ChatbotSseTestCreate
     * @request POST:/chatbot/sse-test
     */
    sseTestCreate: (
      query?: {
        /** @default false */
        stream?: boolean
      },
      data?: Generated,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/chatbot/sse-test`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
  cmi5 = {
    /**
     * @name Cmi5LaunchList
     * @request GET:/cmi5/launch
     */
    launchList: (
      query: {
        content_type: 'topic' | 'learnpath' | 'company_course'
        /** @format uuid */
        content_id: string
        cmi5_launch_params: _Cmi5LaunchParams
      },
      params: RequestParams = {},
    ) =>
      this.request<any, Cmi5LaunchGetUnprocessableContent>({
        path: `/cmi5/launch`,
        method: 'GET',
        query: query,
        ...params,
      }),
  }
  company = {
    /**
     * @name CompanyList
     * @request GET:/company
     */
    list: (params: RequestParams = {}) =>
      this.request<Company, CompanyGetNotFound>({
        path: `/company`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name CompanyCreate
     * @request POST:/company
     */
    create: (data?: CompanyPostRequest, params: RequestParams = {}) =>
      this.request<Empty, CompanyPostUnprocessableContent>({
        path: `/company`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name CompanyUpdate
     * @request PUT:/company
     */
    update: (data?: CompanyPutRequest, params: RequestParams = {}) =>
      this.request<Company, CompanyPutNotFound | CompanyPutUnprocessableEntity>(
        {
          path: `/company`,
          method: 'PUT',
          body: data,
          type: ContentType.Json,
          format: 'json',
          ...params,
        },
      ),

    /**
     * @name CompanyAuditLogRequestsCreate
     * @request POST:/company/audit-log/requests
     */
    auditLogRequestsCreate: (
      data?: CompanyAuditLogRequestPost,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | CompanyAuditLogRequestPostForbidden
        | CompanyAuditLogRequestPostUnprocessableContent
        | CompanyAuditLogRequestPostInternalServerError
      >({
        path: `/company/audit-log/requests`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name CompanyDepartmentsList
     * @request GET:/company/departments
     */
    departmentsList: (params: RequestParams = {}) =>
      this.request<Departments, Empty>({
        path: `/company/departments`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name CompanyDepartmentsCreate
     * @request POST:/company/departments
     */
    departmentsCreate: (
      data?: DepartmentsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Department,
        Empty | CompanyDepartmentsPostUnprocessableEntity
      >({
        path: `/company/departments`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name CompanyDepartmentsDeleteByDepartmentId
     * @request DELETE:/company/departments/{department_id}
     */
    departmentsDeleteByDepartmentId: (
      departmentId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | CompanyDepartmentDeleteForbidden
        | CompanyDepartmentDeleteNotFound
        | CompanyDepartmentDeleteConflict
      >({
        path: `/company/departments/${departmentId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name CompanyDepartmentsUpdateByDepartmentId
     * @request PUT:/company/departments/{department_id}
     */
    departmentsUpdateByDepartmentId: (
      departmentId: string,
      data?: DepartmentPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Department,
        | Empty
        | CompanyDepartmentPutNotFound
        | CompanyDepartmentPutUnprocessableEntity
      >({
        path: `/company/departments/${departmentId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name CompanyFeatureUserGetByUserId
     * @request GET:/company/feature/{feature_key}/user/{user_id}
     */
    featureUserGetByUserId: (
      featureKey: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<UserFeature, UserFeatureGetUnauthorized>({
        path: `/company/feature/${featureKey}/user/${userId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name CompanyLicensesStructureList
     * @request GET:/company/licenses/structure
     */
    licensesStructureList: (
      query?: {
        offset?: number
        size?: number
        query?: string
        email?: string
        license_provider_email?: string
        sort_by?:
          | 'status'
          | 'invitation_date'
          | 'department'
          | 'email'
          | 'first_name'
          | 'last_name'
          | 'license_provider_email'
          | 'role'
          | 'available_licenses'
          | 'total_licenses'
        order?: 'asc' | 'desc'
        roles?: (
          | 'admin'
          | 'owner'
          | 'company_administrator'
          | 'public_api_client'
          | 'manager'
          | 'content_creator'
          | 'student'
        )[]
        /** @format date */
        from_invited_at?: string
        /** @format date */
        to_invited_at?: string
        states?: ('active' | 'pending' | 'deactivated')[]
        /** @format uuid */
        department_id?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<CompanyLicenseStructure, UserListGetForbidden>({
        path: `/company/licenses/structure`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name CompanyNotificationsSettingsList
     * @request GET:/company/notifications_settings
     */
    notificationsSettingsList: (
      data?: NotificationsSettingsGetRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CompanyNotificationsSettings,
        CompanyNotificationsSettingGetNotFound
      >({
        path: `/company/notifications_settings`,
        method: 'GET',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name CompanyNoEmailUsersGetBySsoSourceId
     * @request GET:/company/{sso_source_id}/no_email_users
     */
    noEmailUsersGetBySsoSourceId: (
      ssoSourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<Empty, CompanyNotFound2>({
        path: `/company/${ssoSourceId}/no_email_users`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name CompanySsoGetBySsoSourceId
     * @request GET:/company/{sso_source_id}/sso
     */
    ssoGetBySsoSourceId: (ssoSourceId: string, params: RequestParams = {}) =>
      this.request<
        any,
        Empty | InvalidCompanySsoConfiguration | CompanyNotFound
      >({
        path: `/company/${ssoSourceId}/sso`,
        method: 'GET',
        ...params,
      }),

    /**
     * @name CompanySsoIdpHintGetBySsoSourceId
     * @request GET:/company/{sso_source_id}/sso/idp_hint
     */
    ssoIdpHintGetBySsoSourceId: (
      ssoSourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        CompanySSOIdPHint,
        InvalidCompanySsoConfiguration1 | CompanyNotFound1
      >({
        path: `/company/${ssoSourceId}/sso/idp_hint`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  events = {
    /**
     * @name EventsList
     * @request GET:/events
     */
    list: (
      query?: {
        /** @min 1 */
        page?: number
        size?: 10 | 25 | 50
        sort_title?: 'asc' | 'desc'
        sort_starts_at?: 'asc' | 'desc'
        sort_completed?: 'asc' | 'desc'
        filter_title?: string
        filter_state?:
          | 'all'
          | 'in_progress'
          | 'active'
          | 'unassigned'
          | 'overdue'
          | 'upcoming'
        filter_type?: 'all' | 'in_person' | 'online'
        filter_owner?: 'all' | 'me'
        /** @format uuid */
        filter_group?: string
        /** @minLength 3 */
        filter_learner_name?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<Events, any>({
        path: `/events`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name EventsCreate
     * @request POST:/events
     */
    create: (data?: EventsPostRequest, params: RequestParams = {}) =>
      this.request<Event, EventsPostNotFound>({
        path: `/events`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name EventsUserGroupsLookupList
     * @request GET:/events/user-groups-lookup
     */
    userGroupsLookupList: (
      query?: {
        q?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<UserGroupLookup[], any>({
        path: `/events/user-groups-lookup`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name EventsDeleteByEventId
     * @request DELETE:/events/{event_id}
     */
    deleteByEventId: (eventId: string, params: RequestParams = {}) =>
      this.request<Empty, EventDeleteNotFound>({
        path: `/events/${eventId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name EventsGetByEventId
     * @request GET:/events/{event_id}
     */
    getByEventId: (eventId: string, params: RequestParams = {}) =>
      this.request<Event, EventGetNotFound>({
        path: `/events/${eventId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name EventsUpdateByEventId
     * @request PUT:/events/{event_id}
     */
    updateByEventId: (
      eventId: string,
      data?: EventPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<Event, EventPutNotFound | EventPutUnprocessableContent>({
        path: `/events/${eventId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name EventsAttendeesGetByEventId
     * @request GET:/events/{event_id}/attendees
     */
    attendeesGetByEventId: (eventId: string, params: RequestParams = {}) =>
      this.request<EventAttendees, EventAttendeesGetNotFound>({
        path: `/events/${eventId}/attendees`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name EventsAttendeesUpdateByEventId
     * @request PUT:/events/{event_id}/attendees
     */
    attendeesUpdateByEventId: (
      eventId: string,
      data?: EventAttendee,
      params: RequestParams = {},
    ) =>
      this.request<EventAttendee, EventAttendeesPutNotFound>({
        path: `/events/${eventId}/attendees`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name EventsDuplicateCreateByEventId
     * @request POST:/events/{event_id}/duplicate
     */
    duplicateCreateByEventId: (eventId: string, params: RequestParams = {}) =>
      this.request<Event, EventDuplicatePostNotFound>({
        path: `/events/${eventId}/duplicate`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  }
  faq = {
    /**
     * @name FaqPostFaq
     * @request POST:/faq
     */
    postFaq: (data?: UserFaqPostRequest, params: RequestParams = {}) =>
      this.request<Empty, any>({
        path: `/faq`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  gamification = {
    /**
     * @name GamificationBadgesList
     * @request GET:/gamification/badges
     */
    badgesList: (params: RequestParams = {}) =>
      this.request<BadgesAwardGroupsList, any>({
        path: `/gamification/badges`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name GamificationBadgesClaimCreate
     * @request POST:/gamification/badges/claim
     */
    badgesClaimCreate: (params: RequestParams = {}) =>
      this.request<BadgesAwardGroupsList, any>({
        path: `/gamification/badges/claim`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name GamificationBadgesClaimCreateByActivityId
     * @request POST:/gamification/badges/claim/{activity_id}
     */
    badgesClaimCreateByActivityId: (
      activityId: string,
      params: RequestParams = {},
    ) =>
      this.request<BadgesAwardGroupsList, any>({
        path: `/gamification/badges/claim/${activityId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  }
  glossary = {
    /**
     * @name GlossaryList
     * @request GET:/glossary
     */
    list: (
      query?: {
        /** @default null */
        q?: string | null
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/glossary`,
        method: 'GET',
        query: query,
        ...params,
      }),
  }
  invites = {
    /**
     * @name InvitesConsumeCreate
     * @request POST:/invites/consume
     */
    consumeCreate: (data?: InvitesConsumerPost, params: RequestParams = {}) =>
      this.request<any, InvitesConsumerPostResponse>({
        path: `/invites/consume`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @name InvitesConsumeCreateByInviteToken
     * @request POST:/invites/consume/{invite_token}
     */
    consumeCreateByInviteToken: (
      inviteToken: string,
      data?: InviteConsumerPost,
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        | InviteConsumerPostBadRequest
        | InviteConsumerPostNotFound
        | InviteConsumerPostUnprocessableContent
        | InviteConsumerPostInternalServerError
        | UserTokens
      >({
        path: `/invites/consume/${inviteToken}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @name InvitesSelfInviteCreate
     * @request POST:/invites/self-invite
     */
    selfInviteCreate: (
      data?: SelfInvitePostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | SelfInvitePostNotFound
        | SelfInvitePostUnprocessableEntity
        | SelfInvitePostInternalError
      >({
        path: `/invites/self-invite`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name InvitesSelfInviteLinksGetBySlug
     * @request GET:/invites/self-invite/links/{slug}
     */
    selfInviteLinksGetBySlug: (slug: string, params: RequestParams = {}) =>
      this.request<SelfInviteLink, SelfInviteLinkGetNotFound>({
        path: `/invites/self-invite/links/${slug}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  lang = {
    /**
     * @name LangList
     * @request GET:/lang
     */
    list: (params: RequestParams = {}) =>
      this.request<Lang, any>({
        path: `/lang`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  launch = {
    /**
     * @name LaunchList
     * @request GET:/launch
     */
    list: (
      query?: {
        content_type?: 'topic' | 'learnpath' | 'company_course'
        /** @format uuid */
        content_id?: string
        page?: 'home' | 'player'
        integration_type?: 'lti' | 'no_email_users' | 'cmi5'
        source_id?: string
        response_type?: string
        cmi5_launch_params?: Record<string, any>
      },
      params: RequestParams = {},
    ) =>
      this.request<any, LaunchGetBadRequest | LaunchGetNotFound>({
        path: `/launch`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @name LaunchCreate
     * @request POST:/launch
     */
    create: (
      query: {
        content_type?: 'topic' | 'learnpath' | 'company_course'
        /** @format uuid */
        content_id?: string
        page?: 'home' | 'player'
        integration_type: 'lti' | 'no_email_users' | 'cmi5'
      },
      params: RequestParams = {},
    ) =>
      this.request<any, LaunchPostBadRequest>({
        path: `/launch`,
        method: 'POST',
        query: query,
        ...params,
      }),
  }
  learngroup = {
    /**
     * @name LearngroupDelete
     * @request DELETE:/learngroup
     */
    delete: (params: RequestParams = {}) =>
      this.request<Empty, LearngroupDeleteForbidden | LearngroupDeleteNotFound>(
        {
          path: `/learngroup`,
          method: 'DELETE',
          format: 'json',
          ...params,
        },
      ),

    /**
     * @name LearngroupList
     * @request GET:/learngroup
     */
    list: (params: RequestParams = {}) =>
      this.request<Learngroup, LearngroupGetNotFound>({
        path: `/learngroup`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearngroupCreate
     * @request POST:/learngroup
     */
    create: (
      query?: {
        /** @default false */
        dry?: boolean
      },
      data?: LearngroupPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<Empty, LearngroupPostUnprocessableEntity>({
        path: `/learngroup`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearngroupUpdate
     * @request PUT:/learngroup
     */
    update: (data?: LearngroupPutRequest, params: RequestParams = {}) =>
      this.request<
        Learngroup,
        | LearngroupPutForbidden
        | LearngroupPutNotFound
        | LearngroupPutUnprocessableEntity
      >({
        path: `/learngroup`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearngroupLeaderboardList
     * @request GET:/learngroup/leaderboard
     */
    leaderboardList: (
      query?: {
        /**
         * @format date
         * @default null
         */
        since?: string | null
      },
      params: RequestParams = {},
    ) =>
      this.request<LearngroupLeaderboard, LearngroupLeaderboardGetNotFound>({
        path: `/learngroup/leaderboard`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearngroupMembershipsDeleteByMembershipId
     * @request DELETE:/learngroup/memberships/{membership_id}
     */
    membershipsDeleteByMembershipId: (
      membershipId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        LearngroupMembershipDeleteForbidden | LearngroupMembershipDeleteNotFound
      >({
        path: `/learngroup/memberships/${membershipId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearngroupMembershipsUpdateByMembershipId
     * @request PUT:/learngroup/memberships/{membership_id}
     */
    membershipsUpdateByMembershipId: (
      membershipId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        LearngroupMembershipPutForbidden | LearngroupMembershipPutNotFound
      >({
        path: `/learngroup/memberships/${membershipId}`,
        method: 'PUT',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearngroupMembershipsMailCreateByMembershipId
     * @request POST:/learngroup/memberships/{membership_id}/mail
     */
    membershipsMailCreateByMembershipId: (
      membershipId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | LearngroupMembershipMailPostForbidden
        | LearngroupMembershipMailPostNotFound
        | LearngroupMembershipMailPostUnprocessableEntity
        | LearngroupMembershipMailPostTooManyRequests
        | LearngroupMembershipMailPostInternalError
      >({
        path: `/learngroup/memberships/${membershipId}/mail`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearngroupScoringList
     * @request GET:/learngroup/scoring
     */
    scoringList: (
      query?: {
        /**
         * @format date
         * @default null
         */
        since?: string | null
      },
      params: RequestParams = {},
    ) =>
      this.request<
        LearngroupScoring,
        LearngroupScoringGetForbidden | LearngroupScoringGetNotFound
      >({
        path: `/learngroup/scoring`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  learnpaths = {
    /**
     * @name LearnpathsAssignedList
     * @request GET:/learnpaths/assigned
     */
    assignedList: (
      query?: {
        /** @default false */
        is_course?: boolean
        categories?: string[]
      },
      params: RequestParams = {},
    ) =>
      this.request<AssignedLearnpaths, any>({
        path: `/learnpaths/assigned`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsAssignedCategoriesList
     * @request GET:/learnpaths/assigned/categories
     */
    assignedCategoriesList: (
      query?: {
        /** @default false */
        is_courses_view?: boolean
      },
      params: RequestParams = {},
    ) =>
      this.request<LearnpathCategories, any>({
        path: `/learnpaths/assigned/categories`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsAssignedCurrentList
     * @request GET:/learnpaths/assigned/current
     */
    assignedCurrentList: (params: RequestParams = {}) =>
      this.request<AssignedCurrentLearnpath, Empty>({
        path: `/learnpaths/assigned/current`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsAssignedUpcomingEventList
     * @request GET:/learnpaths/assigned/upcoming-event
     */
    assignedUpcomingEventList: (params: RequestParams = {}) =>
      this.request<AssignedUpcomingEvent, Empty>({
        path: `/learnpaths/assigned/upcoming-event`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsAssignedGetByLearnpathId
     * @request GET:/learnpaths/assigned/{learnpath_id}
     */
    assignedGetByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AssignedLearnpath,
        AssignedLearnpathGetNotFound | AssignedLearnpathGetUnprocessableContent
      >({
        path: `/learnpaths/assigned/${learnpathId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsAssignedConfirmCompletionCreateByLearnpathId
     * @request POST:/learnpaths/assigned/{learnpath_id}/confirm-completion
     */
    assignedConfirmCompletionCreateByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<Empty, any>({
        path: `/learnpaths/assigned/${learnpathId}/confirm-completion`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsAssignedElementsQuizCheckQuestionCreateByQuestionId
     * @request POST:/learnpaths/assigned/{learnpath_id}/elements/quiz/{quiz_id}/check_question/{question_id}
     */
    assignedElementsQuizCheckQuestionCreateByQuestionId: (
      learnpathId: string,
      quizId: string,
      questionId: string,
      data?: AssignedLearnpathQuizElementCheckQuestionPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        AssignedLearnpathQuizElementCheckQuestion,
        | AssignedLearnpathQuizElementCheckQuestionPostNotFound
        | AssignedLearnpathQuizElementCheckQuestionPostUnprocessableContent
      >({
        path: `/learnpaths/assigned/${learnpathId}/elements/quiz/${quizId}/check_question/${questionId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsAssignedElementsGetByElementId
     * @request GET:/learnpaths/assigned/{learnpath_id}/elements/{element_id}
     */
    assignedElementsGetByElementId: (
      learnpathId: string,
      elementId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        | AssignedLearnpathElementGetForbidden
        | AssignedLearnpathElementGetNotFound
        | AssignedLearnpathElementGetUnprocessableContent
        | AssignedLearnpathElementOneOf
      >({
        path: `/learnpaths/assigned/${learnpathId}/elements/${elementId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @name LearnpathsAssignedElementsProgressUpdateByElementId
     * @request PUT:/learnpaths/assigned/{learnpath_id}/elements/{element_id}/progress
     */
    assignedElementsProgressUpdateByElementId: (
      learnpathId: string,
      elementId: string,
      data?: AssignedLearnpathElementProgressPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        AssignedLearnpathElementProgress,
        | AssignedLearnpathElementProgressPutForbidden
        | AssignedLearnpathElementProgressPutNotFound
        | AssignedLearnpathElementProgressPutUnprocessableContent
      >({
        path: `/learnpaths/assigned/${learnpathId}/elements/${elementId}/progress`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsAssignedLanguagesGetByLearnpathId
     * @request GET:/learnpaths/assigned/{learnpath_id}/languages
     */
    assignedLanguagesGetByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AssignedLearnpathLanguages,
        AssignedLearnpathLanguagesGetNotFound
      >({
        path: `/learnpaths/assigned/${learnpathId}/languages`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsAssignedSetLanguageCreateByLearnpathId
     * @request POST:/learnpaths/assigned/{learnpath_id}/set-language
     */
    assignedSetLanguageCreateByLearnpathId: (
      learnpathId: string,
      data?: AssignedLearnpathSetLanguageRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        AssignedLearnpathSetLanguageResponse,
        | AssignedLearnpathSetLanguagePostNotFound
        | AssignedLearnpathSetLanguagePostUnprocessableContent
      >({
        path: `/learnpaths/assigned/${learnpathId}/set-language`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsJoinCreateBySharingLinkId
     * @request POST:/learnpaths/join/{sharing_link_id}
     */
    joinCreateBySharingLinkId: (
      sharingLinkId: string,
      query?: {
        /** @default "link" */
        assignment_method?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<
        AssignedLearnpath,
        | LearnpathJoinByLinkPostForbidden
        | LearnpathJoinByLinkPostNotFound
        | LearnpathJoinByLinkPostUnprocessableContent
      >({
        path: `/learnpaths/join/${sharingLinkId}`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedDelete
     * @request DELETE:/learnpaths/managed
     */
    managedDelete: (
      data?: ManagedLearnpathsDeleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/learnpaths/managed`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @name LearnpathsManagedList
     * @request GET:/learnpaths/managed
     */
    managedList: (
      query?: {
        /**
         * @minLength 1
         * @maxLength 60
         */
        name?: string
        status?: 'active' | 'scheduled' | 'draft' | 'inactive'
        types?: 'mandatory' | 'linear' | 'certificate'
        user?: string[]
        group?: string[]
        owner?: (string | null)[]
        default_lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
        lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
        /** @default false */
        is_course?: boolean
        /** @default false */
        with_managed_learners?: boolean
        /** @default true */
        only_direct_learners_stats?: boolean
        categories?: string[]
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedLearnpaths, any>({
        path: `/learnpaths/managed`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedCreate
     * @request POST:/learnpaths/managed
     */
    managedCreate: (
      data?: ManagedLearnpathsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpath,
        | ManagedLearnpathsPostForbidden
        | ManagedLearnpathsPostUnprocessableContent
        | ManagedLearnpathsPostInternalServerError
      >({
        path: `/learnpaths/managed`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedCategoriesList
     * @request GET:/learnpaths/managed/categories
     */
    managedCategoriesList: (
      query?: {
        /** @default false */
        is_courses_view?: boolean
      },
      params: RequestParams = {},
    ) =>
      this.request<LearnpathCategories, any>({
        path: `/learnpaths/managed/categories`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedStatsCompletionCsvCreate
     * @request POST:/learnpaths/managed/stats/completion/csv
     */
    managedStatsCompletionCsvCreate: (
      data?: ManagedLearnpathsCompletionBulkStatisticsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, ManagedLearnpathsCompletionBulkStatisticsPostNotFound>({
        path: `/learnpaths/managed/stats/completion/csv`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @name LearnpathsManagedDeleteByLearnpathId
     * @request DELETE:/learnpaths/managed/{learnpath_id}
     */
    managedDeleteByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathDeleteForbidden
        | ManagedLearnpathDeleteNotFound
        | ManagedLearnpathDeleteInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedGetByLearnpathId
     * @request GET:/learnpaths/managed/{learnpath_id}
     */
    managedGetByLearnpathId: (
      learnpathId: string,
      query?: {
        /** @default true */
        only_direct_learners_stats?: boolean
        lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedLearnpath, ManagedLearnpathGetNotFound>({
        path: `/learnpaths/managed/${learnpathId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedUpdateByLearnpathId
     * @request PUT:/learnpaths/managed/{learnpath_id}
     */
    managedUpdateByLearnpathId: (
      learnpathId: string,
      data?: ManagedLearnpathPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpath,
        | ManagedLearnpathPutForbidden
        | ManagedLearnpathPutNotFound
        | ManagedLearnpathPutUnprocessableContent
        | ManagedLearnpathPutInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedActionsActivateCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/actions/activate
     */
    managedActionsActivateCreateByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathActivateActionPostForbidden
        | ManagedLearnpathActivateActionPostNotFound
        | ManagedLearnpathActivateActionPostUnprocessableContent
      >({
        path: `/learnpaths/managed/${learnpathId}/actions/activate`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedActionsDeactivateCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/actions/deactivate
     */
    managedActionsDeactivateCreateByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathDeactivateActionPostForbidden
        | ManagedLearnpathDeactivateActionPostNotFound
        | ManagedLearnpathDeactivateActionPostUnprocessableContent
      >({
        path: `/learnpaths/managed/${learnpathId}/actions/deactivate`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedActionsDuplicateCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/actions/duplicate
     */
    managedActionsDuplicateCreateByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathDuplicateActionResponse,
        | ManagedLearnpathDuplicateActionPostNotFound
        | ManagedLearnpathDuplicateActionPostInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/actions/duplicate`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedActionsDuplicateAsCourseCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/actions/duplicate-as-course
     */
    managedActionsDuplicateAsCourseCreateByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathDuplicateAsCourseActionResponse,
        | ManagedLearnpathDuplicateAsCourseActionPostNotFound
        | ManagedLearnpathDuplicateAsCourseActionPostUnprocessableContent
        | ManagedLearnpathDuplicateAsCourseActionPostInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/actions/duplicate-as-course`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedActionsDuplicateAsLearnpathCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/actions/duplicate-as-learnpath
     */
    managedActionsDuplicateAsLearnpathCreateByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathDuplicateAsLearnpathActionResponse,
        | ManagedLearnpathDuplicateAsLearnpathActionPostNotFound
        | ManagedLearnpathDuplicateAsLearnpathActionPostUnprocessableContent
        | ManagedLearnpathDuplicateAsLearnpathActionPostInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/actions/duplicate-as-learnpath`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedActionsSendExpirationReminderBulkCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/actions/send-expiration-reminder-bulk
     */
    managedActionsSendExpirationReminderBulkCreateByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<Empty, any>({
        path: `/learnpaths/managed/${learnpathId}/actions/send-expiration-reminder-bulk`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedActionsToggleLinkSharingCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/actions/toggle-link-sharing
     */
    managedActionsToggleLinkSharingCreateByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathSharingLink,
        ManagedLearnpathToggleLinkSharingActionPostNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/actions/toggle-link-sharing`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedCandidatesGetByLearnpathId
     * @request GET:/learnpaths/managed/{learnpath_id}/candidates
     */
    managedCandidatesGetByLearnpathId: (
      learnpathId: string,
      query?: {
        /**
         * @minLength 3
         * @default null
         */
        query?: string | null
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedLearnpathCandidates, any>({
        path: `/learnpaths/managed/${learnpathId}/candidates`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedCatalogPlatformTopicsGetByLearnpathId
     * @request GET:/learnpaths/managed/{learnpath_id}/catalog/platform-topics
     */
    managedCatalogPlatformTopicsGetByLearnpathId: (
      learnpathId: string,
      query?: {
        /** @default null */
        q?: string | null
        /** @default null */
        order?: 'relevance' | 'top_rated' | 'most_viewed' | 'most_recent' | null
        /** @default [] */
        tags?: string[]
        /** @default null */
        locale?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt-br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
        /** @default null */
        content_type?: 'video' | 'text' | 'chatbot' | 'scorm' | null
        /**
         * @min 0
         * @default null
         */
        offset?: number | null
        /**
         * @min 1
         * @max 25
         * @default null
         */
        limit?: number | null
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedLearnpathPlatformTopicsCatalog, any>({
        path: `/learnpaths/managed/${learnpathId}/catalog/platform-topics`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsGetByLearnpathId
     * @request GET:/learnpaths/managed/{learnpath_id}/elements
     */
    managedElementsGetByLearnpathId: (
      learnpathId: string,
      query?: {
        lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathElements,
        ManagedLearnpathElementsGetNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsUpdateByLearnpathId
     * @request PUT:/learnpaths/managed/{learnpath_id}/elements
     */
    managedElementsUpdateByLearnpathId: (
      learnpathId: string,
      data?: ManagedLearnpathElementsPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathElements,
        | ManagedLearnpathElementsPutForbidden
        | ManagedLearnpathElementsPutUnprocessableContent
      >({
        path: `/learnpaths/managed/${learnpathId}/elements`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsEmbeddedVideoCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/elements/embedded-video
     */
    managedElementsEmbeddedVideoCreateByLearnpathId: (
      learnpathId: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        next_element_id?: string | null
      },
      data?: ManagedLearnpathEmbeddedVideoElementsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathEmbeddedVideoElement,
        | ManagedLearnpathEmbeddedVideoElementsPostForbidden
        | ManagedLearnpathEmbeddedVideoElementsPostNotFound
        | ManagedLearnpathEmbeddedVideoElementsPostConflict
        | ManagedLearnpathEmbeddedVideoElementsPostInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/embedded-video`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsEmbeddedVideoDeleteByElementId
     * @request DELETE:/learnpaths/managed/{learnpath_id}/elements/embedded-video/{element_id}
     */
    managedElementsEmbeddedVideoDeleteByElementId: (
      learnpathId: string,
      elementId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathEmbeddedVideoElementDeleteForbidden
        | ManagedLearnpathEmbeddedVideoElementDeleteNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/embedded-video/${elementId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsEmbeddedVideoGetByElementId
     * @request GET:/learnpaths/managed/{learnpath_id}/elements/embedded-video/{element_id}
     */
    managedElementsEmbeddedVideoGetByElementId: (
      learnpathId: string,
      elementId: string,
      query?: {
        lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathEmbeddedVideoElement,
        ManagedLearnpathEmbeddedVideoElementGetNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/embedded-video/${elementId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsEmbeddedVideoUpdateByElementId
     * @request PUT:/learnpaths/managed/{learnpath_id}/elements/embedded-video/{element_id}
     */
    managedElementsEmbeddedVideoUpdateByElementId: (
      learnpathId: string,
      elementId: string,
      data?: ManagedLearnpathEmbeddedVideoElementPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathEmbeddedVideoElement,
        | ManagedLearnpathEmbeddedVideoElementPutForbidden
        | ManagedLearnpathEmbeddedVideoElementPutNotFound
        | ManagedLearnpathEmbeddedVideoElementPutInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/embedded-video/${elementId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsEventCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/elements/event
     */
    managedElementsEventCreateByLearnpathId: (
      learnpathId: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        next_element_id?: string | null
      },
      data?: ManagedLearnpathEventElementsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathEventElement,
        | ManagedLearnpathEventElementsPostForbidden
        | ManagedLearnpathEventElementsPostNotFound
        | ManagedLearnpathEventElementsPostConflict
        | ManagedLearnpathEventElementsPostUnprocessableContent
        | ManagedLearnpathEventElementsPostInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/event`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsEventDeleteByElementId
     * @request DELETE:/learnpaths/managed/{learnpath_id}/elements/event/{element_id}
     */
    managedElementsEventDeleteByElementId: (
      learnpathId: string,
      elementId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathEventElementDeleteForbidden
        | ManagedLearnpathEventElementDeleteNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/event/${elementId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsEventGetByElementId
     * @request GET:/learnpaths/managed/{learnpath_id}/elements/event/{element_id}
     */
    managedElementsEventGetByElementId: (
      learnpathId: string,
      elementId: string,
      query?: {
        lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathEventElement,
        ManagedLearnpathEventElementGetNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/event/${elementId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsEventUpdateByElementId
     * @request PUT:/learnpaths/managed/{learnpath_id}/elements/event/{element_id}
     */
    managedElementsEventUpdateByElementId: (
      learnpathId: string,
      elementId: string,
      data?: ManagedLearnpathEventElementPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathEventElement,
        | ManagedLearnpathEventElementPutForbidden
        | ManagedLearnpathEventElementPutNotFound
        | ManagedLearnpathEventElementPutInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/event/${elementId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsFileCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/elements/file
     */
    managedElementsFileCreateByLearnpathId: (
      learnpathId: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        next_element_id?: string | null
      },
      data?: ManagedLearnpathFileElementsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathFileElement,
        | ManagedLearnpathFileElementsPostForbidden
        | ManagedLearnpathFileElementsPostNotFound
        | ManagedLearnpathFileElementsPostConflict
        | ManagedLearnpathFileElementsPostInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/file`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsFileDeleteByElementId
     * @request DELETE:/learnpaths/managed/{learnpath_id}/elements/file/{element_id}
     */
    managedElementsFileDeleteByElementId: (
      learnpathId: string,
      elementId: string,
      params: RequestParams = {},
    ) =>
      this.request<Empty, ManagedLearnpathFileElementDeleteForbidden>({
        path: `/learnpaths/managed/${learnpathId}/elements/file/${elementId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsFileGetByElementId
     * @request GET:/learnpaths/managed/{learnpath_id}/elements/file/{element_id}
     */
    managedElementsFileGetByElementId: (
      learnpathId: string,
      elementId: string,
      query?: {
        lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathFileElement,
        ManagedLearnpathFileElementGetNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/file/${elementId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsFileUpdateByElementId
     * @request PUT:/learnpaths/managed/{learnpath_id}/elements/file/{element_id}
     */
    managedElementsFileUpdateByElementId: (
      learnpathId: string,
      elementId: string,
      data?: ManagedLearnpathFileElementPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathFileElement,
        | ManagedLearnpathFileElementPutForbidden
        | ManagedLearnpathFileElementPutNotFound
        | ManagedLearnpathFileElementPutInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/file/${elementId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsLinkCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/elements/link
     */
    managedElementsLinkCreateByLearnpathId: (
      learnpathId: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        next_element_id?: string | null
      },
      data?: ManagedLearnpathLinkElementsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathLinkElement,
        | ManagedLearnpathLinkElementsPostForbidden
        | ManagedLearnpathLinkElementsPostNotFound
        | ManagedLearnpathLinkElementsPostConflict
        | ManagedLearnpathLinkElementsPostInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/link`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsLinkDeleteByElementId
     * @request DELETE:/learnpaths/managed/{learnpath_id}/elements/link/{element_id}
     */
    managedElementsLinkDeleteByElementId: (
      learnpathId: string,
      elementId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathLinkElementDeleteForbidden
        | ManagedLearnpathLinkElementDeleteNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/link/${elementId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsLinkGetByElementId
     * @request GET:/learnpaths/managed/{learnpath_id}/elements/link/{element_id}
     */
    managedElementsLinkGetByElementId: (
      learnpathId: string,
      elementId: string,
      query?: {
        lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathLinkElement,
        ManagedLearnpathLinkElementGetNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/link/${elementId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsLinkUpdateByElementId
     * @request PUT:/learnpaths/managed/{learnpath_id}/elements/link/{element_id}
     */
    managedElementsLinkUpdateByElementId: (
      learnpathId: string,
      elementId: string,
      data?: ManagedLearnpathLinkElementPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathLinkElement,
        | ManagedLearnpathLinkElementPutForbidden
        | ManagedLearnpathLinkElementPutNotFound
        | ManagedLearnpathLinkElementPutInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/link/${elementId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsPlatformTopicCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/elements/platform-topic
     */
    managedElementsPlatformTopicCreateByLearnpathId: (
      learnpathId: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        next_element_id?: string | null
      },
      data?: ManagedLearnpathPlatformTopicElementPostRequest[],
      params: RequestParams = {},
    ) =>
      this.request<ManagedLearnpathPlatformTopicElementsPostResponse[], any>({
        path: `/learnpaths/managed/${learnpathId}/elements/platform-topic`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsPlatformTopicDeleteByElementId
     * @request DELETE:/learnpaths/managed/{learnpath_id}/elements/platform-topic/{element_id}
     */
    managedElementsPlatformTopicDeleteByElementId: (
      learnpathId: string,
      elementId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathPlatformTopicElementDeleteForbidden
        | ManagedLearnpathPlatformTopicElementDeleteNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/platform-topic/${elementId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsPlatformTopicGetByElementId
     * @request GET:/learnpaths/managed/{learnpath_id}/elements/platform-topic/{element_id}
     */
    managedElementsPlatformTopicGetByElementId: (
      learnpathId: string,
      elementId: string,
      query?: {
        lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathPlatformTopicElement,
        ManagedLearnpathPlatformTopicElementGetNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/platform-topic/${elementId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsPlatformTopicUpdateByElementId
     * @request PUT:/learnpaths/managed/{learnpath_id}/elements/platform-topic/{element_id}
     */
    managedElementsPlatformTopicUpdateByElementId: (
      learnpathId: string,
      elementId: string,
      data?: ManagedLearnpathPlatformTopicElementPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathPlatformTopicElement,
        | ManagedLearnpathPlatformTopicElementPutForbidden
        | ManagedLearnpathPlatformTopicElementPutNotFound
        | ManagedLearnpathPlatformTopicElementPutUnprocessableContent
        | ManagedLearnpathPlatformTopicElementPutInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/platform-topic/${elementId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsQuizCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/elements/quiz
     */
    managedElementsQuizCreateByLearnpathId: (
      learnpathId: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        next_element_id?: string | null
      },
      data?: ManagedLearnpathQuizElementsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathQuizElement,
        | ManagedLearnpathQuizElementsPostForbidden
        | ManagedLearnpathQuizElementsPostNotFound
        | ManagedLearnpathQuizElementsPostConflict
        | ManagedLearnpathQuizElementsPostInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/quiz`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsQuizDeleteByElementId
     * @request DELETE:/learnpaths/managed/{learnpath_id}/elements/quiz/{element_id}
     */
    managedElementsQuizDeleteByElementId: (
      learnpathId: string,
      elementId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathQuizElementDeleteForbidden
        | ManagedLearnpathQuizElementDeleteNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/quiz/${elementId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsQuizGetByElementId
     * @request GET:/learnpaths/managed/{learnpath_id}/elements/quiz/{element_id}
     */
    managedElementsQuizGetByElementId: (
      learnpathId: string,
      elementId: string,
      query?: {
        lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathQuizElement,
        ManagedLearnpathQuizElementGetNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/quiz/${elementId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsQuizUpdateByElementId
     * @request PUT:/learnpaths/managed/{learnpath_id}/elements/quiz/{element_id}
     */
    managedElementsQuizUpdateByElementId: (
      learnpathId: string,
      elementId: string,
      data?: ManagedLearnpathQuizElementPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathQuizElement,
        | ManagedLearnpathQuizElementPutForbidden
        | ManagedLearnpathQuizElementPutNotFound
        | ManagedLearnpathQuizElementPutConflict
        | ManagedLearnpathQuizElementPutInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/quiz/${elementId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsScormCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/elements/scorm
     */
    managedElementsScormCreateByLearnpathId: (
      learnpathId: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        next_element_id?: string | null
      },
      data?: ManagedLearnpathScormElementsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathScormElement,
        | ManagedLearnpathScormElementsPostForbidden
        | ManagedLearnpathScormElementsPostNotFound
        | ManagedLearnpathScormElementsPostConflict
        | ManagedLearnpathScormElementsPostUnprocessableContent
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/scorm`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsScormDeleteByElementId
     * @request DELETE:/learnpaths/managed/{learnpath_id}/elements/scorm/{element_id}
     */
    managedElementsScormDeleteByElementId: (
      learnpathId: string,
      elementId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathScormElementDeleteForbidden
        | ManagedLearnpathScormElementDeleteNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/scorm/${elementId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsScormGetByElementId
     * @request GET:/learnpaths/managed/{learnpath_id}/elements/scorm/{element_id}
     */
    managedElementsScormGetByElementId: (
      learnpathId: string,
      elementId: string,
      query?: {
        lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathScormElement,
        ManagedLearnpathScormElementGetNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/scorm/${elementId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsScormUpdateByElementId
     * @request PUT:/learnpaths/managed/{learnpath_id}/elements/scorm/{element_id}
     */
    managedElementsScormUpdateByElementId: (
      learnpathId: string,
      elementId: string,
      data?: ManagedLearnpathScormElementPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathScormElement,
        | ManagedLearnpathScormElementPutForbidden
        | ManagedLearnpathScormElementPutNotFound
        | ManagedLearnpathScormElementPutUnprocessableContent
        | ManagedLearnpathScormElementPutInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/scorm/${elementId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsTextCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/elements/text
     */
    managedElementsTextCreateByLearnpathId: (
      learnpathId: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        next_element_id?: string | null
      },
      data?: ManagedLearnpathTextElementsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathTextElement,
        | ManagedLearnpathTextElementsPostForbidden
        | ManagedLearnpathTextElementsPostNotFound
        | ManagedLearnpathTextElementsPostConflict
        | ManagedLearnpathTextElementsPostInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/text`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsTextDeleteByElementId
     * @request DELETE:/learnpaths/managed/{learnpath_id}/elements/text/{element_id}
     */
    managedElementsTextDeleteByElementId: (
      learnpathId: string,
      elementId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathTextElementDeleteForbidden
        | ManagedLearnpathTextElementDeleteNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/text/${elementId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsTextGetByElementId
     * @request GET:/learnpaths/managed/{learnpath_id}/elements/text/{element_id}
     */
    managedElementsTextGetByElementId: (
      learnpathId: string,
      elementId: string,
      query?: {
        lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathTextElement,
        ManagedLearnpathTextElementGetNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/text/${elementId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsTextUpdateByElementId
     * @request PUT:/learnpaths/managed/{learnpath_id}/elements/text/{element_id}
     */
    managedElementsTextUpdateByElementId: (
      learnpathId: string,
      elementId: string,
      data?: ManagedLearnpathTextElementPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathTextElement,
        | ManagedLearnpathTextElementPutForbidden
        | ManagedLearnpathTextElementPutNotFound
        | ManagedLearnpathTextElementPutInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/text/${elementId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsVideoCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/elements/video
     */
    managedElementsVideoCreateByLearnpathId: (
      learnpathId: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        next_element_id?: string | null
      },
      data?: ManagedLearnpathVideoElementsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathVideoElement,
        | ManagedLearnpathVideoElementsPostForbidden
        | ManagedLearnpathVideoElementsPostNotFound
        | ManagedLearnpathVideoElementsPostConflict
        | ManagedLearnpathVideoElementsPostInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/video`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsVideoDeleteByElementId
     * @request DELETE:/learnpaths/managed/{learnpath_id}/elements/video/{element_id}
     */
    managedElementsVideoDeleteByElementId: (
      learnpathId: string,
      elementId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathVideoElementDeleteForbidden
        | ManagedLearnpathVideoElementDeleteNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/video/${elementId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsVideoGetByElementId
     * @request GET:/learnpaths/managed/{learnpath_id}/elements/video/{element_id}
     */
    managedElementsVideoGetByElementId: (
      learnpathId: string,
      elementId: string,
      query?: {
        lang?:
          | 'de'
          | 'en'
          | 'es'
          | 'fr'
          | 'it'
          | 'cs'
          | 'hu'
          | 'pl'
          | 'pt'
          | 'sk'
          | 'el'
          | 'tr'
          | 'nl'
          | 'pt_br'
          | 'ru'
          | 'sl'
          | 'ja'
          | 'ko'
          | 'zh'
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathVideoElement,
        ManagedLearnpathVideoElementGetNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/video/${elementId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedElementsVideoUpdateByElementId
     * @request PUT:/learnpaths/managed/{learnpath_id}/elements/video/{element_id}
     */
    managedElementsVideoUpdateByElementId: (
      learnpathId: string,
      elementId: string,
      data?: ManagedLearnpathVideoElementPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathVideoElement,
        | ManagedLearnpathVideoElementPutForbidden
        | ManagedLearnpathVideoElementPutNotFound
        | ManagedLearnpathVideoElementPutInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/elements/video/${elementId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedLanguagesGetByLearnpathId
     * @request GET:/learnpaths/managed/{learnpath_id}/languages
     */
    managedLanguagesGetByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathLanguages,
        ManagedLearnpathLanguagesGetNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/languages`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedLanguagesCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/languages
     */
    managedLanguagesCreateByLearnpathId: (
      learnpathId: string,
      data?: ManagedLearnpathLanguagePostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathLanguage,
        | ManagedLearnpathLanguagesPostForbidden
        | ManagedLearnpathLanguagesPostNotFound
        | ManagedLearnpathLanguagesPostConflict
        | ManagedLearnpathLanguagesPostUnprocessableContent
      >({
        path: `/learnpaths/managed/${learnpathId}/languages`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedLanguagesDeleteByCode
     * @request DELETE:/learnpaths/managed/{learnpath_id}/languages/{code}
     */
    managedLanguagesDeleteByCode: (
      learnpathId: string,
      code: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathLanguageDeleteForbidden
        | ManagedLearnpathLanguageDeleteNotFound
        | ManagedLearnpathLanguageDeleteUnprocessableContent
      >({
        path: `/learnpaths/managed/${learnpathId}/languages/${code}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedLanguagesUpdateByCode
     * @request PUT:/learnpaths/managed/{learnpath_id}/languages/{code}
     */
    managedLanguagesUpdateByCode: (
      learnpathId: string,
      code: string,
      data?: ManagedLearnpathLanguagePutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathLanguage,
        | ManagedLearnpathLanguagePutForbidden
        | ManagedLearnpathLanguagePutNotFound
        | ManagedLearnpathLanguagePutUnprocessableContent
      >({
        path: `/learnpaths/managed/${learnpathId}/languages/${code}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedMembersDeleteByLearnpathId
     * @request DELETE:/learnpaths/managed/{learnpath_id}/members
     */
    managedMembersDeleteByLearnpathId: (
      learnpathId: string,
      data?: ManagedLearnpathMembersDeleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<ManagedLearnpathMembers, any>({
        path: `/learnpaths/managed/${learnpathId}/members`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedMembersGetByLearnpathId
     * @request GET:/learnpaths/managed/{learnpath_id}/members
     */
    managedMembersGetByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<ManagedLearnpathMembers, any>({
        path: `/learnpaths/managed/${learnpathId}/members`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedMembersCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/members
     */
    managedMembersCreateByLearnpathId: (
      learnpathId: string,
      data?: ManagedLearnpathMembersPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathMembers,
        | ManagedLearnpathMembersPostForbidden
        | ManagedLearnpathMembersPostUnprocessableContent
        | ManagedLearnpathMembersPostInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/members`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedSendEnabledNotificationsCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/send-enabled-notifications
     */
    managedSendEnabledNotificationsCreateByLearnpathId: (
      learnpathId: string,
      data?: ManagedLearnpathEnabledNotifications,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/learnpaths/managed/${learnpathId}/send-enabled-notifications`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @name LearnpathsManagedStatsCompletionCsvGetByLearnpathId
     * @request GET:/learnpaths/managed/{learnpath_id}/stats/completion/csv
     */
    managedStatsCompletionCsvGetByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ManagedLearnpathCompletionStatisticsGetNotFound>({
        path: `/learnpaths/managed/${learnpathId}/stats/completion/csv`,
        method: 'GET',
        ...params,
      }),

    /**
     * @name LearnpathsManagedStatsQuizCsvGetByLearnpathId
     * @request GET:/learnpaths/managed/{learnpath_id}/stats/quiz/csv
     */
    managedStatsQuizCsvGetByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ManagedLearnpathQuizStatisticsGetNotFound>({
        path: `/learnpaths/managed/${learnpathId}/stats/quiz/csv`,
        method: 'GET',
        ...params,
      }),

    /**
     * @name LearnpathsManagedTranslationsGetByCode
     * @request GET:/learnpaths/managed/{learnpath_id}/translations/{code}
     */
    managedTranslationsGetByCode: (
      learnpathId: string,
      code: string,
      params: RequestParams = {},
    ) =>
      this.request<
        LearnpathTranslations,
        | ManagedLearnpathTranslationsGetNotFound
        | ManagedLearnpathTranslationsGetUnprocessableContent
      >({
        path: `/learnpaths/managed/${learnpathId}/translations/${code}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedTranslationsUpdateByCode
     * @request PUT:/learnpaths/managed/{learnpath_id}/translations/{code}
     */
    managedTranslationsUpdateByCode: (
      learnpathId: string,
      code: string,
      data?: LearnpathTranslationsPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        LearnpathTranslations,
        | ManagedLearnpathTranslationsPutForbidden
        | ManagedLearnpathTranslationsPutNotFound
        | ManagedLearnpathTranslationsPutUnprocessableContent
      >({
        path: `/learnpaths/managed/${learnpathId}/translations/${code}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedUserGroupsDeleteByLearnpathId
     * @request DELETE:/learnpaths/managed/{learnpath_id}/user_groups
     */
    managedUserGroupsDeleteByLearnpathId: (
      learnpathId: string,
      data?: ManagedLearnpathUserGroupsDeleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<Empty, ManagedLearnpathUserGroupsDeleteNotFound>({
        path: `/learnpaths/managed/${learnpathId}/user_groups`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedUserGroupsGetByLearnpathId
     * @request GET:/learnpaths/managed/{learnpath_id}/user_groups
     */
    managedUserGroupsGetByLearnpathId: (
      learnpathId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedLearnpathUserGroups,
        ManagedLearnpathUserGroupsGetNotFound
      >({
        path: `/learnpaths/managed/${learnpathId}/user_groups`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedUserGroupsCreateByLearnpathId
     * @request POST:/learnpaths/managed/{learnpath_id}/user_groups
     */
    managedUserGroupsCreateByLearnpathId: (
      learnpathId: string,
      data?: ManagedLearnpathUserGroupsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | ManagedLearnpathUserGroupsPostNotFound
        | ManagedLearnpathUserGroupsPostInternalServerError
      >({
        path: `/learnpaths/managed/${learnpathId}/user_groups`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsManagedUserGroupsUpdateByLearnpathId
     * @request PUT:/learnpaths/managed/{learnpath_id}/user_groups
     */
    managedUserGroupsUpdateByLearnpathId: (
      learnpathId: string,
      data?: ManagedLearnpathUserGroupsPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<Empty, ManagedLearnpathUserGroupsPutNotFound>({
        path: `/learnpaths/managed/${learnpathId}/user_groups`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsMembershipsDeleteByUserId
     * @request DELETE:/learnpaths/memberships/{user_id}
     */
    membershipsDeleteByUserId: (
      userId: string,
      data?: LearnpathUserMembershipsBulkRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | LearnpathMembershipsOverviewDeleteForbidden
        | LearnpathMembershipsOverviewDeleteNotFound
      >({
        path: `/learnpaths/memberships/${userId}`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsMembershipsGetByUserId
     * @request GET:/learnpaths/memberships/{user_id}
     */
    membershipsGetByUserId: (
      userId: string,
      query?: {
        /** @min 0 */
        offset?: number
        /**
         * Page size. Use -1 to return all learnpaths.
         * @min -1
         */
        size?: number
        /** @default true */
        is_member?: boolean
        /** @default false */
        created_by_me?: boolean
        status?: 'active' | 'scheduled' | 'draft' | 'inactive'
        types?: 'mandatory' | 'linear' | 'certificate'
        categories?: string[]
      },
      params: RequestParams = {},
    ) =>
      this.request<LearnpathsOverview, LearnpathMembershipsOverviewGetNotFound>(
        {
          path: `/learnpaths/memberships/${userId}`,
          method: 'GET',
          query: query,
          format: 'json',
          ...params,
        },
      ),

    /**
     * @name LearnpathsMembershipsCreateByUserId
     * @request POST:/learnpaths/memberships/{user_id}
     */
    membershipsCreateByUserId: (
      userId: string,
      data?: LearnpathUserMembershipsBulkRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | LearnpathMembershipsOverviewPostForbidden
        | LearnpathMembershipsOverviewPostNotFound
      >({
        path: `/learnpaths/memberships/${userId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsUploadsFileCreate
     * @request POST:/learnpaths/uploads/file
     */
    uploadsFileCreate: (
      data?: LearnpathFileUploadsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        LearnpathFileUploadWithPayload,
        | LearnpathFileUploadsPostForbidden
        | LearnpathFileUploadsPostInternalServerError
      >({
        path: `/learnpaths/uploads/file`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsUploadsFileDeleteByUploadId
     * @request DELETE:/learnpaths/uploads/file/{upload_id}
     */
    uploadsFileDeleteByUploadId: (
      uploadId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | LearnpathFileUploadDeleteNotFound
        | LearnpathFileUploadDeleteUnprocessableEntity
        | LearnpathFileUploadDeleteInternalServerError
      >({
        path: `/learnpaths/uploads/file/${uploadId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsUploadsFileGetByUploadId
     * @request GET:/learnpaths/uploads/file/{upload_id}
     */
    uploadsFileGetByUploadId: (uploadId: string, params: RequestParams = {}) =>
      this.request<LearnpathFileUpload, LearnpathFileUploadGetNotFound>({
        path: `/learnpaths/uploads/file/${uploadId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsUploadsFileUpdateByUploadId
     * @request PUT:/learnpaths/uploads/file/{upload_id}
     */
    uploadsFileUpdateByUploadId: (
      uploadId: string,
      data?: LearnpathFileUploadPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        LearnpathFileUpload,
        | LearnpathFileUploadPutNotFound
        | LearnpathFileUploadPutUnprocessableEntity
      >({
        path: `/learnpaths/uploads/file/${uploadId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsUploadsThumbnailCreate
     * @request POST:/learnpaths/uploads/thumbnail
     */
    uploadsThumbnailCreate: (
      data?: ThumbnailsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<ThumbnailsPostResponse, any>({
        path: `/learnpaths/uploads/thumbnail`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsUploadsThumbnailDeleteByUploadId
     * @request DELETE:/learnpaths/uploads/thumbnail/{upload_id}
     */
    uploadsThumbnailDeleteByUploadId: (
      uploadId: string,
      params: RequestParams = {},
    ) =>
      this.request<Empty, LearnpathThumbnailUploadDeleteNotFound>({
        path: `/learnpaths/uploads/thumbnail/${uploadId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsUploadsThumbnailGetByUploadId
     * @request GET:/learnpaths/uploads/thumbnail/{upload_id}
     */
    uploadsThumbnailGetByUploadId: (
      uploadId: string,
      params: RequestParams = {},
    ) =>
      this.request<ThumbnailGetResponse, LearnpathThumbnailUploadGetNotFound>({
        path: `/learnpaths/uploads/thumbnail/${uploadId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsUploadsThumbnailUpdateByUploadId
     * @request PUT:/learnpaths/uploads/thumbnail/{upload_id}
     */
    uploadsThumbnailUpdateByUploadId: (
      uploadId: string,
      data?: ThumbnailPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<ThumbnailPutResponse, LearnpathThumbnailUploadPutNotFound>({
        path: `/learnpaths/uploads/thumbnail/${uploadId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsUploadsVideoCreate
     * @request POST:/learnpaths/uploads/video
     */
    uploadsVideoCreate: (
      data?: LearnpathVideoUploadsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        LearnpathVideoUploadWithPayload,
        | LearnpathVideoUploadsPostForbidden
        | LearnpathVideoUploadsPostInternalServerError
      >({
        path: `/learnpaths/uploads/video`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsUploadsVideoDeleteByUploadId
     * @request DELETE:/learnpaths/uploads/video/{upload_id}
     */
    uploadsVideoDeleteByUploadId: (
      uploadId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | LearnpathVideoUploadDeleteNotFound
        | LearnpathVideoUploadDeleteUnprocessableEntity
        | LearnpathVideoUploadDeleteInternalServerError
      >({
        path: `/learnpaths/uploads/video/${uploadId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsUploadsVideoGetByUploadId
     * @request GET:/learnpaths/uploads/video/{upload_id}
     */
    uploadsVideoGetByUploadId: (uploadId: string, params: RequestParams = {}) =>
      this.request<LearnpathVideoUpload, LearnpathVideoUploadGetNotFound>({
        path: `/learnpaths/uploads/video/${uploadId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name LearnpathsUploadsVideoUpdateByUploadId
     * @request PUT:/learnpaths/uploads/video/{upload_id}
     */
    uploadsVideoUpdateByUploadId: (
      uploadId: string,
      data?: LearnpathVideoUploadPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        LearnpathVideoUpload,
        | LearnpathVideoUploadPutNotFound
        | LearnpathVideoUploadPutUnprocessableEntity
      >({
        path: `/learnpaths/uploads/video/${uploadId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  lectures = {
    /**
     * @name LecturesGetBySlug
     * @request GET:/lectures/{topic_slug}/{slug}
     */
    getBySlug: (
      topicSlug: string,
      slug: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/lectures/${topicSlug}/${slug}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @name LecturesBookmarksGetBySlug
     * @request GET:/lectures/{topic_slug}/{slug}/bookmarks
     */
    bookmarksGetBySlug: (
      topicSlug: string,
      slug: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
        /** @default null */
        q?: string | null
      },
      params: RequestParams = {},
    ) =>
      this.request<
        LectureBookmarks,
        BookmarksGetForbidden | BookmarksGetNotFound
      >({
        path: `/lectures/${topicSlug}/${slug}/bookmarks`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LecturesBookmarksCreateBySlug
     * @request POST:/lectures/{topic_slug}/{slug}/bookmarks
     */
    bookmarksCreateBySlug: (
      topicSlug: string,
      slug: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
      },
      data?: BookmarksPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<Bookmark, BookmarksPostForbidden | BookmarksPostNotFound>({
        path: `/lectures/${topicSlug}/${slug}/bookmarks`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LecturesBookmarksDeleteByBookmarkId
     * @request DELETE:/lectures/{topic_slug}/{slug}/bookmarks/{bookmark_id}
     */
    bookmarksDeleteByBookmarkId: (
      topicSlug: string,
      slug: string,
      bookmarkId: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
      },
      params: RequestParams = {},
    ) =>
      this.request<Empty, BookmarkDeleteForbidden | BookmarkDeleteNotFound>({
        path: `/lectures/${topicSlug}/${slug}/bookmarks/${bookmarkId}`,
        method: 'DELETE',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LecturesBookmarksGetByBookmarkId
     * @request GET:/lectures/{topic_slug}/{slug}/bookmarks/{bookmark_id}
     */
    bookmarksGetByBookmarkId: (
      topicSlug: string,
      slug: string,
      bookmarkId: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
      },
      params: RequestParams = {},
    ) =>
      this.request<Bookmark, BookmarkGetForbidden | BookmarkGetNotFound>({
        path: `/lectures/${topicSlug}/${slug}/bookmarks/${bookmarkId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LecturesBookmarksUpdateByBookmarkId
     * @request PUT:/lectures/{topic_slug}/{slug}/bookmarks/{bookmark_id}
     */
    bookmarksUpdateByBookmarkId: (
      topicSlug: string,
      slug: string,
      bookmarkId: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
      },
      data?: BookmarkPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<Bookmark, BookmarkPutForbidden | BookmarkPutNotFound>({
        path: `/lectures/${topicSlug}/${slug}/bookmarks/${bookmarkId}`,
        method: 'PUT',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LecturesFeedbackGetBySlug
     * @request GET:/lectures/{topic_slug}/{slug}/feedback
     */
    feedbackGetBySlug: (
      topicSlug: string,
      slug: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
      },
      params: RequestParams = {},
    ) =>
      this.request<
        UserFeedback,
        UserFeedbackGetForbidden | UserFeedbackGetNotFound
      >({
        path: `/lectures/${topicSlug}/${slug}/feedback`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LecturesFeedbackCreateBySlug
     * @request POST:/lectures/{topic_slug}/{slug}/feedback
     */
    feedbackCreateBySlug: (
      topicSlug: string,
      slug: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
      },
      data?: UserFeedbackPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        UserFeedback,
        | UserFeedbackPostForbidden
        | UserFeedbackPostNotFound
        | UserFeedbackPostUnprocessableEntity1
      >({
        path: `/lectures/${topicSlug}/${slug}/feedback`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LecturesFeedbackUpdateBySlug
     * @request PUT:/lectures/{topic_slug}/{slug}/feedback
     */
    feedbackUpdateBySlug: (
      topicSlug: string,
      slug: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
      },
      data?: UserFeedbackPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        UserFeedback,
        | UserFeedbackPutForbidden
        | UserFeedbackPutNotFound
        | UserFeedbackPostUnprocessableEntity
      >({
        path: `/lectures/${topicSlug}/${slug}/feedback`,
        method: 'PUT',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LecturesProgressUpdateBySlug
     * @request PUT:/lectures/{topic_slug}/{slug}/progress
     */
    progressUpdateBySlug: (
      topicSlug: string,
      slug: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
      },
      data?: ProgressPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Progress,
        | ProgressPutForbidden
        | ProgressPutNotFound
        | ProgressPutConflict
        | ProgressPutUnprocessableEntity
      >({
        path: `/lectures/${topicSlug}/${slug}/progress`,
        method: 'PUT',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LecturesQuizGetBySlug
     * @request GET:/lectures/{topic_slug}/{slug}/quiz
     */
    quizGetBySlug: (
      topicSlug: string,
      slug: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
      },
      params: RequestParams = {},
    ) =>
      this.request<Quiz, QuizGetForbidden | QuizGetNotFound>({
        path: `/lectures/${topicSlug}/${slug}/quiz`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name LecturesQuizUpdateBySlug
     * @request PUT:/lectures/{topic_slug}/{slug}/quiz
     */
    quizUpdateBySlug: (
      topicSlug: string,
      slug: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
      },
      data?: QuizPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Quiz,
        QuizPutForbidden | QuizPutNotFound | QuizPutUnprocessableEntity
      >({
        path: `/lectures/${topicSlug}/${slug}/quiz`,
        method: 'PUT',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LecturesQuizStepUpdateBySlug
     * @request PUT:/lectures/{topic_slug}/{slug}/quiz/step
     */
    quizStepUpdateBySlug: (
      topicSlug: string,
      slug: string,
      query?: {
        /**
         * @format uuid
         * @default null
         */
        learnpath_id?: string | null
      },
      data?: QuizStepPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        QuizStep,
        | QuizStepPutForbidden
        | QuizStepPutNotFound
        | QuizStepPutUnprocessableEntity
      >({
        path: `/lectures/${topicSlug}/${slug}/quiz/step`,
        method: 'PUT',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  lti = {
    /**
     * @name LtiDeepLinkingCreate
     * @request POST:/lti/deep_linking
     */
    deepLinkingCreate: (
      data?: {
        utf8?: string
        id_token: string
        state: string
        commit?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/lti/deep_linking`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * @name LtiDeepLinkingJwtCreate
     * @request POST:/lti/deep_linking_jwt
     */
    deepLinkingJwtCreate: (
      data?: LTIDeepLinkingJWTPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        LTIDeepLinkingJWTPostResponse,
        LTIDeepLinkingJWTPostBadRequest
      >({
        path: `/lti/deep_linking_jwt`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name LtiLaunchCreate
     * @request POST:/lti/launch
     */
    launchCreate: (
      query?: {
        resource_type?: 'topic' | 'learnpath' | 'company_course'
        /** @format uuid */
        resource_id?: string
        page?: 'home' | 'player'
      },
      data?: {
        id_token: string
        state: string
        utf8?: string
        commit?: string
        resource_type?: 'topic' | 'learnpath' | 'company_course'
        /** @format uuid */
        resource_id?: string
        page?: 'home' | 'player'
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/lti/launch`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * @name LtiLaunchCreateByResourceId
     * @request POST:/lti/launch/{resource_type}/{resource_id}
     */
    launchCreateByResourceId: (
      resourceType: string,
      resourceId: string,
      query?: {
        resource_type?: 'topic' | 'learnpath' | 'company_course'
        /** @format uuid */
        resource_id?: string
        page?: 'home' | 'player'
      },
      data?: {
        id_token: string
        state: string
        utf8?: string
        commit?: string
        resource_type?: 'topic' | 'learnpath' | 'company_course'
        /** @format uuid */
        resource_id?: string
        page?: 'home' | 'player'
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/lti/launch/${resourceType}/${resourceId}`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * @name LtiLoginList
     * @request GET:/lti/login
     */
    loginList: (
      query: {
        utf8?: string
        iss: string
        login_hint: string
        target_link_uri: string
        lti_message_hint?: string
        lti_deployment_id?: string
        client_id?: string
        commit?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/lti/login`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @name LtiLoginCreate
     * @request POST:/lti/login
     */
    loginCreate: (
      data?: {
        utf8?: string
        iss: string
        login_hint: string
        target_link_uri: string
        lti_message_hint?: string
        lti_deployment_id?: string
        client_id?: string
        commit?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/lti/login`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  }
  media = {
    /**
     * @name MediaThumbnailsCreate
     * @request POST:/media/thumbnails
     */
    thumbnailsCreate: (
      data?: ThumbnailsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<ThumbnailsPostResponse, any>({
        path: `/media/thumbnails`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name MediaThumbnailsDeleteByThumbnailId
     * @request DELETE:/media/thumbnails/{thumbnail_id}
     */
    thumbnailsDeleteByThumbnailId: (
      thumbnailId: string,
      params: RequestParams = {},
    ) =>
      this.request<Empty, ThumbnailDeleteNotFound>({
        path: `/media/thumbnails/${thumbnailId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name MediaThumbnailsGetByThumbnailId
     * @request GET:/media/thumbnails/{thumbnail_id}
     */
    thumbnailsGetByThumbnailId: (
      thumbnailId: string,
      params: RequestParams = {},
    ) =>
      this.request<ThumbnailGetResponse, ThumbnailGetNotFound>({
        path: `/media/thumbnails/${thumbnailId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name MediaThumbnailsUpdateByThumbnailId
     * @request PUT:/media/thumbnails/{thumbnail_id}
     */
    thumbnailsUpdateByThumbnailId: (
      thumbnailId: string,
      data?: ThumbnailPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<ThumbnailPutResponse, ThumbnailPutNotFound>({
        path: `/media/thumbnails/${thumbnailId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name MediaUploadsVideoWebhooksInitCreate
     * @request POST:/media/uploads/video/webhooks/init
     */
    uploadsVideoWebhooksInitCreate: (
      data?: VideoUploadWebhookInitPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<Empty, VideoUploadWebhookInitPostInternalServerError>({
        path: `/media/uploads/video/webhooks/init`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name MediaUploadsVideoWebhooksReadyCreate
     * @request POST:/media/uploads/video/webhooks/ready
     */
    uploadsVideoWebhooksReadyCreate: (params: RequestParams = {}) =>
      this.request<
        Empty,
        | VideoUploadWebhookReadyPostNotFound
        | VideoUploadWebhookReadyPostUnprocessableContent
      >({
        path: `/media/uploads/video/webhooks/ready`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name MediaVideoLecturesAudioList
     * @request GET:/media/video-lectures/audio
     */
    videoLecturesAudioList: (
      query: {
        /** @format uuid */
        video_lecture_uid: string
        audio_lang: string
      },
      params: RequestParams = {},
    ) =>
      this.request<
        VideoLectureAudioGetResponse,
        | VideoLecturesAudioGetForbidden
        | VideoLecturesAudioGetNotFound
        | VideoLecturesAudioGetUnprocessableContent
      >({
        path: `/media/video-lectures/audio`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  polls = {
    /**
     * @name PollsCertificateList
     * @request GET:/polls/certificate
     */
    certificateList: (params: RequestParams = {}) =>
      this.request<
        Poll,
        CertificatePollGetForbidden | CertificatePollGetNotFound
      >({
        path: `/polls/certificate`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name PollsSignupList
     * @request GET:/polls/signup
     */
    signupList: (params: RequestParams = {}) =>
      this.request<Poll, SignupPollGetNotFound>({
        path: `/polls/signup`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name PollsSkillAssessmentStepGetByStep
     * @request GET:/polls/skill_assessment/step_{step}
     */
    skillAssessmentStepGetByStep: (step: number, params: RequestParams = {}) =>
      this.request<
        Poll,
        | SkillAssessmentPollGetForbidden
        | SkillAssessmentPollGetNotFound
        | SkillAssessmentPollGetUnprocessableEntity
      >({
        path: `/polls/skill_assessment/step_${step}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name PollsGetByPollId
     * @request GET:/polls/{poll_id}
     */
    getByPollId: (pollId: string, params: RequestParams = {}) =>
      this.request<Poll, PollGetNotFound>({
        path: `/polls/${pollId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name PollsResultsCreateByPollId
     * @request POST:/polls/{poll_id}/results
     */
    resultsCreateByPollId: (
      pollId: string,
      data?: PollResults,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        PollResultsPostNotFound | PollResultsPostUnprocessableEntity
      >({
        path: `/polls/${pollId}/results`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  progress = {
    /**
     * @name ProgressCurrentLectureList
     * @request GET:/progress/current_lecture
     */
    currentLectureList: (params: RequestParams = {}) =>
      this.request<CurrentLecture, any>({
        path: `/progress/current_lecture`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ProgressNextLectureList
     * @request GET:/progress/next_lecture
     */
    nextLectureList: (params: RequestParams = {}) =>
      this.request<NextLecture, NextLectureNotFound>({
        path: `/progress/next_lecture`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ProgressScoreList
     * @request GET:/progress/score
     */
    scoreList: (params: RequestParams = {}) =>
      this.request<Score, any>({
        path: `/progress/score`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  public = {
    /**
     * @name PublicCoursesList
     * @request GET:/public/courses
     */
    coursesList: (
      query: {
        /** @min 1 */
        page: number
        /**
         * @min 1
         * @max 500
         */
        size: number
      },
      params: RequestParams = {},
    ) =>
      this.request<PublicCoursesList, ContentListUnprocessableEntity>({
        path: `/public/courses`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2GroupsList
     * @request GET:/public/scim/v2/Groups
     */
    scimV2GroupsList: (
      query?: {
        /** @default 1 */
        startIndex?: number
        /** @default 25 */
        count?: number
        /** @default null */
        filter?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<
        UserGroupsListResponse,
        SCIMUserGroupsGetBadRequest | ErrorResponse
      >({
        path: `/public/scim/v2/Groups`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2GroupsCreate
     * @request POST:/public/scim/v2/Groups
     */
    scimV2GroupsCreate: (
      data?: UserGroupCreateUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<
        UserGroupDetails,
        SCIMUserGroupsPostBadRequest | ErrorResponse
      >({
        path: `/public/scim/v2/Groups`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2GroupsDeleteByUserGroupId
     * @request DELETE:/public/scim/v2/Groups/{user_group_id}
     */
    scimV2GroupsDeleteByUserGroupId: (
      userGroupId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | SCIMUserGroupDeleteBadRequest
        | SCIMUserGroupDeleteNotFound
        | ErrorResponse
      >({
        path: `/public/scim/v2/Groups/${userGroupId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2GroupsGetByUserGroupId
     * @request GET:/public/scim/v2/Groups/{user_group_id}
     */
    scimV2GroupsGetByUserGroupId: (
      userGroupId: string,
      params: RequestParams = {},
    ) =>
      this.request<UserGroupDetails, SCIMUserGroupGetNotFound>({
        path: `/public/scim/v2/Groups/${userGroupId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2GroupsPartialUpdateByUserGroupId
     * @request PATCH:/public/scim/v2/Groups/{user_group_id}
     */
    scimV2GroupsPartialUpdateByUserGroupId: (
      userGroupId: string,
      data?: UserGroupUpdatePatch,
      params: RequestParams = {},
    ) =>
      this.request<
        UserGroupDetails,
        | SCIMUserGroupPatchBadRequest
        | SCIMUserGroupPatchNotFound
        | ErrorResponse
      >({
        path: `/public/scim/v2/Groups/${userGroupId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2GroupsUpdateByUserGroupId
     * @request PUT:/public/scim/v2/Groups/{user_group_id}
     */
    scimV2GroupsUpdateByUserGroupId: (
      userGroupId: string,
      data?: UserGroupCreateUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<
        UserGroupDetails,
        SCIMUserGroupPutBadRequest | SCIMUserGroupPutNotFound | ErrorResponse
      >({
        path: `/public/scim/v2/Groups/${userGroupId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2ResourceTypesList
     * @request GET:/public/scim/v2/ResourceTypes
     */
    scimV2ResourceTypesList: (params: RequestParams = {}) =>
      this.request<ResourcesTypes, any>({
        path: `/public/scim/v2/ResourceTypes`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2ResourceTypesGetByResourceName
     * @request GET:/public/scim/v2/ResourceTypes/{resource_name}
     */
    scimV2ResourceTypesGetByResourceName: (
      resourceName: string,
      params: RequestParams = {},
    ) =>
      this.request<ResourceType, SCIMTypeGetNotFound>({
        path: `/public/scim/v2/ResourceTypes/${resourceName}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2SchemasList
     * @request GET:/public/scim/v2/Schemas
     */
    scimV2SchemasList: (params: RequestParams = {}) =>
      this.request<SchemasDetails, any>({
        path: `/public/scim/v2/Schemas`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2SchemasGetBySchemaId
     * @request GET:/public/scim/v2/Schemas/{schema_id}
     */
    scimV2SchemasGetBySchemaId: (
      schemaId: string,
      params: RequestParams = {},
    ) =>
      this.request<SchemaDetails, SCIMSchemaGetNotFound>({
        path: `/public/scim/v2/Schemas/${schemaId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2ServiceProviderConfigList
     * @request GET:/public/scim/v2/ServiceProviderConfig
     */
    scimV2ServiceProviderConfigList: (params: RequestParams = {}) =>
      this.request<ServiceProviderConfig, any>({
        path: `/public/scim/v2/ServiceProviderConfig`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2UsersList
     * @request GET:/public/scim/v2/Users
     */
    scimV2UsersList: (
      query?: {
        /** @default 1 */
        startIndex?: number
        /** @default 25 */
        count?: number
        /** @default null */
        filter?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<UsersListResponse, SCIMUsersGetBadRequest | ErrorResponse>({
        path: `/public/scim/v2/Users`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2UsersCreate
     * @request POST:/public/scim/v2/Users
     */
    scimV2UsersCreate: (data?: UserCreatePayload, params: RequestParams = {}) =>
      this.request<
        UserDetails,
        | SCIMUsersPostBadRequest
        | SCIMUsersPostNotFound
        | SCIMUsersPostInternalServerError
        | ErrorResponse
      >({
        path: `/public/scim/v2/Users`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2UsersLegacyList
     * @request GET:/public/scim/v2/Users-legacy
     */
    scimV2UsersLegacyList: (
      query?: {
        /** @default 1 */
        startIndex?: number
        /** @default 25 */
        count?: number
        /** @default null */
        filter?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<
        UsersListResponse,
        SCIMUsersLegacyGetBadRequest | ErrorResponse
      >({
        path: `/public/scim/v2/Users-legacy`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2UsersDeleteByGlobalId
     * @request DELETE:/public/scim/v2/Users/{global_id}
     */
    scimV2UsersDeleteByGlobalId: (
      globalId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | SCIMUserDeleteBadRequest
        | SCIMUserDeleteNotFound
        | SCIMUserDeleteInternalServerError
      >({
        path: `/public/scim/v2/Users/${globalId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2UsersGetByGlobalId
     * @request GET:/public/scim/v2/Users/{global_id}
     */
    scimV2UsersGetByGlobalId: (globalId: string, params: RequestParams = {}) =>
      this.request<UserDetails, SCIMUserGetNotFound>({
        path: `/public/scim/v2/Users/${globalId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2UsersPartialUpdateByGlobalId
     * @request PATCH:/public/scim/v2/Users/{global_id}
     */
    scimV2UsersPartialUpdateByGlobalId: (
      globalId: string,
      data?: UserUpdatePatch,
      params: RequestParams = {},
    ) =>
      this.request<
        UserDetails,
        | SCIMUserPatchBadRequest
        | SCIMUserPatchNotFound
        | SCIMUserPatchInternalServerError
        | ErrorResponse
      >({
        path: `/public/scim/v2/Users/${globalId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name PublicScimV2UsersUpdateByGlobalId
     * @request PUT:/public/scim/v2/Users/{global_id}
     */
    scimV2UsersUpdateByGlobalId: (
      globalId: string,
      data?: UserUpdatePut,
      params: RequestParams = {},
    ) =>
      this.request<
        UserDetails,
        | SCIMUserPutBadRequest
        | SCIMUserPutNotFound
        | SCIMUserPutInternalServerError
        | ErrorResponse
      >({
        path: `/public/scim/v2/Users/${globalId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  reminder = {
    /**
     * @name ReminderLearningAppointmentCreate
     * @request POST:/reminder/learning_appointment
     */
    learningAppointmentCreate: (
      data?: LearningAppointmentPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, Reminder>({
        path: `/reminder/learning_appointment`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
  schemas = {
    /**
     * @name SchemasGetBySchemaName
     * @request GET:/schemas/{schema_name}
     */
    getBySchemaName: (schemaName: string, params: RequestParams = {}) =>
      this.request<any, SchemaNotFound | InternalError>({
        path: `/schemas/${schemaName}`,
        method: 'GET',
        ...params,
      }),
  }
  scorm = {
    /**
     * @name ScormAuthCreate
     * @request POST:/scorm/auth
     */
    authCreate: (data?: ScormAuthPostRequest, params: RequestParams = {}) =>
      this.request<Tokens, Empty | ScormAuthPostUnprocessableContent>({
        path: `/scorm/auth`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormClientList
     * @request GET:/scorm/client
     */
    clientList: (params: RequestParams = {}) =>
      this.request<ScormClient, ScormClientGetUnprocessableContent>({
        path: `/scorm/client`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormInitCreate
     * @request POST:/scorm/init
     */
    initCreate: (data?: ScormInitPostRequest, params: RequestParams = {}) =>
      this.request<ScormInit, ScormInitPostUnprocessableContent>({
        path: `/scorm/init`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormPackageDelete
     * @request DELETE:/scorm/package
     */
    packageDelete: (params: RequestParams = {}) =>
      this.request<
        Empty,
        | ScormPackageDeleteForbidden
        | ScormPackageDeleteNotFound
        | ScormPackageDeleteInternalServerError
      >({
        path: `/scorm/package`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormPackageList
     * @request GET:/scorm/package
     */
    packageList: (params: RequestParams = {}) =>
      this.request<
        ScormPackage,
        ScormPackageGetForbidden | ScormPackageGetNotFound
      >({
        path: `/scorm/package`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormPackageCreate
     * @request POST:/scorm/package
     */
    packageCreate: (
      data?: ScormPackagePostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ScormPackageWithPayload,
        ScormPackagePostInternalServerError
      >({
        path: `/scorm/package`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormPackageUpdate
     * @request PUT:/scorm/package
     */
    packageUpdate: (
      data?: ScormPackagePutRequest,
      params: RequestParams = {},
    ) =>
      this.request<Empty, ScormPackagePutForbidden | ScormPackagePutNotFound>({
        path: `/scorm/package`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormPackageDeleteByPackageId
     * @request DELETE:/scorm/package/{package_id}
     */
    packageDeleteByPackageId: (packageId: string, params: RequestParams = {}) =>
      this.request<
        Empty,
        | ScormPackageDeleteForbidden
        | ScormPackageDeleteNotFound
        | ScormPackageDeleteInternalServerError
      >({
        path: `/scorm/package/${packageId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormPackageGetByPackageId
     * @request GET:/scorm/package/{package_id}
     */
    packageGetByPackageId: (packageId: string, params: RequestParams = {}) =>
      this.request<
        ScormPackage,
        ScormPackageGetForbidden | ScormPackageGetNotFound
      >({
        path: `/scorm/package/${packageId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormPackageCreateByPackageId
     * @request POST:/scorm/package/{package_id}
     */
    packageCreateByPackageId: (
      packageId: string,
      data?: ScormPackagePostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ScormPackageWithPayload,
        ScormPackagePostInternalServerError
      >({
        path: `/scorm/package/${packageId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormPackageUpdateByPackageId
     * @request PUT:/scorm/package/{package_id}
     */
    packageUpdateByPackageId: (
      packageId: string,
      data?: ScormPackagePutRequest,
      params: RequestParams = {},
    ) =>
      this.request<Empty, ScormPackagePutForbidden | ScormPackagePutNotFound>({
        path: `/scorm/package/${packageId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormPackagesList
     * @request GET:/scorm/packages
     */
    packagesList: (params: RequestParams = {}) =>
      this.request<ScormPackages, any>({
        path: `/scorm/packages`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormStateGetByPackageId
     * @request GET:/scorm/state/{package_id}
     */
    stateGetByPackageId: (packageId: string, params: RequestParams = {}) =>
      this.request<ScormState, ScormStateGetForbidden | ScormStateGetNotFound>({
        path: `/scorm/state/${packageId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormStateCreateByPackageId
     * @request POST:/scorm/state/{package_id}
     */
    stateCreateByPackageId: (
      packageId: string,
      data?: ScormStatePostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ScormState,
        | ScormStatePostForbidden
        | ScormStatePostNotFound
        | ScormStatePostInternalServerError
      >({
        path: `/scorm/state/${packageId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormUpdateCreate
     * @request POST:/scorm/update
     */
    updateCreate: (
      data?: ScormPackageLambdaPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<ScormPackage, ScormPackageLambdaPostNotFound>({
        path: `/scorm/update`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name ScormUserEmailUpdate
     * @request PUT:/scorm/user/email
     */
    userEmailUpdate: (data?: ScormEmailUpdatePut, params: RequestParams = {}) =>
      this.request<
        Empty,
        | ScormEmailPutForbidden
        | ScormEmailPutNotFound
        | ScormEmailPutUnprocessableContent
        | ScormEmailPutInternalServerError
      >({
        path: `/scorm/user/email`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  search = {
    /**
     * @name SearchList
     * @request GET:/search
     */
    list: (
      query?: {
        q?: string
        /** @default null */
        search_in?:
          | ('TTI' | 'TEX' | 'TAN' | 'TAC' | 'LTI' | 'LAN' | 'LAC')[]
          | null
        /** @default null */
        order?: 'relevance' | 'top_rated' | 'most_viewed' | 'most_recent' | null
        /** @default true */
        order_desc?: boolean
        /**
         * @min 0
         * @default 0
         */
        offset?: number
        /** @min 1 */
        limit?: number
        max_duration?: number
        min_duration?: number
        state?: 'all' | 'started' | 'completed' | 'not_started'
        /** @default null */
        format_or_type?:
          | ('mp_shorts' | 'mp_originals' | 'pace' | 'text_only')[]
          | null
        channels?: string[]
        creator?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchResultsSchemaV2, SearchV2GetUnprocessableContent>({
        path: `/search`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  signatureCourses = {
    /**
     * @name SignatureCoursesList
     * @request GET:/signature-courses
     */
    list: (params: RequestParams = {}) =>
      this.request<SignatureCourse, CourseGetNotFound>({
        path: `/signature-courses`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name SignatureCoursesAllAvailableList
     * @request GET:/signature-courses/all-available
     */
    allAvailableList: (params: RequestParams = {}) =>
      this.request<UserSignatureCourses, any>({
        path: `/signature-courses/all-available`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name SignatureCoursesGetBySlug
     * @request GET:/signature-courses/{slug}
     */
    getBySlug: (slug: string, params: RequestParams = {}) =>
      this.request<SignatureCourse, CourseGetNotFound>({
        path: `/signature-courses/${slug}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  skills = {
    /**
     * @name SkillsList
     * @request GET:/skills
     */
    list: (params: RequestParams = {}) =>
      this.request<SkillList, any>({
        path: `/skills`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name SkillsAssessmentDelete
     * @request DELETE:/skills/assessment
     */
    assessmentDelete: (params: RequestParams = {}) =>
      this.request<any, AssessmentDeleteInternalServerError>({
        path: `/skills/assessment`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @name SkillsAssessmentList
     * @request GET:/skills/assessment
     */
    assessmentList: (params: RequestParams = {}) =>
      this.request<AssessmentInfo, any>({
        path: `/skills/assessment`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name SkillsCurrentList
     * @request GET:/skills/current
     */
    currentList: (params: RequestParams = {}) =>
      this.request<CurrentSkill, CurrentSkillGetNotFound>({
        path: `/skills/current`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name SkillsCurrentUpdate
     * @request PUT:/skills/current
     */
    currentUpdate: (
      data?: CurrentSkillPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, CurrentSkillPutNotFound>({
        path: `/skills/current`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @name SkillsGetBySlug
     * @request GET:/skills/{slug}
     */
    getBySlug: (slug: string, params: RequestParams = {}) =>
      this.request<BaseSkill, SkillGetNotFound>({
        path: `/skills/${slug}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name SkillsProgressGetBySlug
     * @request GET:/skills/{slug}/progress
     */
    progressGetBySlug: (slug: string, params: RequestParams = {}) =>
      this.request<SkillProgress, SkillProgressGetNotFound>({
        path: `/skills/${slug}/progress`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name SkillsTopicsGetBySlug
     * @request GET:/skills/{slug}/topics
     */
    topicsGetBySlug: (slug: string, params: RequestParams = {}) =>
      this.request<SkillTopics, SkillTopicsGetNotFound>({
        path: `/skills/${slug}/topics`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  status = {
    /**
     * @name StatusList
     * @request GET:/status
     */
    list: (params: RequestParams = {}) =>
      this.request<Status, any>({
        path: `/status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  topics = {
    /**
     * @name TopicsGetBySlug
     * @request GET:/topics/{slug}
     */
    getBySlug: (slug: string, params: RequestParams = {}) =>
      this.request<Topic, TopicGetForbidden | TopicGetNotFound>({
        path: `/topics/${slug}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  users = {
    /**
     * @name UsersDelete
     * @request DELETE:/users
     */
    delete: (data?: UsersBulkDeleteRequest, params: RequestParams = {}) =>
      this.request<UsersBulkDeleteResult, UsersDeleteForbidden>({
        path: `/users`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersList
     * @request GET:/users
     */
    list: (
      query?: {
        /** @min 0 */
        page?: number
        /** @min 1 */
        size?: number
        query?: string
        email?: string
        first_name?: string
        last_name?: string
        license_provider_email?: string
        sort_by?:
          | 'status'
          | 'invitation_date'
          | 'department'
          | 'email'
          | 'first_name'
          | 'last_name'
          | 'license_provider_email'
          | 'role'
          | 'available_licenses'
          | 'total_licenses'
        order?: 'asc' | 'desc'
        roles?: (
          | 'admin'
          | 'owner'
          | 'company_administrator'
          | 'public_api_client'
          | 'manager'
          | 'content_creator'
          | 'student'
        )[]
        /** @format date */
        from_invited_at?: string
        /** @format date */
        to_invited_at?: string
        states?: ('active' | 'pending' | 'deactivated')[] | null
        /** @format uuid */
        department_id?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<UserList, UsersGetForbidden | UsersGetUnprocessableContent>({
        path: `/users`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersCreate
     * @request POST:/users
     */
    create: (data?: UsersPost, params: RequestParams = {}) =>
      this.request<
        Empty,
        | UsersPostLicensesLimitExceeded
        | UsersPostForbidden
        | UsersPostCompanyNotFound
        | UsersPostEmailIsNotAllowedInCompany
        | UsersPostIamError
      >({
        path: `/users`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersBatchOperationsDeactivateCreate
     * @request POST:/users/batch-operations/deactivate
     */
    batchOperationsDeactivateCreate: (params: RequestParams = {}) =>
      this.request<
        BatchOperationFileUploaded,
        | BatchOperationsUserDeactivationPostForbidden
        | BatchOperationsUserDeactivationPostContentTooLarge
        | BatchOperationsUserDeactivationPostUnprocessableContent
      >({
        path: `/users/batch-operations/deactivate`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersBatchOperationsDepartmentsCreate
     * @request POST:/users/batch-operations/departments
     */
    batchOperationsDepartmentsCreate: (params: RequestParams = {}) =>
      this.request<
        BatchOperationFileUploaded,
        | BatchOperationsDepartmentAssignmentPostForbidden
        | BatchOperationsDepartmentAssignmentPostContentTooLarge
        | BatchOperationsDepartmentAssignmentPostUnprocessableContent
      >({
        path: `/users/batch-operations/departments`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersBatchOperationsEditCreate
     * @request POST:/users/batch-operations/edit
     */
    batchOperationsEditCreate: (params: RequestParams = {}) =>
      this.request<
        BatchOperationFileUploaded,
        | BatchOperationsUserEditPostForbidden
        | BatchOperationsUserEditPostContentTooLarge
        | BatchOperationsUserEditPostUnprocessableContent
      >({
        path: `/users/batch-operations/edit`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersBatchOperationsLicenseProviderCreate
     * @request POST:/users/batch-operations/license-provider
     */
    batchOperationsLicenseProviderCreate: (params: RequestParams = {}) =>
      this.request<
        BatchOperationFileUploaded,
        | BatchOperationsLicenseProviderChangePostForbidden
        | BatchOperationsLicenseProviderChangePostContentTooLarge
        | BatchOperationsLicenseProviderChangePostUnprocessableContent
      >({
        path: `/users/batch-operations/license-provider`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersBatchOperationsReactivateCreate
     * @request POST:/users/batch-operations/reactivate
     */
    batchOperationsReactivateCreate: (params: RequestParams = {}) =>
      this.request<
        BatchOperationFileUploaded,
        | BatchOperationsUserReactivationPostForbidden
        | BatchOperationsUserReactivationPostContentTooLarge
        | BatchOperationsUserReactivationPostUnprocessableContent
      >({
        path: `/users/batch-operations/reactivate`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersCurrentList
     * @request GET:/users/current
     */
    currentList: (params: RequestParams = {}) =>
      this.request<CurrentUser, any>({
        path: `/users/current`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersCurrentUpdate
     * @request PUT:/users/current
     */
    currentUpdate: (data?: CurrentUserPut, params: RequestParams = {}) =>
      this.request<
        Empty,
        CurrentUserPutBadRequest | CurrentUserPutUnprocessableContent
      >({
        path: `/users/current`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersCurrentAvatarUpdate
     * @request PUT:/users/current/avatar
     */
    currentAvatarUpdate: (
      data?: CurrentUserAvatarPut,
      params: RequestParams = {},
    ) =>
      this.request<Empty, CurrentUserAvatarPutInternalServerError>({
        path: `/users/current/avatar`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersCurrentExtraDataUpdate
     * @request PUT:/users/current/extra-data
     */
    currentExtraDataUpdate: (
      data?: CurrentUserExtraDataPut,
      params: RequestParams = {},
    ) =>
      this.request<Empty, any>({
        path: `/users/current/extra-data`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersCurrentStateList
     * @request GET:/users/current/state
     */
    currentStateList: (params: RequestParams = {}) =>
      this.request<CurrentUserStateGet, any>({
        path: `/users/current/state`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersDeactivateCreate
     * @request POST:/users/deactivate
     */
    deactivateCreate: (
      data?: UsersBulkDeactivationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersBulkDeactivationResult, UsersDeactivationPostForbidden>(
        {
          path: `/users/deactivate`,
          method: 'POST',
          body: data,
          type: ContentType.Json,
          format: 'json',
          ...params,
        },
      ),

    /**
     * @name UsersE2ENoEmailUsersCreate
     * @request POST:/users/e2e/no-email-users
     */
    e2ENoEmailUsersCreate: (
      data?: E2ENoEmailUsersPost,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | E2ENoEmailUsersPostForbidden
        | E2ENoEmailUsersPostNotFound
        | E2ENoEmailUsersPostConflict
        | E2ENoEmailUsersPostUnprocessableContent
      >({
        path: `/users/e2e/no-email-users`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersE2EResetProgressCreate
     * @request POST:/users/e2e/reset-progress
     */
    e2EResetProgressCreate: (
      data?: E2EResetUsersProgressPost,
      params: RequestParams = {},
    ) =>
      this.request<Empty, any>({
        path: `/users/e2e/reset-progress`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersExportsCreate
     * @request POST:/users/exports
     */
    exportsCreate: (params: RequestParams = {}) =>
      this.request<any, UsersExportPostForbidden>({
        path: `/users/exports`,
        method: 'POST',
        ...params,
      }),

    /**
     * @name UsersGroupsDelete
     * @request DELETE:/users/groups
     */
    groupsDelete: (
      data?: UserGroupsBulkDeleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<UserGroupsBulkDeleteResult, UserGroupsDeleteForbidden>({
        path: `/users/groups`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsList
     * @request GET:/users/groups
     */
    groupsList: (
      query?: {
        /** @min 0 */
        page?: number
        /** @min 1 */
        size?: number
        sort_by?: 'user_group_name' | 'visibility' | 'members' | 'creation_date'
        sort_order?: 'asc' | 'desc'
        name?: string
        /** @format uuid */
        creator_id?: string
        /** @format date */
        from_created_at?: string
        /** @format date */
        to_created_at?: string
        private?: boolean
        members_ids?: string[]
        exclude_groups_with_members_ids?: string[]
      },
      params: RequestParams = {},
    ) =>
      this.request<UserGroupList, Empty>({
        path: `/users/groups`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsCreate
     * @request POST:/users/groups
     */
    groupsCreate: (data?: UserGroupsPostRequest, params: RequestParams = {}) =>
      this.request<
        UserGroupCreated,
        | UserGroupsPostBadRequest
        | UserGroupsPostForbidden
        | UserGroupsPostNotFound
        | UserGroupsPostUnprocessableContent
      >({
        path: `/users/groups`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsBatchOperationsAssignCreate
     * @request POST:/users/groups/batch-operations/assign
     */
    groupsBatchOperationsAssignCreate: (params: RequestParams = {}) =>
      this.request<
        BatchOperationFileUploaded,
        | BatchOperationsUserGroupAssignmentPostForbidden
        | BatchOperationsUserGroupAssignmentPostContentTooLarge
        | BatchOperationsUserGroupAssignmentPostUnprocessableContent
      >({
        path: `/users/groups/batch-operations/assign`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsMembersDelete
     * @request DELETE:/users/groups/members
     */
    groupsMembersDelete: (
      data?: UserGroupMembersBulkDeleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        UserGroupMembersBulkResult,
        | UserGroupMembersBulkDeleteForbidden
        | UserGroupMembersBulkDeleteNotFound
        | UserGroupMembersBulkDeleteUnprocessableContent
      >({
        path: `/users/groups/members`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsMembersCreate
     * @request POST:/users/groups/members
     */
    groupsMembersCreate: (
      data?: UserGroupMembersBulkPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        UserGroupMembersBulkResult,
        | UserGroupMembersBulkPostForbidden
        | UserGroupMembersBulkPostNotFound
        | UserGroupMembersBulkPostUnprocessableContent
      >({
        path: `/users/groups/members`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsDeleteByUserGroupId
     * @request DELETE:/users/groups/{user_group_id}
     */
    groupsDeleteByUserGroupId: (
      userGroupId: string,
      params: RequestParams = {},
    ) =>
      this.request<Empty, Empty>({
        path: `/users/groups/${userGroupId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsUpdateByUserGroupId
     * @request PUT:/users/groups/{user_group_id}
     */
    groupsUpdateByUserGroupId: (
      userGroupId: string,
      data?: UserGroupPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<Empty, Empty | NameTooLong>({
        path: `/users/groups/${userGroupId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsCandidatesGetByUserGroupId
     * @request GET:/users/groups/{user_group_id}/candidates
     */
    groupsCandidatesGetByUserGroupId: (
      userGroupId: string,
      query?: {
        /**
         * @min 0
         * @default 0
         */
        offset?: number
        /**
         * @min 2
         * @default 25
         */
        size?: number
        query?: string
        states?: ('active' | 'pending' | 'deactivated')[]
        /** @format uuid */
        department_id?: string
        /** @format uuid */
        license_provider_id?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<
        UserGroupCandidates,
        | UserGroupCandidatesGetForbidden
        | UserGroupCandidatesGetNotFound
        | UserGroupCandidatesGetUnprocessableContent
      >({
        path: `/users/groups/${userGroupId}/candidates`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsMembersGetByUserGroupId
     * @request GET:/users/groups/{user_group_id}/members
     */
    groupsMembersGetByUserGroupId: (
      userGroupId: string,
      query?: {
        query?: string
        states?: ('active' | 'pending' | 'deactivated')[]
        /** @format uuid */
        department_id?: string
        /** @format uuid */
        license_provider_id?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<
        UserGroupMemberList,
        UserGroupMembersGetForbidden | UserGroupMembersGetUnprocessableContent
      >({
        path: `/users/groups/${userGroupId}/members`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsMembersCreateByUserGroupId
     * @request POST:/users/groups/{user_group_id}/members
     */
    groupsMembersCreateByUserGroupId: (
      userGroupId: string,
      data?: UserGroupMembersPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<Empty, Empty>({
        path: `/users/groups/${userGroupId}/members`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsMembersExportsCreateByUserGroupId
     * @request POST:/users/groups/{user_group_id}/members/exports
     */
    groupsMembersExportsCreateByUserGroupId: (
      userGroupId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        UserGroupMembersExportPostForbidden | UserGroupMembersExportPostNotFound
      >({
        path: `/users/groups/${userGroupId}/members/exports`,
        method: 'POST',
        ...params,
      }),

    /**
     * @name UsersGroupsMembersDeleteByUserId
     * @request DELETE:/users/groups/{user_group_id}/members/{user_id}
     */
    groupsMembersDeleteByUserId: (
      userGroupId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<Empty, Empty>({
        path: `/users/groups/${userGroupId}/members/${userId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsPrivacyUpdateByUserGroupId
     * @request PUT:/users/groups/{user_group_id}/privacy
     */
    groupsPrivacyUpdateByUserGroupId: (
      userGroupId: string,
      data?: UserGroupPrivacyPutRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        UserGroupPrivacyPutBadRequest | UserGroupPrivacyPutForbidden
      >({
        path: `/users/groups/${userGroupId}/privacy`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersImportsCreate
     * @request POST:/users/imports
     */
    importsCreate: (params: RequestParams = {}) =>
      this.request<
        BatchOperationFileUploaded,
        | UsersImportPostForbidden
        | UsersImportPostContentTooLarge
        | UsersImportPostUnprocessableContent
      >({
        path: `/users/imports`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersMailCreate
     * @request POST:/users/mail
     */
    mailCreate: (
      data?: UsersBulkInviteEmailRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersBulkInviteEmailResult, UsersInviteEmailPostForbidden>({
        path: `/users/mail`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersReactivateCreate
     * @request POST:/users/reactivate
     */
    reactivateCreate: (
      data?: UsersBulkReactivationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersBulkReactivationResult, UsersReactivationPostForbidden>(
        {
          path: `/users/reactivate`,
          method: 'POST',
          body: data,
          type: ContentType.Json,
          format: 'json',
          ...params,
        },
      ),

    /**
     * @name UsersSearchList
     * @request GET:/users/search
     */
    searchList: (
      query?: {
        /**
         * @min 0
         * @default 0
         */
        offset?: number
        /**
         * @min 2
         * @default 25
         */
        size?: number
        /** @default null */
        query?: string | null
        roles?: (
          | 'admin'
          | 'owner'
          | 'company_administrator'
          | 'public_api_client'
          | 'manager'
          | 'content_creator'
          | 'student'
        )[]
      },
      params: RequestParams = {},
    ) =>
      this.request<
        UserSearch,
        UserSearchGetForbidden | UserSearchGetUnprocessableContent
      >({
        path: `/users/search`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersTransferLicensesCreate
     * @request POST:/users/transfer-licenses
     */
    transferLicensesCreate: (
      data?: TransferLicenses,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | TransferLicensesInsufficientNumberOfLicensesToTransfer
        | TransferLicensesForbidden
        | TransferLicensesUserNotFound
        | TransferLicensesInvalidNumberOfLicenses
      >({
        path: `/users/transfer-licenses`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersUserIdentityDeleteByKeycloakId
     * @request DELETE:/users/user-identity/{keycloak_id}
     */
    userIdentityDeleteByKeycloakId: (
      keycloakId: string,
      params: RequestParams = {},
    ) =>
      this.request<Empty, any>({
        path: `/users/user-identity/${keycloakId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersUserIdentityCreateByKeycloakId
     * @request POST:/users/user-identity/{keycloak_id}
     */
    userIdentityCreateByKeycloakId: (
      keycloakId: string,
      data?: UserIdentityPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<Empty, any>({
        path: `/users/user-identity/${keycloakId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersSignupDetailsGetByInviteToken
     * @request GET:/users/{invite_token}/signup-details
     */
    signupDetailsGetByInviteToken: (
      inviteToken: string,
      params: RequestParams = {},
    ) =>
      this.request<
        UserSignupDetails,
        | UserSignupDetailsGetBadRequest
        | UserSignupDetailsGetNotFound
        | UserSignupDetailsGetGone
      >({
        path: `/users/${inviteToken}/signup-details`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersDeleteByUserId
     * @request DELETE:/users/{user_id}
     */
    deleteByUserId: (userId: string, params: RequestParams = {}) =>
      this.request<
        Empty,
        | UserDeleteForbidden
        | UserDeleteNotFound
        | UserDeleteUnprocessableContent
      >({
        path: `/users/${userId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGetByUserId
     * @request GET:/users/{user_id}
     */
    getByUserId: (userId: string, params: RequestParams = {}) =>
      this.request<User, UserGetUserNotFound>({
        path: `/users/${userId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersUpdateByUserId
     * @request PUT:/users/{user_id}
     */
    updateByUserId: (
      userId: string,
      data?: UserPut,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | UserPutNoEmailUserDoesNotHaveEmail
        | UserPutForbidden
        | UserPutUserNotFound
        | UserPutEmailAlreadyInUse
      >({
        path: `/users/${userId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersDeactivateCreateByUserId
     * @request POST:/users/{user_id}/deactivate
     */
    deactivateCreateByUserId: (userId: string, params: RequestParams = {}) =>
      this.request<
        Empty,
        | UserDeactivationPostBadRequest
        | UserDeactivationPostForbidden
        | UserDeactivationPostNotFound
        | UserDeactivationPostInternalServerError
      >({
        path: `/users/${userId}/deactivate`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersDepartmentsDeleteByUserId
     * @request DELETE:/users/{user_id}/departments
     */
    departmentsDeleteByUserId: (
      userId: string,
      data?: UserDepartmentsDelete,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        UserDepartmentsDeleteForbidden | UserDepartmentsDeleteNotFound
      >({
        path: `/users/${userId}/departments`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersDepartmentsUpdateByUserId
     * @request PUT:/users/{user_id}/departments
     */
    departmentsUpdateByUserId: (
      userId: string,
      data?: UserDepartmentsPut,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        UserDepartmentsPutForbidden | UserDepartmentsPutNotFound
      >({
        path: `/users/${userId}/departments`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsDeleteByUserId
     * @request DELETE:/users/{user_id}/groups
     */
    groupsDeleteByUserId: (
      userId: string,
      data?: UserAssignedGroupsDeleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        UserAssignedGroupsDeleteResult,
        UserAssignedGroupsDeleteForbidden | UserAssignedGroupsDeleteNotFound
      >({
        path: `/users/${userId}/groups`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsGetByUserId
     * @request GET:/users/{user_id}/groups
     */
    groupsGetByUserId: (userId: string, params: RequestParams = {}) =>
      this.request<
        AssignedUserGroups,
        UserAssignedGroupsGetForbidden | UserAssignedGroupsGetNotFound
      >({
        path: `/users/${userId}/groups`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersGroupsCreateByUserId
     * @request POST:/users/{user_id}/groups
     */
    groupsCreateByUserId: (
      userId: string,
      data?: UserAssignedGroupsPostRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        UserAssignedGroupsResult,
        UserAssignedGroupsPostForbidden | UserAssignedGroupsPostNotFound
      >({
        path: `/users/${userId}/groups`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersInviteLinkCreateByUserId
     * @request POST:/users/{user_id}/invite-link
     */
    inviteLinkCreateByUserId: (userId: string, params: RequestParams = {}) =>
      this.request<
        UserInviteLink,
        | UserInviteLinkPostBadRequest
        | UserInviteLinkPostForbidden
        | UserInviteLinkPostNotFound
        | UserInviteLinkPostConflict
      >({
        path: `/users/${userId}/invite-link`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersLicenseProviderUpdateByUserId
     * @request PUT:/users/{user_id}/license-provider
     */
    licenseProviderUpdateByUserId: (
      userId: string,
      data?: LicenseProviderPut,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | LicenseProviderPutBadRequest
        | LicenseProviderPutForbidden
        | LicenseProviderPutNotFound
      >({
        path: `/users/${userId}/license-provider`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersMailCreateByUserId
     * @request POST:/users/{user_id}/mail
     */
    mailCreateByUserId: (userId: string, params: RequestParams = {}) =>
      this.request<
        Empty,
        | UserInviteEmailPostBadRequest
        | UserInviteEmailPostForbidden
        | UserInviteEmailPostNotFound
      >({
        path: `/users/${userId}/mail`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersReactivateCreateByUserId
     * @request POST:/users/{user_id}/reactivate
     */
    reactivateCreateByUserId: (userId: string, params: RequestParams = {}) =>
      this.request<
        Empty,
        | UserReactivationPostBadRequest
        | UserReactivationPostForbidden
        | UserReactivationPostNotFound
        | UserReactivationPostInternalServerError
      >({
        path: `/users/${userId}/reactivate`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersResetPasswordUpdateByUserId
     * @request PUT:/users/{user_id}/reset-password
     */
    resetPasswordUpdateByUserId: (userId: string, params: RequestParams = {}) =>
      this.request<
        UserPasswordReset,
        | UserPasswordResetPutForbidden
        | UserPasswordResetPutNotFound
        | UserPasswordResetPutConflict
      >({
        path: `/users/${userId}/reset-password`,
        method: 'PUT',
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersRolesDeleteByUserId
     * @request DELETE:/users/{user_id}/roles
     */
    rolesDeleteByUserId: (
      userId: string,
      data?: UserRolesDelete,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        UserRolesDeleteForbidden | UserRolesDeleteUserNotFound
      >({
        path: `/users/${userId}/roles`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersRolesCreateByUserId
     * @request POST:/users/{user_id}/roles
     */
    rolesCreateByUserId: (
      userId: string,
      data?: UserRolesPost,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        | UserRolesPostForbidden
        | UserRolesPostUserNotFound
        | UserRolesPostRoleAlreadyAssigned
      >({
        path: `/users/${userId}/roles`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersRolesUpdateByUserId
     * @request PUT:/users/{user_id}/roles
     */
    rolesUpdateByUserId: (
      userId: string,
      data?: UserRolesPut,
      params: RequestParams = {},
    ) =>
      this.request<Empty, UserRolesPutForbidden | UserRolesPutUserNotFound>({
        path: `/users/${userId}/roles`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @name UsersSettingsPartialUpdateByUserId
     * @request PATCH:/users/{user_id}/settings
     */
    settingsPartialUpdateByUserId: (
      userId: string,
      data?: UserSettingsPatch,
      params: RequestParams = {},
    ) =>
      this.request<
        Empty,
        UserSettingsPatchForbidden | UserSettingsPatchNotFound
      >({
        path: `/users/${userId}/settings`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  xapi = {
    /**
     * @name XapiStatementsCreate
     * @request POST:/xapi/statements
     */
    statementsCreate: (
      data?: XAPIStatementsResourcePost,
      params: RequestParams = {},
    ) =>
      this.request<Empty, XAPIStatementsPostBadRequest>({
        path: `/xapi/statements`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
}
